import {Emoji} from './@type';

export const EmojiIconConfig: Emoji[] = [

    {
        symbol: '😀',
        name: 'emoji-1',
        keyword: 'grinning grinning face'
    },
    {
        symbol: '😃',
        name: 'emoji-2',
        keyword: 'smiley smiling face with open mouth'
    },
    {
        symbol: '😄',
        name: 'emoji-3',
        keyword: 'smile smiling face with open mouth and smiling eyes'
    },
    {
        symbol: '😁',
        name: 'emoji-4',
        keyword: 'grin grinning face with smiling eyes'
    },
    {
        symbol: '😆',
        name: 'emoji-5',
        keyword: 'laughing satisfied smiling face with open mouth and tightly-closed eyes'
    },
    {
        symbol: '😅',
        name: 'emoji-6',
        keyword: 'sweat smile smiling face with open mouth and cold sweat'
    },
    {
        symbol: '🤣',
        name: 'emoji-7',
        keyword: 'rolling on the floor laughing'
    },
    {
        symbol: '😂',
        name: 'emoji-8',
        keyword: 'joy face with tears of joy'
    },
    {
        symbol: '🙂',
        name: 'emoji-9',
        keyword: 'slightly smiling face'
    },
    {
        symbol: '🙃',
        name: 'emoji-10',
        keyword: 'upside-down face upside down face'
    },
    {
        symbol: '🫠',
        name: 'emoji-11',
        keyword: 'melting face'
    },
    {
        symbol: '😉',
        name: 'emoji-12',
        keyword: 'wink winking face'
    },
    {
        symbol: '😊',
        name: 'emoji-13',
        keyword: 'blush smiling face with smiling eyes'
    },
    {
        symbol: '😇',
        name: 'emoji-14',
        keyword: 'innocent smiling face with halo'
    },
    {
        symbol: '🥰',
        name: 'emoji-15',
        keyword: 'smiling face with 3 hearts smiling face with smiling eyes and three hearts'
    },
    {
        symbol: '😍',
        name: 'emoji-16',
        keyword: 'heart eyes smiling face with heart-shaped eyes'
    },
    {
        symbol: '🤩',
        name: 'emoji-17',
        keyword: 'star-struck grinning face with star eyes'
    },
    {
        symbol: '😘',
        name: 'emoji-18',
        keyword: 'kissing heart face throwing a kiss'
    },
    {
        symbol: '😗',
        name: 'emoji-19',
        keyword: 'kissing kissing face'
    },
    {
        symbol: '☺️',
        name: 'emoji-20',
        keyword: 'relaxed white smiling face'
    },
    {
        symbol: '😚',
        name: 'emoji-21',
        keyword: 'kissing closed eyes kissing face with closed eyes'
    },
    {
        symbol: '😙',
        name: 'emoji-22',
        keyword: 'kissing smiling eyes kissing face with smiling eyes'
    },
    {
        symbol: '🥲',
        name: 'emoji-23',
        keyword: 'smiling face with tear'
    },
    {
        symbol: '😋',
        name: 'emoji-24',
        keyword: 'yum face savouring delicious food'
    },
    {
        symbol: '😛',
        name: 'emoji-25',
        keyword: 'stuck out tongue face with stuck-out tongue'
    },
    {
        symbol: '😜',
        name: 'emoji-26',
        keyword: 'stuck out tongue winking eye face with stuck-out tongue and winking eye'
    },
    {
        symbol: '🤪',
        name: 'emoji-27',
        keyword: 'zany face grinning face with one large and one small eye'
    },
    {
        symbol: '😝',
        name: 'emoji-28',
        keyword: 'stuck out tongue closed eyes face with stuck-out tongue and tightly-closed eyes'
    },
    {
        symbol: '🤑',
        name: 'emoji-29',
        keyword: 'money-mouth face money mouth face'
    },
    {
        symbol: '🤗',
        name: 'emoji-30',
        keyword: 'hugging face'
    },
    {
        symbol: '🤭',
        name: 'emoji-31',
        keyword: 'face with hand over mouth smiling face with smiling eyes and hand covering mouth'
    },
    {
        symbol: '🫢',
        name: 'emoji-32',
        keyword: 'face with open eyes and hand over mouth'
    },
    {
        symbol: '🫣',
        name: 'emoji-33',
        keyword: 'face with peeking eye'
    },
    {
        symbol: '🤫',
        name: 'emoji-34',
        keyword: 'shushing face face with finger covering closed lips'
    },
    {
        symbol: '🤔',
        name: 'emoji-35',
        keyword: 'thinking face'
    },
    {
        symbol: '🫡',
        name: 'emoji-36',
        keyword: 'saluting face'
    },
    {
        symbol: '🤐',
        name: 'emoji-37',
        keyword: 'zipper-mouth face zipper mouth face'
    },
    {
        symbol: '🤨',
        name: 'emoji-38',
        keyword: 'face with raised eyebrow face with one eyebrow raised'
    },
    {
        symbol: '😐',
        name: 'emoji-39',
        keyword: 'neutral face'
    },
    {
        symbol: '😑',
        name: 'emoji-40',
        keyword: 'expressionless expressionless face'
    },
    {
        symbol: '😶',
        name: 'emoji-41',
        keyword: 'no mouth face without mouth'
    },
    {
        symbol: '🫥',
        name: 'emoji-42',
        keyword: 'dotted line face'
    },
    {
        symbol: '😶‍🌫️',
        name: 'emoji-43',
        keyword: 'face in clouds'
    },
    {
        symbol: '😏',
        name: 'emoji-44',
        keyword: 'smirk smirking face'
    },
    {
        symbol: '😒',
        name: 'emoji-45',
        keyword: 'unamused unamused face'
    },
    {
        symbol: '🙄',
        name: 'emoji-46',
        keyword: 'face with rolling eyes'
    },
    {
        symbol: '😬',
        name: 'emoji-47',
        keyword: 'grimacing grimacing face'
    },
    {
        symbol: '😮‍💨',
        name: 'emoji-48',
        keyword: 'face exhaling'
    },
    {
        symbol: '🤥',
        name: 'emoji-49',
        keyword: 'lying face'
    },
    {
        symbol: '😌',
        name: 'emoji-50',
        keyword: 'relieved relieved face'
    },
    {
        symbol: '😔',
        name: 'emoji-51',
        keyword: 'pensive pensive face'
    },
    {
        symbol: '😪',
        name: 'emoji-52',
        keyword: 'sleepy sleepy face'
    },
    {
        symbol: '🤤',
        name: 'emoji-53',
        keyword: 'drooling face'
    },
    {
        symbol: '😴',
        name: 'emoji-54',
        keyword: 'sleeping sleeping face'
    },
    {
        symbol: '😷',
        name: 'emoji-55',
        keyword: 'mask face with medical mask'
    },
    {
        symbol: '🤒',
        name: 'emoji-56',
        keyword: 'face with thermometer'
    },
    {
        symbol: '🤕',
        name: 'emoji-57',
        keyword: 'face with head-bandage face with head bandage'
    },
    {
        symbol: '🤢',
        name: 'emoji-58',
        keyword: 'nauseated face'
    },
    {
        symbol: '🤮',
        name: 'emoji-59',
        keyword: 'face vomiting face with open mouth vomiting'
    },
    {
        symbol: '🤧',
        name: 'emoji-60',
        keyword: 'sneezing face'
    },
    {
        symbol: '🥵',
        name: 'emoji-61',
        keyword: 'hot face overheated face'
    },
    {
        symbol: '🥶',
        name: 'emoji-62',
        keyword: 'cold face freezing face'
    },
    {
        symbol: '🥴',
        name: 'emoji-63',
        keyword: 'woozy face face with uneven eyes and wavy mouth'
    },
    {
        symbol: '😵',
        name: 'emoji-64',
        keyword: 'dizzy face'
    },
    {
        symbol: '😵‍💫',
        name: 'emoji-65',
        keyword: 'face with spiral eyes'
    },
    {
        symbol: '🤯',
        name: 'emoji-66',
        keyword: 'exploding head shocked face with exploding head'
    },
    {
        symbol: '🤠',
        name: 'emoji-67',
        keyword: 'face with cowboy hat'
    },
    {
        symbol: '🥳',
        name: 'emoji-68',
        keyword: 'partying face face with party horn and party hat'
    },
    {
        symbol: '🥸',
        name: 'emoji-69',
        keyword: 'disguised face'
    },
    {
        symbol: '😎',
        name: 'emoji-70',
        keyword: 'sunglasses smiling face with sunglasses'
    },
    {
        symbol: '🤓',
        name: 'emoji-71',
        keyword: 'nerd face'
    },
    {
        symbol: '🧐',
        name: 'emoji-72',
        keyword: 'face with monocle'
    },
    {
        symbol: '😕',
        name: 'emoji-73',
        keyword: 'confused confused face'
    },
    {
        symbol: '🫤',
        name: 'emoji-74',
        keyword: 'face with diagonal mouth'
    },
    {
        symbol: '😟',
        name: 'emoji-75',
        keyword: 'worried worried face'
    },
    {
        symbol: '🙁',
        name: 'emoji-76',
        keyword: 'slightly frowning face'
    },
    {
        symbol: '☹️',
        name: 'emoji-77',
        keyword: 'frowning face white frowning face'
    },
    {
        symbol: '😮',
        name: 'emoji-78',
        keyword: 'open mouth face with open mouth'
    },
    {
        symbol: '😯',
        name: 'emoji-79',
        keyword: 'hushed hushed face'
    },
    {
        symbol: '😲',
        name: 'emoji-80',
        keyword: 'astonished astonished face'
    },
    {
        symbol: '😳',
        name: 'emoji-81',
        keyword: 'flushed flushed face'
    },
    {
        symbol: '🥺',
        name: 'emoji-82',
        keyword: 'pleading face face with pleading eyes'
    },
    {
        symbol: '🥹',
        name: 'emoji-83',
        keyword: 'face holding back tears'
    },
    {
        symbol: '😦',
        name: 'emoji-84',
        keyword: 'frowning frowning face with open mouth'
    },
    {
        symbol: '😧',
        name: 'emoji-85',
        keyword: 'anguished anguished face'
    },
    {
        symbol: '😨',
        name: 'emoji-86',
        keyword: 'fearful fearful face'
    },
    {
        symbol: '😰',
        name: 'emoji-87',
        keyword: 'cold sweat face with open mouth and cold sweat'
    },
    {
        symbol: '😥',
        name: 'emoji-88',
        keyword: 'disappointed relieved disappointed but relieved face'
    },
    {
        symbol: '😢',
        name: 'emoji-89',
        keyword: 'cry crying face'
    },
    {
        symbol: '😭',
        name: 'emoji-90',
        keyword: 'sob loudly crying face'
    },
    {
        symbol: '😱',
        name: 'emoji-91',
        keyword: 'scream face screaming in fear'
    },
    {
        symbol: '😖',
        name: 'emoji-92',
        keyword: 'confounded confounded face'
    },
    {
        symbol: '😣',
        name: 'emoji-93',
        keyword: 'persevere persevering face'
    },
    {
        symbol: '😞',
        name: 'emoji-94',
        keyword: 'disappointed disappointed face'
    },
    {
        symbol: '😓',
        name: 'emoji-95',
        keyword: 'sweat face with cold sweat'
    },
    {
        symbol: '😩',
        name: 'emoji-96',
        keyword: 'weary weary face'
    },
    {
        symbol: '😫',
        name: 'emoji-97',
        keyword: 'tired face'
    },
    {
        symbol: '🥱',
        name: 'emoji-98',
        keyword: 'yawning face'
    },
    {
        symbol: '😤',
        name: 'emoji-99',
        keyword: 'triumph face with look of triumph'
    },
    {
        symbol: '😡',
        name: 'emoji-100',
        keyword: 'rage pouting face'
    },
    {
        symbol: '😠',
        name: 'emoji-101',
        keyword: 'angry angry face'
    },
    {
        symbol: '🤬',
        name: 'emoji-102',
        keyword: 'face with symbols on mouth serious face with symbols covering mouth'
    },
    {
        symbol: '😈',
        name: 'emoji-103',
        keyword: 'smiling imp smiling face with horns'
    },
    {
        symbol: '👿',
        name: 'emoji-104',
        keyword: 'imp'
    },
    {
        symbol: '💀',
        name: 'emoji-105',
        keyword: 'skull'
    },
    {
        symbol: '☠️',
        name: 'emoji-106',
        keyword: 'skull and crossbones'
    },
    {
        symbol: '💩',
        name: 'emoji-107',
        keyword: 'poop shit hankey pile of poo'
    },
    {
        symbol: '🤡',
        name: 'emoji-108',
        keyword: 'clown face'
    },
    {
        symbol: '👹',
        name: 'emoji-109',
        keyword: 'japanese ogre'
    },
    {
        symbol: '👺',
        name: 'emoji-110',
        keyword: 'japanese goblin'
    },
    {
        symbol: '👻',
        name: 'emoji-111',
        keyword: 'ghost'
    },
    {
        symbol: '👽',
        name: 'emoji-112',
        keyword: 'alien extraterrestrial alien'
    },
    {
        symbol: '👾',
        name: 'emoji-113',
        keyword: 'alien monster space invader'
    },
    {
        symbol: '🤖',
        name: 'emoji-114',
        keyword: 'robot face'
    },
    {
        symbol: '😺',
        name: 'emoji-115',
        keyword: 'smiley cat smiling cat face with open mouth'
    },
    {
        symbol: '😸',
        name: 'emoji-116',
        keyword: 'smile cat grinning cat face with smiling eyes'
    },
    {
        symbol: '😹',
        name: 'emoji-117',
        keyword: 'joy cat cat face with tears of joy'
    },
    {
        symbol: '😻',
        name: 'emoji-118',
        keyword: 'heart eyes cat smiling cat face with heart-shaped eyes'
    },
    {
        symbol: '😼',
        name: 'emoji-119',
        keyword: 'smirk cat cat face with wry smile'
    },
    {
        symbol: '😽',
        name: 'emoji-120',
        keyword: 'kissing cat kissing cat face with closed eyes'
    },
    {
        symbol: '🙀',
        name: 'emoji-121',
        keyword: 'scream cat weary cat face'
    },
    {
        symbol: '😿',
        name: 'emoji-122',
        keyword: 'crying cat face'
    },
    {
        symbol: '😾',
        name: 'emoji-123',
        keyword: 'pouting cat pouting cat face'
    },
    {
        symbol: '🙈',
        name: 'emoji-124',
        keyword: 'see no evil see-no-evil monkey'
    },
    {
        symbol: '🙉',
        name: 'emoji-125',
        keyword: 'hear no evil hear-no-evil monkey'
    },
    {
        symbol: '🙊',
        name: 'emoji-126',
        keyword: 'speak no evil speak-no-evil monkey'
    },
    {
        symbol: '💋',
        name: 'emoji-127',
        keyword: 'kiss kiss mark'
    },
    {
        symbol: '💌',
        name: 'emoji-128',
        keyword: 'love letter'
    },
    {
        symbol: '💘',
        name: 'emoji-129',
        keyword: 'cupid heart with arrow'
    },
    {
        symbol: '💝',
        name: 'emoji-130',
        keyword: 'gift heart heart with ribbon'
    },
    {
        symbol: '💖',
        name: 'emoji-131',
        keyword: 'sparkling heart'
    },
    {
        symbol: '💗',
        name: 'emoji-132',
        keyword: 'heartpulse growing heart'
    },
    {
        symbol: '💓',
        name: 'emoji-133',
        keyword: 'heartbeat beating heart'
    },
    {
        symbol: '💞',
        name: 'emoji-134',
        keyword: 'revolving hearts'
    },
    {
        symbol: '💕',
        name: 'emoji-135',
        keyword: 'two hearts'
    },
    {
        symbol: '💟',
        name: 'emoji-136',
        keyword: 'heart decoration'
    },
    {
        symbol: '❣️',
        name: 'emoji-137',
        keyword: 'heart exclamation heavy heart exclamation mark ornament'
    },
    {
        symbol: '💔',
        name: 'emoji-138',
        keyword: 'broken heart'
    },
    {
        symbol: '❤️‍🔥',
        name: 'emoji-139',
        keyword: 'heart on fire'
    },
    {
        symbol: '❤️‍🩹',
        name: 'emoji-140',
        keyword: 'mending heart'
    },
    {
        symbol: '❤️',
        name: 'emoji-141',
        keyword: 'heart heavy black heart'
    },
    {
        symbol: '🧡',
        name: 'emoji-142',
        keyword: 'orange heart'
    },
    {
        symbol: '💛',
        name: 'emoji-143',
        keyword: 'yellow heart'
    },
    {
        symbol: '💚',
        name: 'emoji-144',
        keyword: 'green heart'
    },
    {
        symbol: '💙',
        name: 'emoji-145',
        keyword: 'blue heart'
    },
    {
        symbol: '💜',
        name: 'emoji-146',
        keyword: 'purple heart'
    },
    {
        symbol: '🤎',
        name: 'emoji-147',
        keyword: 'brown heart'
    },
    {
        symbol: '🖤',
        name: 'emoji-148',
        keyword: 'black heart'
    },
    {
        symbol: '🤍',
        name: 'emoji-149',
        keyword: 'white heart'
    },
    {
        symbol: '💯',
        name: 'emoji-150',
        keyword: '100 hundred points symbol'
    },
    {
        symbol: '💢',
        name: 'emoji-151',
        keyword: 'anger anger symbol'
    },
    {
        symbol: '💥',
        name: 'emoji-152',
        keyword: 'boom collision collision symbol'
    },
    {
        symbol: '💫',
        name: 'emoji-153',
        keyword: 'dizzy dizzy symbol'
    },
    {
        symbol: '💦',
        name: 'emoji-154',
        keyword: 'sweat drops splashing sweat symbol'
    },
    {
        symbol: '💨',
        name: 'emoji-155',
        keyword: 'dash dash symbol'
    },
    {
        symbol: '🕳️',
        name: 'emoji-156',
        keyword: 'hole'
    },
    {
        symbol: '💣',
        name: 'emoji-157',
        keyword: 'bomb'
    },
    {
        symbol: '💬',
        name: 'emoji-158',
        keyword: 'speech balloon'
    },
    {
        symbol: '👁️‍🗨️',
        name: 'emoji-159',
        keyword: 'eye in speech bubble eye-in-speech-bubble'
    },
    {
        symbol: '🗨️',
        name: 'emoji-160',
        keyword: 'left speech bubble'
    },
    {
        symbol: '🗯️',
        name: 'emoji-161',
        keyword: 'right anger bubble'
    },
    {
        symbol: '💭',
        name: 'emoji-162',
        keyword: 'thought balloon'
    },
    {
        symbol: '💤',
        name: 'emoji-163',
        keyword: 'zzz sleeping symbol'
    },
    {
        versions: [
            '👋🏻',
            '👋🏼',
            '👋🏽',
            '👋🏾',
            '👋🏿'
        ],
        symbol: '👋',
        name: 'emoji-164',
        keyword: 'wave waving hand sign'
    },
    {
        versions: [
            '🤚🏻',
            '🤚🏼',
            '🤚🏽',
            '🤚🏾',
            '🤚🏿'
        ],
        symbol: '🤚',
        name: 'emoji-165',
        keyword: 'raised back of hand'
    },
    {
        versions: [
            '🖐🏻',
            '🖐🏼',
            '🖐🏽',
            '🖐🏾',
            '🖐🏿'
        ],
        symbol: '🖐️',
        name: 'emoji-166',
        keyword: 'hand with fingers splayed raised hand with fingers splayed'
    },
    {
        versions: [
            '✋🏻',
            '✋🏼',
            '✋🏽',
            '✋🏾',
            '✋🏿'
        ],
        symbol: '✋',
        name: 'emoji-167',
        keyword: 'hand raised hand'
    },
    {
        versions: [
            '🖖🏻',
            '🖖🏼',
            '🖖🏽',
            '🖖🏾',
            '🖖🏿'
        ],
        symbol: '🖖',
        name: 'emoji-168',
        keyword: 'spock-hand raised hand with part between middle and ring fingers'
    },
    {
        versions: [
            '🫱🏻',
            '🫱🏼',
            '🫱🏽',
            '🫱🏾',
            '🫱🏿'
        ],
        symbol: '🫱',
        name: 'emoji-169',
        keyword: 'rightwards hand'
    },
    {
        versions: [
            '🫲🏻',
            '🫲🏼',
            '🫲🏽',
            '🫲🏾',
            '🫲🏿'
        ],
        symbol: '🫲',
        name: 'emoji-170',
        keyword: 'leftwards hand'
    },
    {
        versions: [
            '🫳🏻',
            '🫳🏼',
            '🫳🏽',
            '🫳🏾',
            '🫳🏿'
        ],
        symbol: '🫳',
        name: 'emoji-171',
        keyword: 'palm down hand'
    },
    {
        versions: [
            '🫴🏻',
            '🫴🏼',
            '🫴🏽',
            '🫴🏾',
            '🫴🏿'
        ],
        symbol: '🫴',
        name: 'emoji-172',
        keyword: 'palm up hand'
    },
    {
        versions: [
            '👌🏻',
            '👌🏼',
            '👌🏽',
            '👌🏾',
            '👌🏿'
        ],
        symbol: '👌',
        name: 'emoji-173',
        keyword: 'ok hand ok hand sign'
    },
    {
        versions: [
            '🤌🏻',
            '🤌🏼',
            '🤌🏽',
            '🤌🏾',
            '🤌🏿'
        ],
        symbol: '🤌',
        name: 'emoji-174',
        keyword: 'pinched fingers'
    },
    {
        versions: [
            '🤏🏻',
            '🤏🏼',
            '🤏🏽',
            '🤏🏾',
            '🤏🏿'
        ],
        symbol: '🤏',
        name: 'emoji-175',
        keyword: 'pinching hand'
    },
    {
        versions: [
            '✌🏻',
            '✌🏼',
            '✌🏽',
            '✌🏾',
            '✌🏿'
        ],
        symbol: '✌️',
        name: 'emoji-176',
        keyword: 'v victory hand'
    },
    {
        versions: [
            '🤞🏻',
            '🤞🏼',
            '🤞🏽',
            '🤞🏾',
            '🤞🏿'
        ],
        symbol: '🤞',
        name: 'emoji-177',
        keyword: 'crossed fingers hand with index and middle fingers crossed'
    },
    {
        versions: [
            '🫰🏻',
            '🫰🏼',
            '🫰🏽',
            '🫰🏾',
            '🫰🏿'
        ],
        symbol: '🫰',
        name: 'emoji-178',
        keyword: 'hand with index finger and thumb crossed'
    },
    {
        versions: [
            '🤟🏻',
            '🤟🏼',
            '🤟🏽',
            '🤟🏾',
            '🤟🏿'
        ],
        symbol: '🤟',
        name: 'emoji-179',
        keyword: 'i love you hand sign'
    },
    {
        versions: [
            '🤘🏻',
            '🤘🏼',
            '🤘🏽',
            '🤘🏾',
            '🤘🏿'
        ],
        symbol: '🤘',
        name: 'emoji-180',
        keyword: 'the horns sign of the horns'
    },
    {
        versions: [
            '🤙🏻',
            '🤙🏼',
            '🤙🏽',
            '🤙🏾',
            '🤙🏿'
        ],
        symbol: '🤙',
        name: 'emoji-181',
        keyword: 'call me hand'
    },
    {
        versions: [
            '👈🏻',
            '👈🏼',
            '👈🏽',
            '👈🏾',
            '👈🏿'
        ],
        symbol: '👈',
        name: 'emoji-182',
        keyword: 'point left white left pointing backhand index'
    },
    {
        versions: [
            '👉🏻',
            '👉🏼',
            '👉🏽',
            '👉🏾',
            '👉🏿'
        ],
        symbol: '👉',
        name: 'emoji-183',
        keyword: 'point right white right pointing backhand index'
    },
    {
        versions: [
            '👆🏻',
            '👆🏼',
            '👆🏽',
            '👆🏾',
            '👆🏿'
        ],
        symbol: '👆',
        name: 'emoji-184',
        keyword: 'point up 2 white up pointing backhand index'
    },
    {
        versions: [
            '🖕🏻',
            '🖕🏼',
            '🖕🏽',
            '🖕🏾',
            '🖕🏿'
        ],
        symbol: '🖕',
        name: 'emoji-185',
        keyword: 'middle finger reversed hand with middle finger extended'
    },
    {
        versions: [
            '👇🏻',
            '👇🏼',
            '👇🏽',
            '👇🏾',
            '👇🏿'
        ],
        symbol: '👇',
        name: 'emoji-186',
        keyword: 'point down white down pointing backhand index'
    },
    {
        versions: [
            '☝🏻',
            '☝🏼',
            '☝🏽',
            '☝🏾',
            '☝🏿'
        ],
        symbol: '☝️',
        name: 'emoji-187',
        keyword: 'point up white up pointing index'
    },
    {
        versions: [
            '🫵🏻',
            '🫵🏼',
            '🫵🏽',
            '🫵🏾',
            '🫵🏿'
        ],
        symbol: '🫵',
        name: 'emoji-188',
        keyword: 'index pointing at the viewer'
    },
    {
        versions: [
            '👍🏻',
            '👍🏼',
            '👍🏽',
            '👍🏾',
            '👍🏿'
        ],
        symbol: '👍',
        name: 'emoji-189',
        keyword: '+1 thumbsup thumbs up sign'
    },
    {
        versions: [
            '👎🏻',
            '👎🏼',
            '👎🏽',
            '👎🏾',
            '👎🏿'
        ],
        symbol: '👎',
        name: 'emoji-190',
        keyword: '-1 thumbsdown thumbs down sign'
    },
    {
        versions: [
            '✊🏻',
            '✊🏼',
            '✊🏽',
            '✊🏾',
            '✊🏿'
        ],
        symbol: '✊',
        name: 'emoji-191',
        keyword: 'fist raised fist'
    },
    {
        versions: [
            '👊🏻',
            '👊🏼',
            '👊🏽',
            '👊🏾',
            '👊🏿'
        ],
        symbol: '👊',
        name: 'emoji-192',
        keyword: 'punch facepunch fisted hand sign'
    },
    {
        versions: [
            '🤛🏻',
            '🤛🏼',
            '🤛🏽',
            '🤛🏾',
            '🤛🏿'
        ],
        symbol: '🤛',
        name: 'emoji-193',
        keyword: 'left-facing fist'
    },
    {
        versions: [
            '🤜🏻',
            '🤜🏼',
            '🤜🏽',
            '🤜🏾',
            '🤜🏿'
        ],
        symbol: '🤜',
        name: 'emoji-194',
        keyword: 'right-facing fist'
    },
    {
        versions: [
            '👏🏻',
            '👏🏼',
            '👏🏽',
            '👏🏾',
            '👏🏿'
        ],
        symbol: '👏',
        name: 'emoji-195',
        keyword: 'clap clapping hands sign'
    },
    {
        versions: [
            '🙌🏻',
            '🙌🏼',
            '🙌🏽',
            '🙌🏾',
            '🙌🏿'
        ],
        symbol: '🙌',
        name: 'emoji-196',
        keyword: 'raised hands person raising both hands in celebration'
    },
    {
        versions: [
            '🫶🏻',
            '🫶🏼',
            '🫶🏽',
            '🫶🏾',
            '🫶🏿'
        ],
        symbol: '🫶',
        name: 'emoji-197',
        keyword: 'heart hands'
    },
    {
        versions: [
            '👐🏻',
            '👐🏼',
            '👐🏽',
            '👐🏾',
            '👐🏿'
        ],
        symbol: '👐',
        name: 'emoji-198',
        keyword: 'open hands open hands sign'
    },
    {
        versions: [
            '🤲🏻',
            '🤲🏼',
            '🤲🏽',
            '🤲🏾',
            '🤲🏿'
        ],
        symbol: '🤲',
        name: 'emoji-199',
        keyword: 'palms up together'
    },
    {
        versions: [
            '🤝🏻',
            '🤝🏼',
            '🤝🏽',
            '🤝🏾',
            '🤝🏿',
            '🫱🏻‍🫲🏼',
            '🫱🏻‍🫲🏽',
            '🫱🏻‍🫲🏾',
            '🫱🏻‍🫲🏿',
            '🫱🏼‍🫲🏻',
            '🫱🏼‍🫲🏽',
            '🫱🏼‍🫲🏾',
            '🫱🏼‍🫲🏿',
            '🫱🏽‍🫲🏻',
            '🫱🏽‍🫲🏼',
            '🫱🏽‍🫲🏾',
            '🫱🏽‍🫲🏿',
            '🫱🏾‍🫲🏻',
            '🫱🏾‍🫲🏼',
            '🫱🏾‍🫲🏽',
            '🫱🏾‍🫲🏿',
            '🫱🏿‍🫲🏻',
            '🫱🏿‍🫲🏼',
            '🫱🏿‍🫲🏽',
            '🫱🏿‍🫲🏾'
        ],
        symbol: '🤝',
        name: 'emoji-200',
        keyword: 'handshake'
    },
    {
        versions: [
            '🙏🏻',
            '🙏🏼',
            '🙏🏽',
            '🙏🏾',
            '🙏🏿'
        ],
        symbol: '🙏',
        name: 'emoji-201',
        keyword: 'pray person with folded hands'
    },
    {
        versions: [
            '✍🏻',
            '✍🏼',
            '✍🏽',
            '✍🏾',
            '✍🏿'
        ],
        symbol: '✍️',
        name: 'emoji-202',
        keyword: 'writing hand'
    },
    {
        versions: [
            '💅🏻',
            '💅🏼',
            '💅🏽',
            '💅🏾',
            '💅🏿'
        ],
        symbol: '💅',
        name: 'emoji-203',
        keyword: 'nail care nail polish'
    },
    {
        versions: [
            '🤳🏻',
            '🤳🏼',
            '🤳🏽',
            '🤳🏾',
            '🤳🏿'
        ],
        symbol: '🤳',
        name: 'emoji-204',
        keyword: 'selfie'
    },
    {
        versions: [
            '💪🏻',
            '💪🏼',
            '💪🏽',
            '💪🏾',
            '💪🏿'
        ],
        symbol: '💪',
        name: 'emoji-205',
        keyword: 'muscle flexed biceps'
    },
    {
        symbol: '🦾',
        name: 'emoji-206',
        keyword: 'mechanical arm'
    },
    {
        symbol: '🦿',
        name: 'emoji-207',
        keyword: 'mechanical leg'
    },
    {
        versions: [
            '🦵🏻',
            '🦵🏼',
            '🦵🏽',
            '🦵🏾',
            '🦵🏿'
        ],
        symbol: '🦵',
        name: 'emoji-208',
        keyword: 'leg'
    },
    {
        versions: [
            '🦶🏻',
            '🦶🏼',
            '🦶🏽',
            '🦶🏾',
            '🦶🏿'
        ],
        symbol: '🦶',
        name: 'emoji-209',
        keyword: 'foot'
    },
    {
        versions: [
            '👂🏻',
            '👂🏼',
            '👂🏽',
            '👂🏾',
            '👂🏿'
        ],
        symbol: '👂',
        name: 'emoji-210',
        keyword: 'ear'
    },
    {
        versions: [
            '🦻🏻',
            '🦻🏼',
            '🦻🏽',
            '🦻🏾',
            '🦻🏿'
        ],
        symbol: '🦻',
        name: 'emoji-211',
        keyword: 'ear with hearing aid'
    },
    {
        versions: [
            '👃🏻',
            '👃🏼',
            '👃🏽',
            '👃🏾',
            '👃🏿'
        ],
        symbol: '👃',
        name: 'emoji-212',
        keyword: 'nose'
    },
    {
        symbol: '🧠',
        name: 'emoji-213',
        keyword: 'brain'
    },
    {
        symbol: '🫀',
        name: 'emoji-214',
        keyword: 'anatomical heart'
    },
    {
        symbol: '🫁',
        name: 'emoji-215',
        keyword: 'lungs'
    },
    {
        symbol: '🦷',
        name: 'emoji-216',
        keyword: 'tooth'
    },
    {
        symbol: '🦴',
        name: 'emoji-217',
        keyword: 'bone'
    },
    {
        symbol: '👀',
        name: 'emoji-218',
        keyword: 'eyes'
    },
    {
        symbol: '👁️',
        name: 'emoji-219',
        keyword: 'eye'
    },
    {
        symbol: '👅',
        name: 'emoji-220',
        keyword: 'tongue'
    },
    {
        symbol: '👄',
        name: 'emoji-221',
        keyword: 'lips mouth'
    },
    {
        symbol: '🫦',
        name: 'emoji-222',
        keyword: 'biting lip'
    },
    {
        versions: [
            '👶🏻',
            '👶🏼',
            '👶🏽',
            '👶🏾',
            '👶🏿'
        ],
        symbol: '👶',
        name: 'emoji-223',
        keyword: 'baby'
    },
    {
        versions: [
            '🧒🏻',
            '🧒🏼',
            '🧒🏽',
            '🧒🏾',
            '🧒🏿'
        ],
        symbol: '🧒',
        name: 'emoji-224',
        keyword: 'child'
    },
    {
        versions: [
            '👦🏻',
            '👦🏼',
            '👦🏽',
            '👦🏾',
            '👦🏿'
        ],
        symbol: '👦',
        name: 'emoji-225',
        keyword: 'boy'
    },
    {
        versions: [
            '👧🏻',
            '👧🏼',
            '👧🏽',
            '👧🏾',
            '👧🏿'
        ],
        symbol: '👧',
        name: 'emoji-226',
        keyword: 'girl'
    },
    {
        versions: [
            '🧑🏻',
            '🧑🏼',
            '🧑🏽',
            '🧑🏾',
            '🧑🏿'
        ],
        symbol: '🧑',
        name: 'emoji-227',
        keyword: 'adult'
    },
    {
        versions: [
            '👱🏻',
            '👱🏼',
            '👱🏽',
            '👱🏾',
            '👱🏿'
        ],
        symbol: '👱',
        name: 'emoji-228',
        keyword: 'person with blond hair'
    },
    {
        versions: [
            '👨🏻',
            '👨🏼',
            '👨🏽',
            '👨🏾',
            '👨🏿'
        ],
        symbol: '👨',
        name: 'emoji-229',
        keyword: 'man'
    },
    {
        versions: [
            '🧔🏻',
            '🧔🏼',
            '🧔🏽',
            '🧔🏾',
            '🧔🏿'
        ],
        symbol: '🧔',
        name: 'emoji-230',
        keyword: 'bearded person'
    },
    {
        versions: [
            '🧔🏻‍♂️',
            '🧔🏼‍♂️',
            '🧔🏽‍♂️',
            '🧔🏾‍♂️',
            '🧔🏿‍♂️'
        ],
        symbol: '🧔‍♂️',
        name: 'emoji-231',
        keyword: 'man: beard man with beard'
    },
    {
        versions: [
            '🧔🏻‍♀️',
            '🧔🏼‍♀️',
            '🧔🏽‍♀️',
            '🧔🏾‍♀️',
            '🧔🏿‍♀️'
        ],
        symbol: '🧔‍♀️',
        name: 'emoji-232',
        keyword: 'woman: beard woman with beard'
    },
    {
        versions: [
            '👨🏻‍🦰',
            '👨🏼‍🦰',
            '👨🏽‍🦰',
            '👨🏾‍🦰',
            '👨🏿‍🦰'
        ],
        symbol: '👨‍🦰',
        name: 'emoji-233',
        keyword: 'man: red hair red haired man'
    },
    {
        versions: [
            '👨🏻‍🦱',
            '👨🏼‍🦱',
            '👨🏽‍🦱',
            '👨🏾‍🦱',
            '👨🏿‍🦱'
        ],
        symbol: '👨‍🦱',
        name: 'emoji-234',
        keyword: 'man: curly hair curly haired man'
    },
    {
        versions: [
            '👨🏻‍🦳',
            '👨🏼‍🦳',
            '👨🏽‍🦳',
            '👨🏾‍🦳',
            '👨🏿‍🦳'
        ],
        symbol: '👨‍🦳',
        name: 'emoji-235',
        keyword: 'man: white hair white haired man'
    },
    {
        versions: [
            '👨🏻‍🦲',
            '👨🏼‍🦲',
            '👨🏽‍🦲',
            '👨🏾‍🦲',
            '👨🏿‍🦲'
        ],
        symbol: '👨‍🦲',
        name: 'emoji-236',
        keyword: 'bald man man: bald'
    },
    {
        versions: [
            '👩🏻',
            '👩🏼',
            '👩🏽',
            '👩🏾',
            '👩🏿'
        ],
        symbol: '👩',
        name: 'emoji-237',
        keyword: 'woman'
    },
    {
        versions: [
            '👩🏻‍🦰',
            '👩🏼‍🦰',
            '👩🏽‍🦰',
            '👩🏾‍🦰',
            '👩🏿‍🦰'
        ],
        symbol: '👩‍🦰',
        name: 'emoji-238',
        keyword: 'woman: red hair red haired woman'
    },
    {
        versions: [
            '🧑🏻‍🦰',
            '🧑🏼‍🦰',
            '🧑🏽‍🦰',
            '🧑🏾‍🦰',
            '🧑🏿‍🦰'
        ],
        symbol: '🧑‍🦰',
        name: 'emoji-239',
        keyword: 'person: red hair red haired person'
    },
    {
        versions: [
            '👩🏻‍🦱',
            '👩🏼‍🦱',
            '👩🏽‍🦱',
            '👩🏾‍🦱',
            '👩🏿‍🦱'
        ],
        symbol: '👩‍🦱',
        name: 'emoji-240',
        keyword: 'woman: curly hair curly haired woman'
    },
    {
        versions: [
            '🧑🏻‍🦱',
            '🧑🏼‍🦱',
            '🧑🏽‍🦱',
            '🧑🏾‍🦱',
            '🧑🏿‍🦱'
        ],
        symbol: '🧑‍🦱',
        name: 'emoji-241',
        keyword: 'person: curly hair curly haired person'
    },
    {
        versions: [
            '👩🏻‍🦳',
            '👩🏼‍🦳',
            '👩🏽‍🦳',
            '👩🏾‍🦳',
            '👩🏿‍🦳'
        ],
        symbol: '👩‍🦳',
        name: 'emoji-242',
        keyword: 'woman: white hair white haired woman'
    },
    {
        versions: [
            '🧑🏻‍🦳',
            '🧑🏼‍🦳',
            '🧑🏽‍🦳',
            '🧑🏾‍🦳',
            '🧑🏿‍🦳'
        ],
        symbol: '🧑‍🦳',
        name: 'emoji-243',
        keyword: 'person: white hair white haired person'
    },
    {
        versions: [
            '👩🏻‍🦲',
            '👩🏼‍🦲',
            '👩🏽‍🦲',
            '👩🏾‍🦲',
            '👩🏿‍🦲'
        ],
        symbol: '👩‍🦲',
        name: 'emoji-244',
        keyword: 'bald woman woman: bald'
    },
    {
        versions: [
            '🧑🏻‍🦲',
            '🧑🏼‍🦲',
            '🧑🏽‍🦲',
            '🧑🏾‍🦲',
            '🧑🏿‍🦲'
        ],
        symbol: '🧑‍🦲',
        name: 'emoji-245',
        keyword: 'bald person person: bald'
    },
    {
        versions: [
            '👱🏻‍♀️',
            '👱🏼‍♀️',
            '👱🏽‍♀️',
            '👱🏾‍♀️',
            '👱🏿‍♀️'
        ],
        symbol: '👱‍♀️',
        name: 'emoji-246',
        keyword: 'woman: blond hair blond-haired-woman'
    },
    {
        versions: [
            '👱🏻‍♂️',
            '👱🏼‍♂️',
            '👱🏽‍♂️',
            '👱🏾‍♂️',
            '👱🏿‍♂️'
        ],
        symbol: '👱‍♂️',
        name: 'emoji-247',
        keyword: 'man: blond hair blond-haired-man'
    },
    {
        versions: [
            '🧓🏻',
            '🧓🏼',
            '🧓🏽',
            '🧓🏾',
            '🧓🏿'
        ],
        symbol: '🧓',
        name: 'emoji-248',
        keyword: 'older adult'
    },
    {
        versions: [
            '👴🏻',
            '👴🏼',
            '👴🏽',
            '👴🏾',
            '👴🏿'
        ],
        symbol: '👴',
        name: 'emoji-249',
        keyword: 'older man'
    },
    {
        versions: [
            '👵🏻',
            '👵🏼',
            '👵🏽',
            '👵🏾',
            '👵🏿'
        ],
        symbol: '👵',
        name: 'emoji-250',
        keyword: 'older woman'
    },
    {
        versions: [
            '🙍🏻',
            '🙍🏼',
            '🙍🏽',
            '🙍🏾',
            '🙍🏿'
        ],
        symbol: '🙍',
        name: 'emoji-251',
        keyword: 'person frowning'
    },
    {
        versions: [
            '🙍🏻‍♂️',
            '🙍🏼‍♂️',
            '🙍🏽‍♂️',
            '🙍🏾‍♂️',
            '🙍🏿‍♂️'
        ],
        symbol: '🙍‍♂️',
        name: 'emoji-252',
        keyword: 'man frowning man-frowning'
    },
    {
        versions: [
            '🙍🏻‍♀️',
            '🙍🏼‍♀️',
            '🙍🏽‍♀️',
            '🙍🏾‍♀️',
            '🙍🏿‍♀️'
        ],
        symbol: '🙍‍♀️',
        name: 'emoji-253',
        keyword: 'woman frowning woman-frowning'
    },
    {
        versions: [
            '🙎🏻',
            '🙎🏼',
            '🙎🏽',
            '🙎🏾',
            '🙎🏿'
        ],
        symbol: '🙎',
        name: 'emoji-254',
        keyword: 'person with pouting face'
    },
    {
        versions: [
            '🙎🏻‍♂️',
            '🙎🏼‍♂️',
            '🙎🏽‍♂️',
            '🙎🏾‍♂️',
            '🙎🏿‍♂️'
        ],
        symbol: '🙎‍♂️',
        name: 'emoji-255',
        keyword: 'man pouting man-pouting'
    },
    {
        versions: [
            '🙎🏻‍♀️',
            '🙎🏼‍♀️',
            '🙎🏽‍♀️',
            '🙎🏾‍♀️',
            '🙎🏿‍♀️'
        ],
        symbol: '🙎‍♀️',
        name: 'emoji-256',
        keyword: 'woman pouting woman-pouting'
    },
    {
        versions: [
            '🙅🏻',
            '🙅🏼',
            '🙅🏽',
            '🙅🏾',
            '🙅🏿'
        ],
        symbol: '🙅',
        name: 'emoji-257',
        keyword: 'no good face with no good gesture'
    },
    {
        versions: [
            '🙅🏻‍♂️',
            '🙅🏼‍♂️',
            '🙅🏽‍♂️',
            '🙅🏾‍♂️',
            '🙅🏿‍♂️'
        ],
        symbol: '🙅‍♂️',
        name: 'emoji-258',
        keyword: 'man gesturing no man-gesturing-no'
    },
    {
        versions: [
            '🙅🏻‍♀️',
            '🙅🏼‍♀️',
            '🙅🏽‍♀️',
            '🙅🏾‍♀️',
            '🙅🏿‍♀️'
        ],
        symbol: '🙅‍♀️',
        name: 'emoji-259',
        keyword: 'woman gesturing no woman-gesturing-no'
    },
    {
        versions: [
            '🙆🏻',
            '🙆🏼',
            '🙆🏽',
            '🙆🏾',
            '🙆🏿'
        ],
        symbol: '🙆',
        name: 'emoji-260',
        keyword: 'ok woman face with ok gesture'
    },
    {
        versions: [
            '🙆🏻‍♂️',
            '🙆🏼‍♂️',
            '🙆🏽‍♂️',
            '🙆🏾‍♂️',
            '🙆🏿‍♂️'
        ],
        symbol: '🙆‍♂️',
        name: 'emoji-261',
        keyword: 'man gesturing ok man-gesturing-ok'
    },
    {
        versions: [
            '🙆🏻‍♀️',
            '🙆🏼‍♀️',
            '🙆🏽‍♀️',
            '🙆🏾‍♀️',
            '🙆🏿‍♀️'
        ],
        symbol: '🙆‍♀️',
        name: 'emoji-262',
        keyword: 'woman gesturing ok woman-gesturing-ok'
    },
    {
        versions: [
            '💁🏻',
            '💁🏼',
            '💁🏽',
            '💁🏾',
            '💁🏿'
        ],
        symbol: '💁',
        name: 'emoji-263',
        keyword: 'information desk person'
    },
    {
        versions: [
            '💁🏻‍♂️',
            '💁🏼‍♂️',
            '💁🏽‍♂️',
            '💁🏾‍♂️',
            '💁🏿‍♂️'
        ],
        symbol: '💁‍♂️',
        name: 'emoji-264',
        keyword: 'man tipping hand man-tipping-hand'
    },
    {
        versions: [
            '💁🏻‍♀️',
            '💁🏼‍♀️',
            '💁🏽‍♀️',
            '💁🏾‍♀️',
            '💁🏿‍♀️'
        ],
        symbol: '💁‍♀️',
        name: 'emoji-265',
        keyword: 'woman tipping hand woman-tipping-hand'
    },
    {
        versions: [
            '🙋🏻',
            '🙋🏼',
            '🙋🏽',
            '🙋🏾',
            '🙋🏿'
        ],
        symbol: '🙋',
        name: 'emoji-266',
        keyword: 'raising hand happy person raising one hand'
    },
    {
        versions: [
            '🙋🏻‍♂️',
            '🙋🏼‍♂️',
            '🙋🏽‍♂️',
            '🙋🏾‍♂️',
            '🙋🏿‍♂️'
        ],
        symbol: '🙋‍♂️',
        name: 'emoji-267',
        keyword: 'man raising hand man-raising-hand'
    },
    {
        versions: [
            '🙋🏻‍♀️',
            '🙋🏼‍♀️',
            '🙋🏽‍♀️',
            '🙋🏾‍♀️',
            '🙋🏿‍♀️'
        ],
        symbol: '🙋‍♀️',
        name: 'emoji-268',
        keyword: 'woman raising hand woman-raising-hand'
    },
    {
        versions: [
            '🧏🏻',
            '🧏🏼',
            '🧏🏽',
            '🧏🏾',
            '🧏🏿'
        ],
        symbol: '🧏',
        name: 'emoji-269',
        keyword: 'deaf person'
    },
    {
        versions: [
            '🧏🏻‍♂️',
            '🧏🏼‍♂️',
            '🧏🏽‍♂️',
            '🧏🏾‍♂️',
            '🧏🏿‍♂️'
        ],
        symbol: '🧏‍♂️',
        name: 'emoji-270',
        keyword: 'deaf man'
    },
    {
        versions: [
            '🧏🏻‍♀️',
            '🧏🏼‍♀️',
            '🧏🏽‍♀️',
            '🧏🏾‍♀️',
            '🧏🏿‍♀️'
        ],
        symbol: '🧏‍♀️',
        name: 'emoji-271',
        keyword: 'deaf woman'
    },
    {
        versions: [
            '🙇🏻',
            '🙇🏼',
            '🙇🏽',
            '🙇🏾',
            '🙇🏿'
        ],
        symbol: '🙇',
        name: 'emoji-272',
        keyword: 'bow person bowing deeply'
    },
    {
        versions: [
            '🙇🏻‍♂️',
            '🙇🏼‍♂️',
            '🙇🏽‍♂️',
            '🙇🏾‍♂️',
            '🙇🏿‍♂️'
        ],
        symbol: '🙇‍♂️',
        name: 'emoji-273',
        keyword: 'man bowing man-bowing'
    },
    {
        versions: [
            '🙇🏻‍♀️',
            '🙇🏼‍♀️',
            '🙇🏽‍♀️',
            '🙇🏾‍♀️',
            '🙇🏿‍♀️'
        ],
        symbol: '🙇‍♀️',
        name: 'emoji-274',
        keyword: 'woman bowing woman-bowing'
    },
    {
        versions: [
            '🤦🏻',
            '🤦🏼',
            '🤦🏽',
            '🤦🏾',
            '🤦🏿'
        ],
        symbol: '🤦',
        name: 'emoji-275',
        keyword: 'face palm'
    },
    {
        versions: [
            '🤦🏻‍♂️',
            '🤦🏼‍♂️',
            '🤦🏽‍♂️',
            '🤦🏾‍♂️',
            '🤦🏿‍♂️'
        ],
        symbol: '🤦‍♂️',
        name: 'emoji-276',
        keyword: 'man facepalming man-facepalming'
    },
    {
        versions: [
            '🤦🏻‍♀️',
            '🤦🏼‍♀️',
            '🤦🏽‍♀️',
            '🤦🏾‍♀️',
            '🤦🏿‍♀️'
        ],
        symbol: '🤦‍♀️',
        name: 'emoji-277',
        keyword: 'woman facepalming woman-facepalming'
    },
    {
        versions: [
            '🤷🏻',
            '🤷🏼',
            '🤷🏽',
            '🤷🏾',
            '🤷🏿'
        ],
        symbol: '🤷',
        name: 'emoji-278',
        keyword: 'shrug'
    },
    {
        versions: [
            '🤷🏻‍♂️',
            '🤷🏼‍♂️',
            '🤷🏽‍♂️',
            '🤷🏾‍♂️',
            '🤷🏿‍♂️'
        ],
        symbol: '🤷‍♂️',
        name: 'emoji-279',
        keyword: 'man shrugging man-shrugging'
    },
    {
        versions: [
            '🤷🏻‍♀️',
            '🤷🏼‍♀️',
            '🤷🏽‍♀️',
            '🤷🏾‍♀️',
            '🤷🏿‍♀️'
        ],
        symbol: '🤷‍♀️',
        name: 'emoji-280',
        keyword: 'woman shrugging woman-shrugging'
    },
    {
        versions: [
            '🧑🏻‍⚕️',
            '🧑🏼‍⚕️',
            '🧑🏽‍⚕️',
            '🧑🏾‍⚕️',
            '🧑🏿‍⚕️'
        ],
        symbol: '🧑‍⚕️',
        name: 'emoji-281',
        keyword: 'health worker'
    },
    {
        versions: [
            '👨🏻‍⚕️',
            '👨🏼‍⚕️',
            '👨🏽‍⚕️',
            '👨🏾‍⚕️',
            '👨🏿‍⚕️'
        ],
        symbol: '👨‍⚕️',
        name: 'emoji-282',
        keyword: 'male-doctor man health worker'
    },
    {
        versions: [
            '👩🏻‍⚕️',
            '👩🏼‍⚕️',
            '👩🏽‍⚕️',
            '👩🏾‍⚕️',
            '👩🏿‍⚕️'
        ],
        symbol: '👩‍⚕️',
        name: 'emoji-283',
        keyword: 'female-doctor woman health worker'
    },
    {
        versions: [
            '🧑🏻‍🎓',
            '🧑🏼‍🎓',
            '🧑🏽‍🎓',
            '🧑🏾‍🎓',
            '🧑🏿‍🎓'
        ],
        symbol: '🧑‍🎓',
        name: 'emoji-284',
        keyword: 'student'
    },
    {
        versions: [
            '👨🏻‍🎓',
            '👨🏼‍🎓',
            '👨🏽‍🎓',
            '👨🏾‍🎓',
            '👨🏿‍🎓'
        ],
        symbol: '👨‍🎓',
        name: 'emoji-285',
        keyword: 'man student male-student'
    },
    {
        versions: [
            '👩🏻‍🎓',
            '👩🏼‍🎓',
            '👩🏽‍🎓',
            '👩🏾‍🎓',
            '👩🏿‍🎓'
        ],
        symbol: '👩‍🎓',
        name: 'emoji-286',
        keyword: 'woman student female-student'
    },
    {
        versions: [
            '🧑🏻‍🏫',
            '🧑🏼‍🏫',
            '🧑🏽‍🏫',
            '🧑🏾‍🏫',
            '🧑🏿‍🏫'
        ],
        symbol: '🧑‍🏫',
        name: 'emoji-287',
        keyword: 'teacher'
    },
    {
        versions: [
            '👨🏻‍🏫',
            '👨🏼‍🏫',
            '👨🏽‍🏫',
            '👨🏾‍🏫',
            '👨🏿‍🏫'
        ],
        symbol: '👨‍🏫',
        name: 'emoji-288',
        keyword: 'man teacher male-teacher'
    },
    {
        versions: [
            '👩🏻‍🏫',
            '👩🏼‍🏫',
            '👩🏽‍🏫',
            '👩🏾‍🏫',
            '👩🏿‍🏫'
        ],
        symbol: '👩‍🏫',
        name: 'emoji-289',
        keyword: 'woman teacher female-teacher'
    },
    {
        versions: [
            '🧑🏻‍⚖️',
            '🧑🏼‍⚖️',
            '🧑🏽‍⚖️',
            '🧑🏾‍⚖️',
            '🧑🏿‍⚖️'
        ],
        symbol: '🧑‍⚖️',
        name: 'emoji-290',
        keyword: 'judge'
    },
    {
        versions: [
            '👨🏻‍⚖️',
            '👨🏼‍⚖️',
            '👨🏽‍⚖️',
            '👨🏾‍⚖️',
            '👨🏿‍⚖️'
        ],
        symbol: '👨‍⚖️',
        name: 'emoji-291',
        keyword: 'man judge male-judge'
    },
    {
        versions: [
            '👩🏻‍⚖️',
            '👩🏼‍⚖️',
            '👩🏽‍⚖️',
            '👩🏾‍⚖️',
            '👩🏿‍⚖️'
        ],
        symbol: '👩‍⚖️',
        name: 'emoji-292',
        keyword: 'woman judge female-judge'
    },
    {
        versions: [
            '🧑🏻‍🌾',
            '🧑🏼‍🌾',
            '🧑🏽‍🌾',
            '🧑🏾‍🌾',
            '🧑🏿‍🌾'
        ],
        symbol: '🧑‍🌾',
        name: 'emoji-293',
        keyword: 'farmer'
    },
    {
        versions: [
            '👨🏻‍🌾',
            '👨🏼‍🌾',
            '👨🏽‍🌾',
            '👨🏾‍🌾',
            '👨🏿‍🌾'
        ],
        symbol: '👨‍🌾',
        name: 'emoji-294',
        keyword: 'man farmer male-farmer'
    },
    {
        versions: [
            '👩🏻‍🌾',
            '👩🏼‍🌾',
            '👩🏽‍🌾',
            '👩🏾‍🌾',
            '👩🏿‍🌾'
        ],
        symbol: '👩‍🌾',
        name: 'emoji-295',
        keyword: 'woman farmer female-farmer'
    },
    {
        versions: [
            '🧑🏻‍🍳',
            '🧑🏼‍🍳',
            '🧑🏽‍🍳',
            '🧑🏾‍🍳',
            '🧑🏿‍🍳'
        ],
        symbol: '🧑‍🍳',
        name: 'emoji-296',
        keyword: 'cook'
    },
    {
        versions: [
            '👨🏻‍🍳',
            '👨🏼‍🍳',
            '👨🏽‍🍳',
            '👨🏾‍🍳',
            '👨🏿‍🍳'
        ],
        symbol: '👨‍🍳',
        name: 'emoji-297',
        keyword: 'man cook male-cook'
    },
    {
        versions: [
            '👩🏻‍🍳',
            '👩🏼‍🍳',
            '👩🏽‍🍳',
            '👩🏾‍🍳',
            '👩🏿‍🍳'
        ],
        symbol: '👩‍🍳',
        name: 'emoji-298',
        keyword: 'woman cook female-cook'
    },
    {
        versions: [
            '🧑🏻‍🔧',
            '🧑🏼‍🔧',
            '🧑🏽‍🔧',
            '🧑🏾‍🔧',
            '🧑🏿‍🔧'
        ],
        symbol: '🧑‍🔧',
        name: 'emoji-299',
        keyword: 'mechanic'
    },
    {
        versions: [
            '👨🏻‍🔧',
            '👨🏼‍🔧',
            '👨🏽‍🔧',
            '👨🏾‍🔧',
            '👨🏿‍🔧'
        ],
        symbol: '👨‍🔧',
        name: 'emoji-300',
        keyword: 'man mechanic male-mechanic'
    },
    {
        versions: [
            '👩🏻‍🔧',
            '👩🏼‍🔧',
            '👩🏽‍🔧',
            '👩🏾‍🔧',
            '👩🏿‍🔧'
        ],
        symbol: '👩‍🔧',
        name: 'emoji-301',
        keyword: 'woman mechanic female-mechanic'
    },
    {
        versions: [
            '🧑🏻‍🏭',
            '🧑🏼‍🏭',
            '🧑🏽‍🏭',
            '🧑🏾‍🏭',
            '🧑🏿‍🏭'
        ],
        symbol: '🧑‍🏭',
        name: 'emoji-302',
        keyword: 'factory worker'
    },
    {
        versions: [
            '👨🏻‍🏭',
            '👨🏼‍🏭',
            '👨🏽‍🏭',
            '👨🏾‍🏭',
            '👨🏿‍🏭'
        ],
        symbol: '👨‍🏭',
        name: 'emoji-303',
        keyword: 'man factory worker male-factory-worker'
    },
    {
        versions: [
            '👩🏻‍🏭',
            '👩🏼‍🏭',
            '👩🏽‍🏭',
            '👩🏾‍🏭',
            '👩🏿‍🏭'
        ],
        symbol: '👩‍🏭',
        name: 'emoji-304',
        keyword: 'woman factory worker female-factory-worker'
    },
    {
        versions: [
            '🧑🏻‍💼',
            '🧑🏼‍💼',
            '🧑🏽‍💼',
            '🧑🏾‍💼',
            '🧑🏿‍💼'
        ],
        symbol: '🧑‍💼',
        name: 'emoji-305',
        keyword: 'office worker'
    },
    {
        versions: [
            '👨🏻‍💼',
            '👨🏼‍💼',
            '👨🏽‍💼',
            '👨🏾‍💼',
            '👨🏿‍💼'
        ],
        symbol: '👨‍💼',
        name: 'emoji-306',
        keyword: 'man office worker male-office-worker'
    },
    {
        versions: [
            '👩🏻‍💼',
            '👩🏼‍💼',
            '👩🏽‍💼',
            '👩🏾‍💼',
            '👩🏿‍💼'
        ],
        symbol: '👩‍💼',
        name: 'emoji-307',
        keyword: 'woman office worker female-office-worker'
    },
    {
        versions: [
            '🧑🏻‍🔬',
            '🧑🏼‍🔬',
            '🧑🏽‍🔬',
            '🧑🏾‍🔬',
            '🧑🏿‍🔬'
        ],
        symbol: '🧑‍🔬',
        name: 'emoji-308',
        keyword: 'scientist'
    },
    {
        versions: [
            '👨🏻‍🔬',
            '👨🏼‍🔬',
            '👨🏽‍🔬',
            '👨🏾‍🔬',
            '👨🏿‍🔬'
        ],
        symbol: '👨‍🔬',
        name: 'emoji-309',
        keyword: 'man scientist male-scientist'
    },
    {
        versions: [
            '👩🏻‍🔬',
            '👩🏼‍🔬',
            '👩🏽‍🔬',
            '👩🏾‍🔬',
            '👩🏿‍🔬'
        ],
        symbol: '👩‍🔬',
        name: 'emoji-310',
        keyword: 'woman scientist female-scientist'
    },
    {
        versions: [
            '🧑🏻‍💻',
            '🧑🏼‍💻',
            '🧑🏽‍💻',
            '🧑🏾‍💻',
            '🧑🏿‍💻'
        ],
        symbol: '🧑‍💻',
        name: 'emoji-311',
        keyword: 'technologist'
    },
    {
        versions: [
            '👨🏻‍💻',
            '👨🏼‍💻',
            '👨🏽‍💻',
            '👨🏾‍💻',
            '👨🏿‍💻'
        ],
        symbol: '👨‍💻',
        name: 'emoji-312',
        keyword: 'man technologist male-technologist'
    },
    {
        versions: [
            '👩🏻‍💻',
            '👩🏼‍💻',
            '👩🏽‍💻',
            '👩🏾‍💻',
            '👩🏿‍💻'
        ],
        symbol: '👩‍💻',
        name: 'emoji-313',
        keyword: 'woman technologist female-technologist'
    },
    {
        versions: [
            '🧑🏻‍🎤',
            '🧑🏼‍🎤',
            '🧑🏽‍🎤',
            '🧑🏾‍🎤',
            '🧑🏿‍🎤'
        ],
        symbol: '🧑‍🎤',
        name: 'emoji-314',
        keyword: 'singer'
    },
    {
        versions: [
            '👨🏻‍🎤',
            '👨🏼‍🎤',
            '👨🏽‍🎤',
            '👨🏾‍🎤',
            '👨🏿‍🎤'
        ],
        symbol: '👨‍🎤',
        name: 'emoji-315',
        keyword: 'man singer male-singer'
    },
    {
        versions: [
            '👩🏻‍🎤',
            '👩🏼‍🎤',
            '👩🏽‍🎤',
            '👩🏾‍🎤',
            '👩🏿‍🎤'
        ],
        symbol: '👩‍🎤',
        name: 'emoji-316',
        keyword: 'woman singer female-singer'
    },
    {
        versions: [
            '🧑🏻‍🎨',
            '🧑🏼‍🎨',
            '🧑🏽‍🎨',
            '🧑🏾‍🎨',
            '🧑🏿‍🎨'
        ],
        symbol: '🧑‍🎨',
        name: 'emoji-317',
        keyword: 'artist'
    },
    {
        versions: [
            '👨🏻‍🎨',
            '👨🏼‍🎨',
            '👨🏽‍🎨',
            '👨🏾‍🎨',
            '👨🏿‍🎨'
        ],
        symbol: '👨‍🎨',
        name: 'emoji-318',
        keyword: 'man artist male-artist'
    },
    {
        versions: [
            '👩🏻‍🎨',
            '👩🏼‍🎨',
            '👩🏽‍🎨',
            '👩🏾‍🎨',
            '👩🏿‍🎨'
        ],
        symbol: '👩‍🎨',
        name: 'emoji-319',
        keyword: 'woman artist female-artist'
    },
    {
        versions: [
            '🧑🏻‍✈️',
            '🧑🏼‍✈️',
            '🧑🏽‍✈️',
            '🧑🏾‍✈️',
            '🧑🏿‍✈️'
        ],
        symbol: '🧑‍✈️',
        name: 'emoji-320',
        keyword: 'pilot'
    },
    {
        versions: [
            '👨🏻‍✈️',
            '👨🏼‍✈️',
            '👨🏽‍✈️',
            '👨🏾‍✈️',
            '👨🏿‍✈️'
        ],
        symbol: '👨‍✈️',
        name: 'emoji-321',
        keyword: 'man pilot male-pilot'
    },
    {
        versions: [
            '👩🏻‍✈️',
            '👩🏼‍✈️',
            '👩🏽‍✈️',
            '👩🏾‍✈️',
            '👩🏿‍✈️'
        ],
        symbol: '👩‍✈️',
        name: 'emoji-322',
        keyword: 'woman pilot female-pilot'
    },
    {
        versions: [
            '🧑🏻‍🚀',
            '🧑🏼‍🚀',
            '🧑🏽‍🚀',
            '🧑🏾‍🚀',
            '🧑🏿‍🚀'
        ],
        symbol: '🧑‍🚀',
        name: 'emoji-323',
        keyword: 'astronaut'
    },
    {
        versions: [
            '👨🏻‍🚀',
            '👨🏼‍🚀',
            '👨🏽‍🚀',
            '👨🏾‍🚀',
            '👨🏿‍🚀'
        ],
        symbol: '👨‍🚀',
        name: 'emoji-324',
        keyword: 'man astronaut male-astronaut'
    },
    {
        versions: [
            '👩🏻‍🚀',
            '👩🏼‍🚀',
            '👩🏽‍🚀',
            '👩🏾‍🚀',
            '👩🏿‍🚀'
        ],
        symbol: '👩‍🚀',
        name: 'emoji-325',
        keyword: 'woman astronaut female-astronaut'
    },
    {
        versions: [
            '🧑🏻‍🚒',
            '🧑🏼‍🚒',
            '🧑🏽‍🚒',
            '🧑🏾‍🚒',
            '🧑🏿‍🚒'
        ],
        symbol: '🧑‍🚒',
        name: 'emoji-326',
        keyword: 'firefighter'
    },
    {
        versions: [
            '👨🏻‍🚒',
            '👨🏼‍🚒',
            '👨🏽‍🚒',
            '👨🏾‍🚒',
            '👨🏿‍🚒'
        ],
        symbol: '👨‍🚒',
        name: 'emoji-327',
        keyword: 'man firefighter male-firefighter'
    },
    {
        versions: [
            '👩🏻‍🚒',
            '👩🏼‍🚒',
            '👩🏽‍🚒',
            '👩🏾‍🚒',
            '👩🏿‍🚒'
        ],
        symbol: '👩‍🚒',
        name: 'emoji-328',
        keyword: 'woman firefighter female-firefighter'
    },
    {
        versions: [
            '👮🏻',
            '👮🏼',
            '👮🏽',
            '👮🏾',
            '👮🏿'
        ],
        symbol: '👮',
        name: 'emoji-329',
        keyword: 'cop police officer'
    },
    {
        versions: [
            '👮🏻‍♂️',
            '👮🏼‍♂️',
            '👮🏽‍♂️',
            '👮🏾‍♂️',
            '👮🏿‍♂️'
        ],
        symbol: '👮‍♂️',
        name: 'emoji-330',
        keyword: 'man police officer male-police-officer'
    },
    {
        versions: [
            '👮🏻‍♀️',
            '👮🏼‍♀️',
            '👮🏽‍♀️',
            '👮🏾‍♀️',
            '👮🏿‍♀️'
        ],
        symbol: '👮‍♀️',
        name: 'emoji-331',
        keyword: 'woman police officer female-police-officer'
    },
    {
        versions: [
            '🕵🏻',
            '🕵🏼',
            '🕵🏽',
            '🕵🏾',
            '🕵🏿'
        ],
        symbol: '🕵️',
        name: 'emoji-332',
        keyword: 'detective sleuth or spy'
    },
    {
        versions: [
            '🕵🏻‍♂️',
            '🕵🏼‍♂️',
            '🕵🏽‍♂️',
            '🕵🏾‍♂️',
            '🕵🏿‍♂️'
        ],
        symbol: '🕵️‍♂️',
        name: 'emoji-333',
        keyword: 'man detective male-detective'
    },
    {
        versions: [
            '🕵🏻‍♀️',
            '🕵🏼‍♀️',
            '🕵🏽‍♀️',
            '🕵🏾‍♀️',
            '🕵🏿‍♀️'
        ],
        symbol: '🕵️‍♀️',
        name: 'emoji-334',
        keyword: 'woman detective female-detective'
    },
    {
        versions: [
            '💂🏻',
            '💂🏼',
            '💂🏽',
            '💂🏾',
            '💂🏿'
        ],
        symbol: '💂',
        name: 'emoji-335',
        keyword: 'guardsman'
    },
    {
        versions: [
            '💂🏻‍♂️',
            '💂🏼‍♂️',
            '💂🏽‍♂️',
            '💂🏾‍♂️',
            '💂🏿‍♂️'
        ],
        symbol: '💂‍♂️',
        name: 'emoji-336',
        keyword: 'man guard male-guard'
    },
    {
        versions: [
            '💂🏻‍♀️',
            '💂🏼‍♀️',
            '💂🏽‍♀️',
            '💂🏾‍♀️',
            '💂🏿‍♀️'
        ],
        symbol: '💂‍♀️',
        name: 'emoji-337',
        keyword: 'woman guard female-guard'
    },
    {
        versions: [
            '🥷🏻',
            '🥷🏼',
            '🥷🏽',
            '🥷🏾',
            '🥷🏿'
        ],
        symbol: '🥷',
        name: 'emoji-338',
        keyword: 'ninja'
    },
    {
        versions: [
            '👷🏻',
            '👷🏼',
            '👷🏽',
            '👷🏾',
            '👷🏿'
        ],
        symbol: '👷',
        name: 'emoji-339',
        keyword: 'construction worker'
    },
    {
        versions: [
            '👷🏻‍♂️',
            '👷🏼‍♂️',
            '👷🏽‍♂️',
            '👷🏾‍♂️',
            '👷🏿‍♂️'
        ],
        symbol: '👷‍♂️',
        name: 'emoji-340',
        keyword: 'man construction worker male-construction-worker'
    },
    {
        versions: [
            '👷🏻‍♀️',
            '👷🏼‍♀️',
            '👷🏽‍♀️',
            '👷🏾‍♀️',
            '👷🏿‍♀️'
        ],
        symbol: '👷‍♀️',
        name: 'emoji-341',
        keyword: 'woman construction worker female-construction-worker'
    },
    {
        versions: [
            '🫅🏻',
            '🫅🏼',
            '🫅🏽',
            '🫅🏾',
            '🫅🏿'
        ],
        symbol: '🫅',
        name: 'emoji-342',
        keyword: 'person with crown'
    },
    {
        versions: [
            '🤴🏻',
            '🤴🏼',
            '🤴🏽',
            '🤴🏾',
            '🤴🏿'
        ],
        symbol: '🤴',
        name: 'emoji-343',
        keyword: 'prince'
    },
    {
        versions: [
            '👸🏻',
            '👸🏼',
            '👸🏽',
            '👸🏾',
            '👸🏿'
        ],
        symbol: '👸',
        name: 'emoji-344',
        keyword: 'princess'
    },
    {
        versions: [
            '👳🏻',
            '👳🏼',
            '👳🏽',
            '👳🏾',
            '👳🏿'
        ],
        symbol: '👳',
        name: 'emoji-345',
        keyword: 'man with turban'
    },
    {
        versions: [
            '👳🏻‍♂️',
            '👳🏼‍♂️',
            '👳🏽‍♂️',
            '👳🏾‍♂️',
            '👳🏿‍♂️'
        ],
        symbol: '👳‍♂️',
        name: 'emoji-346',
        keyword: 'man wearing turban man-wearing-turban'
    },
    {
        versions: [
            '👳🏻‍♀️',
            '👳🏼‍♀️',
            '👳🏽‍♀️',
            '👳🏾‍♀️',
            '👳🏿‍♀️'
        ],
        symbol: '👳‍♀️',
        name: 'emoji-347',
        keyword: 'woman wearing turban woman-wearing-turban'
    },
    {
        versions: [
            '👲🏻',
            '👲🏼',
            '👲🏽',
            '👲🏾',
            '👲🏿'
        ],
        symbol: '👲',
        name: 'emoji-348',
        keyword: 'man with gua pi mao'
    },
    {
        versions: [
            '🧕🏻',
            '🧕🏼',
            '🧕🏽',
            '🧕🏾',
            '🧕🏿'
        ],
        symbol: '🧕',
        name: 'emoji-349',
        keyword: 'person with headscarf'
    },
    {
        versions: [
            '🤵🏻',
            '🤵🏼',
            '🤵🏽',
            '🤵🏾',
            '🤵🏿'
        ],
        symbol: '🤵',
        name: 'emoji-350',
        keyword: 'man in tuxedo person in tuxedo'
    },
    {
        versions: [
            '🤵🏻‍♂️',
            '🤵🏼‍♂️',
            '🤵🏽‍♂️',
            '🤵🏾‍♂️',
            '🤵🏿‍♂️'
        ],
        symbol: '🤵‍♂️',
        name: 'emoji-351',
        keyword: 'man in tuxedo'
    },
    {
        versions: [
            '🤵🏻‍♀️',
            '🤵🏼‍♀️',
            '🤵🏽‍♀️',
            '🤵🏾‍♀️',
            '🤵🏿‍♀️'
        ],
        symbol: '🤵‍♀️',
        name: 'emoji-352',
        keyword: 'woman in tuxedo'
    },
    {
        versions: [
            '👰🏻',
            '👰🏼',
            '👰🏽',
            '👰🏾',
            '👰🏿'
        ],
        symbol: '👰',
        name: 'emoji-353',
        keyword: 'bride with veil'
    },
    {
        versions: [
            '👰🏻‍♂️',
            '👰🏼‍♂️',
            '👰🏽‍♂️',
            '👰🏾‍♂️',
            '👰🏿‍♂️'
        ],
        symbol: '👰‍♂️',
        name: 'emoji-354',
        keyword: 'man with veil'
    },
    {
        versions: [
            '👰🏻‍♀️',
            '👰🏼‍♀️',
            '👰🏽‍♀️',
            '👰🏾‍♀️',
            '👰🏿‍♀️'
        ],
        symbol: '👰‍♀️',
        name: 'emoji-355',
        keyword: 'woman with veil'
    },
    {
        versions: [
            '🤰🏻',
            '🤰🏼',
            '🤰🏽',
            '🤰🏾',
            '🤰🏿'
        ],
        symbol: '🤰',
        name: 'emoji-356',
        keyword: 'pregnant woman'
    },
    {
        versions: [
            '🫃🏻',
            '🫃🏼',
            '🫃🏽',
            '🫃🏾',
            '🫃🏿'
        ],
        symbol: '🫃',
        name: 'emoji-357',
        keyword: 'pregnant man'
    },
    {
        versions: [
            '🫄🏻',
            '🫄🏼',
            '🫄🏽',
            '🫄🏾',
            '🫄🏿'
        ],
        symbol: '🫄',
        name: 'emoji-358',
        keyword: 'pregnant person'
    },
    {
        versions: [
            '🤱🏻',
            '🤱🏼',
            '🤱🏽',
            '🤱🏾',
            '🤱🏿'
        ],
        symbol: '🤱',
        name: 'emoji-359',
        keyword: 'breast-feeding'
    },
    {
        versions: [
            '👩🏻‍🍼',
            '👩🏼‍🍼',
            '👩🏽‍🍼',
            '👩🏾‍🍼',
            '👩🏿‍🍼'
        ],
        symbol: '👩‍🍼',
        name: 'emoji-360',
        keyword: 'woman feeding baby'
    },
    {
        versions: [
            '👨🏻‍🍼',
            '👨🏼‍🍼',
            '👨🏽‍🍼',
            '👨🏾‍🍼',
            '👨🏿‍🍼'
        ],
        symbol: '👨‍🍼',
        name: 'emoji-361',
        keyword: 'man feeding baby'
    },
    {
        versions: [
            '🧑🏻‍🍼',
            '🧑🏼‍🍼',
            '🧑🏽‍🍼',
            '🧑🏾‍🍼',
            '🧑🏿‍🍼'
        ],
        symbol: '🧑‍🍼',
        name: 'emoji-362',
        keyword: 'person feeding baby'
    },
    {
        versions: [
            '👼🏻',
            '👼🏼',
            '👼🏽',
            '👼🏾',
            '👼🏿'
        ],
        symbol: '👼',
        name: 'emoji-363',
        keyword: 'angel baby angel'
    },
    {
        versions: [
            '🎅🏻',
            '🎅🏼',
            '🎅🏽',
            '🎅🏾',
            '🎅🏿'
        ],
        symbol: '🎅',
        name: 'emoji-364',
        keyword: 'santa father christmas'
    },
    {
        versions: [
            '🤶🏻',
            '🤶🏼',
            '🤶🏽',
            '🤶🏾',
            '🤶🏿'
        ],
        symbol: '🤶',
        name: 'emoji-365',
        keyword: 'mrs claus mother christmas'
    },
    {
        versions: [
            '🧑🏻‍🎄',
            '🧑🏼‍🎄',
            '🧑🏽‍🎄',
            '🧑🏾‍🎄',
            '🧑🏿‍🎄'
        ],
        symbol: '🧑‍🎄',
        name: 'emoji-366',
        keyword: 'mx claus'
    },
    {
        versions: [
            '🦸🏻',
            '🦸🏼',
            '🦸🏽',
            '🦸🏾',
            '🦸🏿'
        ],
        symbol: '🦸',
        name: 'emoji-367',
        keyword: 'superhero'
    },
    {
        versions: [
            '🦸🏻‍♂️',
            '🦸🏼‍♂️',
            '🦸🏽‍♂️',
            '🦸🏾‍♂️',
            '🦸🏿‍♂️'
        ],
        symbol: '🦸‍♂️',
        name: 'emoji-368',
        keyword: 'man superhero male superhero'
    },
    {
        versions: [
            '🦸🏻‍♀️',
            '🦸🏼‍♀️',
            '🦸🏽‍♀️',
            '🦸🏾‍♀️',
            '🦸🏿‍♀️'
        ],
        symbol: '🦸‍♀️',
        name: 'emoji-369',
        keyword: 'woman superhero female superhero'
    },
    {
        versions: [
            '🦹🏻',
            '🦹🏼',
            '🦹🏽',
            '🦹🏾',
            '🦹🏿'
        ],
        symbol: '🦹',
        name: 'emoji-370',
        keyword: 'supervillain'
    },
    {
        versions: [
            '🦹🏻‍♂️',
            '🦹🏼‍♂️',
            '🦹🏽‍♂️',
            '🦹🏾‍♂️',
            '🦹🏿‍♂️'
        ],
        symbol: '🦹‍♂️',
        name: 'emoji-371',
        keyword: 'man supervillain male supervillain'
    },
    {
        versions: [
            '🦹🏻‍♀️',
            '🦹🏼‍♀️',
            '🦹🏽‍♀️',
            '🦹🏾‍♀️',
            '🦹🏿‍♀️'
        ],
        symbol: '🦹‍♀️',
        name: 'emoji-372',
        keyword: 'woman supervillain female supervillain'
    },
    {
        versions: [
            '🧙🏻',
            '🧙🏼',
            '🧙🏽',
            '🧙🏾',
            '🧙🏿'
        ],
        symbol: '🧙',
        name: 'emoji-373',
        keyword: 'mage'
    },
    {
        versions: [
            '🧙🏻‍♂️',
            '🧙🏼‍♂️',
            '🧙🏽‍♂️',
            '🧙🏾‍♂️',
            '🧙🏿‍♂️'
        ],
        symbol: '🧙‍♂️',
        name: 'emoji-374',
        keyword: 'man mage male mage'
    },
    {
        versions: [
            '🧙🏻‍♀️',
            '🧙🏼‍♀️',
            '🧙🏽‍♀️',
            '🧙🏾‍♀️',
            '🧙🏿‍♀️'
        ],
        symbol: '🧙‍♀️',
        name: 'emoji-375',
        keyword: 'woman mage female mage'
    },
    {
        versions: [
            '🧚🏻',
            '🧚🏼',
            '🧚🏽',
            '🧚🏾',
            '🧚🏿'
        ],
        symbol: '🧚',
        name: 'emoji-376',
        keyword: 'fairy'
    },
    {
        versions: [
            '🧚🏻‍♂️',
            '🧚🏼‍♂️',
            '🧚🏽‍♂️',
            '🧚🏾‍♂️',
            '🧚🏿‍♂️'
        ],
        symbol: '🧚‍♂️',
        name: 'emoji-377',
        keyword: 'man fairy male fairy'
    },
    {
        versions: [
            '🧚🏻‍♀️',
            '🧚🏼‍♀️',
            '🧚🏽‍♀️',
            '🧚🏾‍♀️',
            '🧚🏿‍♀️'
        ],
        symbol: '🧚‍♀️',
        name: 'emoji-378',
        keyword: 'woman fairy female fairy'
    },
    {
        versions: [
            '🧛🏻',
            '🧛🏼',
            '🧛🏽',
            '🧛🏾',
            '🧛🏿'
        ],
        symbol: '🧛',
        name: 'emoji-379',
        keyword: 'vampire'
    },
    {
        versions: [
            '🧛🏻‍♂️',
            '🧛🏼‍♂️',
            '🧛🏽‍♂️',
            '🧛🏾‍♂️',
            '🧛🏿‍♂️'
        ],
        symbol: '🧛‍♂️',
        name: 'emoji-380',
        keyword: 'man vampire male vampire'
    },
    {
        versions: [
            '🧛🏻‍♀️',
            '🧛🏼‍♀️',
            '🧛🏽‍♀️',
            '🧛🏾‍♀️',
            '🧛🏿‍♀️'
        ],
        symbol: '🧛‍♀️',
        name: 'emoji-381',
        keyword: 'woman vampire female vampire'
    },
    {
        versions: [
            '🧜🏻',
            '🧜🏼',
            '🧜🏽',
            '🧜🏾',
            '🧜🏿'
        ],
        symbol: '🧜',
        name: 'emoji-382',
        keyword: 'merperson'
    },
    {
        versions: [
            '🧜🏻‍♂️',
            '🧜🏼‍♂️',
            '🧜🏽‍♂️',
            '🧜🏾‍♂️',
            '🧜🏿‍♂️'
        ],
        symbol: '🧜‍♂️',
        name: 'emoji-383',
        keyword: 'merman'
    },
    {
        versions: [
            '🧜🏻‍♀️',
            '🧜🏼‍♀️',
            '🧜🏽‍♀️',
            '🧜🏾‍♀️',
            '🧜🏿‍♀️'
        ],
        symbol: '🧜‍♀️',
        name: 'emoji-384',
        keyword: 'mermaid'
    },
    {
        versions: [
            '🧝🏻',
            '🧝🏼',
            '🧝🏽',
            '🧝🏾',
            '🧝🏿'
        ],
        symbol: '🧝',
        name: 'emoji-385',
        keyword: 'elf'
    },
    {
        versions: [
            '🧝🏻‍♂️',
            '🧝🏼‍♂️',
            '🧝🏽‍♂️',
            '🧝🏾‍♂️',
            '🧝🏿‍♂️'
        ],
        symbol: '🧝‍♂️',
        name: 'emoji-386',
        keyword: 'man elf male elf'
    },
    {
        versions: [
            '🧝🏻‍♀️',
            '🧝🏼‍♀️',
            '🧝🏽‍♀️',
            '🧝🏾‍♀️',
            '🧝🏿‍♀️'
        ],
        symbol: '🧝‍♀️',
        name: 'emoji-387',
        keyword: 'woman elf female elf'
    },
    {
        symbol: '🧞',
        name: 'emoji-388',
        keyword: 'genie'
    },
    {
        symbol: '🧞‍♂️',
        name: 'emoji-389',
        keyword: 'man genie male genie'
    },
    {
        symbol: '🧞‍♀️',
        name: 'emoji-390',
        keyword: 'woman genie female genie'
    },
    {
        symbol: '🧟',
        name: 'emoji-391',
        keyword: 'zombie'
    },
    {
        symbol: '🧟‍♂️',
        name: 'emoji-392',
        keyword: 'man zombie male zombie'
    },
    {
        symbol: '🧟‍♀️',
        name: 'emoji-393',
        keyword: 'woman zombie female zombie'
    },
    {
        symbol: '🧌',
        name: 'emoji-394',
        keyword: 'troll'
    },
    {
        versions: [
            '💆🏻',
            '💆🏼',
            '💆🏽',
            '💆🏾',
            '💆🏿'
        ],
        symbol: '💆',
        name: 'emoji-395',
        keyword: 'massage face massage'
    },
    {
        versions: [
            '💆🏻‍♂️',
            '💆🏼‍♂️',
            '💆🏽‍♂️',
            '💆🏾‍♂️',
            '💆🏿‍♂️'
        ],
        symbol: '💆‍♂️',
        name: 'emoji-396',
        keyword: 'man getting massage man-getting-massage'
    },
    {
        versions: [
            '💆🏻‍♀️',
            '💆🏼‍♀️',
            '💆🏽‍♀️',
            '💆🏾‍♀️',
            '💆🏿‍♀️'
        ],
        symbol: '💆‍♀️',
        name: 'emoji-397',
        keyword: 'woman getting massage woman-getting-massage'
    },
    {
        versions: [
            '💇🏻',
            '💇🏼',
            '💇🏽',
            '💇🏾',
            '💇🏿'
        ],
        symbol: '💇',
        name: 'emoji-398',
        keyword: 'haircut'
    },
    {
        versions: [
            '💇🏻‍♂️',
            '💇🏼‍♂️',
            '💇🏽‍♂️',
            '💇🏾‍♂️',
            '💇🏿‍♂️'
        ],
        symbol: '💇‍♂️',
        name: 'emoji-399',
        keyword: 'man getting haircut man-getting-haircut'
    },
    {
        versions: [
            '💇🏻‍♀️',
            '💇🏼‍♀️',
            '💇🏽‍♀️',
            '💇🏾‍♀️',
            '💇🏿‍♀️'
        ],
        symbol: '💇‍♀️',
        name: 'emoji-400',
        keyword: 'woman getting haircut woman-getting-haircut'
    },
    {
        versions: [
            '🚶🏻',
            '🚶🏼',
            '🚶🏽',
            '🚶🏾',
            '🚶🏿'
        ],
        symbol: '🚶',
        name: 'emoji-401',
        keyword: 'walking pedestrian'
    },
    {
        versions: [
            '🚶🏻‍♂️',
            '🚶🏼‍♂️',
            '🚶🏽‍♂️',
            '🚶🏾‍♂️',
            '🚶🏿‍♂️'
        ],
        symbol: '🚶‍♂️',
        name: 'emoji-402',
        keyword: 'man walking man-walking'
    },
    {
        versions: [
            '🚶🏻‍♀️',
            '🚶🏼‍♀️',
            '🚶🏽‍♀️',
            '🚶🏾‍♀️',
            '🚶🏿‍♀️'
        ],
        symbol: '🚶‍♀️',
        name: 'emoji-403',
        keyword: 'woman walking woman-walking'
    },
    {
        versions: [
            '🧍🏻',
            '🧍🏼',
            '🧍🏽',
            '🧍🏾',
            '🧍🏿'
        ],
        symbol: '🧍',
        name: 'emoji-404',
        keyword: 'standing person'
    },
    {
        versions: [
            '🧍🏻‍♂️',
            '🧍🏼‍♂️',
            '🧍🏽‍♂️',
            '🧍🏾‍♂️',
            '🧍🏿‍♂️'
        ],
        symbol: '🧍‍♂️',
        name: 'emoji-405',
        keyword: 'man standing'
    },
    {
        versions: [
            '🧍🏻‍♀️',
            '🧍🏼‍♀️',
            '🧍🏽‍♀️',
            '🧍🏾‍♀️',
            '🧍🏿‍♀️'
        ],
        symbol: '🧍‍♀️',
        name: 'emoji-406',
        keyword: 'woman standing'
    },
    {
        versions: [
            '🧎🏻',
            '🧎🏼',
            '🧎🏽',
            '🧎🏾',
            '🧎🏿'
        ],
        symbol: '🧎',
        name: 'emoji-407',
        keyword: 'kneeling person'
    },
    {
        versions: [
            '🧎🏻‍♂️',
            '🧎🏼‍♂️',
            '🧎🏽‍♂️',
            '🧎🏾‍♂️',
            '🧎🏿‍♂️'
        ],
        symbol: '🧎‍♂️',
        name: 'emoji-408',
        keyword: 'man kneeling'
    },
    {
        versions: [
            '🧎🏻‍♀️',
            '🧎🏼‍♀️',
            '🧎🏽‍♀️',
            '🧎🏾‍♀️',
            '🧎🏿‍♀️'
        ],
        symbol: '🧎‍♀️',
        name: 'emoji-409',
        keyword: 'woman kneeling'
    },
    {
        versions: [
            '🧑🏻‍🦯',
            '🧑🏼‍🦯',
            '🧑🏽‍🦯',
            '🧑🏾‍🦯',
            '🧑🏿‍🦯'
        ],
        symbol: '🧑‍🦯',
        name: 'emoji-410',
        keyword: 'person with white cane person with probing cane'
    },
    {
        versions: [
            '👨🏻‍🦯',
            '👨🏼‍🦯',
            '👨🏽‍🦯',
            '👨🏾‍🦯',
            '👨🏿‍🦯'
        ],
        symbol: '👨‍🦯',
        name: 'emoji-411',
        keyword: 'man with white cane man with probing cane'
    },
    {
        versions: [
            '👩🏻‍🦯',
            '👩🏼‍🦯',
            '👩🏽‍🦯',
            '👩🏾‍🦯',
            '👩🏿‍🦯'
        ],
        symbol: '👩‍🦯',
        name: 'emoji-412',
        keyword: 'woman with white cane woman with probing cane'
    },
    {
        versions: [
            '🧑🏻‍🦼',
            '🧑🏼‍🦼',
            '🧑🏽‍🦼',
            '🧑🏾‍🦼',
            '🧑🏿‍🦼'
        ],
        symbol: '🧑‍🦼',
        name: 'emoji-413',
        keyword: 'person in motorized wheelchair'
    },
    {
        versions: [
            '👨🏻‍🦼',
            '👨🏼‍🦼',
            '👨🏽‍🦼',
            '👨🏾‍🦼',
            '👨🏿‍🦼'
        ],
        symbol: '👨‍🦼',
        name: 'emoji-414',
        keyword: 'man in motorized wheelchair'
    },
    {
        versions: [
            '👩🏻‍🦼',
            '👩🏼‍🦼',
            '👩🏽‍🦼',
            '👩🏾‍🦼',
            '👩🏿‍🦼'
        ],
        symbol: '👩‍🦼',
        name: 'emoji-415',
        keyword: 'woman in motorized wheelchair'
    },
    {
        versions: [
            '🧑🏻‍🦽',
            '🧑🏼‍🦽',
            '🧑🏽‍🦽',
            '🧑🏾‍🦽',
            '🧑🏿‍🦽'
        ],
        symbol: '🧑‍🦽',
        name: 'emoji-416',
        keyword: 'person in manual wheelchair'
    },
    {
        versions: [
            '👨🏻‍🦽',
            '👨🏼‍🦽',
            '👨🏽‍🦽',
            '👨🏾‍🦽',
            '👨🏿‍🦽'
        ],
        symbol: '👨‍🦽',
        name: 'emoji-417',
        keyword: 'man in manual wheelchair'
    },
    {
        versions: [
            '👩🏻‍🦽',
            '👩🏼‍🦽',
            '👩🏽‍🦽',
            '👩🏾‍🦽',
            '👩🏿‍🦽'
        ],
        symbol: '👩‍🦽',
        name: 'emoji-418',
        keyword: 'woman in manual wheelchair'
    },
    {
        versions: [
            '🏃🏻',
            '🏃🏼',
            '🏃🏽',
            '🏃🏾',
            '🏃🏿'
        ],
        symbol: '🏃',
        name: 'emoji-419',
        keyword: 'runner running'
    },
    {
        versions: [
            '🏃🏻‍♂️',
            '🏃🏼‍♂️',
            '🏃🏽‍♂️',
            '🏃🏾‍♂️',
            '🏃🏿‍♂️'
        ],
        symbol: '🏃‍♂️',
        name: 'emoji-420',
        keyword: 'man running man-running'
    },
    {
        versions: [
            '🏃🏻‍♀️',
            '🏃🏼‍♀️',
            '🏃🏽‍♀️',
            '🏃🏾‍♀️',
            '🏃🏿‍♀️'
        ],
        symbol: '🏃‍♀️',
        name: 'emoji-421',
        keyword: 'woman running woman-running'
    },
    {
        versions: [
            '💃🏻',
            '💃🏼',
            '💃🏽',
            '💃🏾',
            '💃🏿'
        ],
        symbol: '💃',
        name: 'emoji-422',
        keyword: 'dancer'
    },
    {
        versions: [
            '🕺🏻',
            '🕺🏼',
            '🕺🏽',
            '🕺🏾',
            '🕺🏿'
        ],
        symbol: '🕺',
        name: 'emoji-423',
        keyword: 'man dancing'
    },
    {
        versions: [
            '🕴🏻',
            '🕴🏼',
            '🕴🏽',
            '🕴🏾',
            '🕴🏿'
        ],
        symbol: '🕴️',
        name: 'emoji-424',
        keyword: 'person in suit levitating man in business suit levitating'
    },
    {
        symbol: '👯',
        name: 'emoji-425',
        keyword: 'dancers woman with bunny ears'
    },
    {
        symbol: '👯‍♂️',
        name: 'emoji-426',
        keyword: 'men with bunny ears men-with-bunny-ears-partying man-with-bunny-ears-partying'
    },
    {
        symbol: '👯‍♀️',
        name: 'emoji-427',
        keyword: 'women with bunny ears women-with-bunny-ears-partying woman-with-bunny-ears-partying'
    },
    {
        versions: [
            '🧖🏻',
            '🧖🏼',
            '🧖🏽',
            '🧖🏾',
            '🧖🏿'
        ],
        symbol: '🧖',
        name: 'emoji-428',
        keyword: 'person in steamy room'
    },
    {
        versions: [
            '🧖🏻‍♂️',
            '🧖🏼‍♂️',
            '🧖🏽‍♂️',
            '🧖🏾‍♂️',
            '🧖🏿‍♂️'
        ],
        symbol: '🧖‍♂️',
        name: 'emoji-429',
        keyword: 'man in steamy room'
    },
    {
        versions: [
            '🧖🏻‍♀️',
            '🧖🏼‍♀️',
            '🧖🏽‍♀️',
            '🧖🏾‍♀️',
            '🧖🏿‍♀️'
        ],
        symbol: '🧖‍♀️',
        name: 'emoji-430',
        keyword: 'woman in steamy room'
    },
    {
        versions: [
            '🧗🏻',
            '🧗🏼',
            '🧗🏽',
            '🧗🏾',
            '🧗🏿'
        ],
        symbol: '🧗',
        name: 'emoji-431',
        keyword: 'person climbing'
    },
    {
        versions: [
            '🧗🏻‍♂️',
            '🧗🏼‍♂️',
            '🧗🏽‍♂️',
            '🧗🏾‍♂️',
            '🧗🏿‍♂️'
        ],
        symbol: '🧗‍♂️',
        name: 'emoji-432',
        keyword: 'man climbing'
    },
    {
        versions: [
            '🧗🏻‍♀️',
            '🧗🏼‍♀️',
            '🧗🏽‍♀️',
            '🧗🏾‍♀️',
            '🧗🏿‍♀️'
        ],
        symbol: '🧗‍♀️',
        name: 'emoji-433',
        keyword: 'woman climbing'
    },
    {
        symbol: '🤺',
        name: 'emoji-434',
        keyword: 'fencer'
    },
    {
        versions: [
            '🏇🏻',
            '🏇🏼',
            '🏇🏽',
            '🏇🏾',
            '🏇🏿'
        ],
        symbol: '🏇',
        name: 'emoji-435',
        keyword: 'horse racing'
    },
    {
        symbol: '⛷️',
        name: 'emoji-436',
        keyword: 'skier'
    },
    {
        versions: [
            '🏂🏻',
            '🏂🏼',
            '🏂🏽',
            '🏂🏾',
            '🏂🏿'
        ],
        symbol: '🏂',
        name: 'emoji-437',
        keyword: 'snowboarder'
    },
    {
        versions: [
            '🏌🏻',
            '🏌🏼',
            '🏌🏽',
            '🏌🏾',
            '🏌🏿'
        ],
        symbol: '🏌️',
        name: 'emoji-438',
        keyword: 'golfer person golfing'
    },
    {
        versions: [
            '🏌🏻‍♂️',
            '🏌🏼‍♂️',
            '🏌🏽‍♂️',
            '🏌🏾‍♂️',
            '🏌🏿‍♂️'
        ],
        symbol: '🏌️‍♂️',
        name: 'emoji-439',
        keyword: 'man golfing man-golfing'
    },
    {
        versions: [
            '🏌🏻‍♀️',
            '🏌🏼‍♀️',
            '🏌🏽‍♀️',
            '🏌🏾‍♀️',
            '🏌🏿‍♀️'
        ],
        symbol: '🏌️‍♀️',
        name: 'emoji-440',
        keyword: 'woman golfing woman-golfing'
    },
    {
        versions: [
            '🏄🏻',
            '🏄🏼',
            '🏄🏽',
            '🏄🏾',
            '🏄🏿'
        ],
        symbol: '🏄',
        name: 'emoji-441',
        keyword: 'surfer'
    },
    {
        versions: [
            '🏄🏻‍♂️',
            '🏄🏼‍♂️',
            '🏄🏽‍♂️',
            '🏄🏾‍♂️',
            '🏄🏿‍♂️'
        ],
        symbol: '🏄‍♂️',
        name: 'emoji-442',
        keyword: 'man surfing man-surfing'
    },
    {
        versions: [
            '🏄🏻‍♀️',
            '🏄🏼‍♀️',
            '🏄🏽‍♀️',
            '🏄🏾‍♀️',
            '🏄🏿‍♀️'
        ],
        symbol: '🏄‍♀️',
        name: 'emoji-443',
        keyword: 'woman surfing woman-surfing'
    },
    {
        versions: [
            '🚣🏻',
            '🚣🏼',
            '🚣🏽',
            '🚣🏾',
            '🚣🏿'
        ],
        symbol: '🚣',
        name: 'emoji-444',
        keyword: 'rowboat'
    },
    {
        versions: [
            '🚣🏻‍♂️',
            '🚣🏼‍♂️',
            '🚣🏽‍♂️',
            '🚣🏾‍♂️',
            '🚣🏿‍♂️'
        ],
        symbol: '🚣‍♂️',
        name: 'emoji-445',
        keyword: 'man rowing boat man-rowing-boat'
    },
    {
        versions: [
            '🚣🏻‍♀️',
            '🚣🏼‍♀️',
            '🚣🏽‍♀️',
            '🚣🏾‍♀️',
            '🚣🏿‍♀️'
        ],
        symbol: '🚣‍♀️',
        name: 'emoji-446',
        keyword: 'woman rowing boat woman-rowing-boat'
    },
    {
        versions: [
            '🏊🏻',
            '🏊🏼',
            '🏊🏽',
            '🏊🏾',
            '🏊🏿'
        ],
        symbol: '🏊',
        name: 'emoji-447',
        keyword: 'swimmer'
    },
    {
        versions: [
            '🏊🏻‍♂️',
            '🏊🏼‍♂️',
            '🏊🏽‍♂️',
            '🏊🏾‍♂️',
            '🏊🏿‍♂️'
        ],
        symbol: '🏊‍♂️',
        name: 'emoji-448',
        keyword: 'man swimming man-swimming'
    },
    {
        versions: [
            '🏊🏻‍♀️',
            '🏊🏼‍♀️',
            '🏊🏽‍♀️',
            '🏊🏾‍♀️',
            '🏊🏿‍♀️'
        ],
        symbol: '🏊‍♀️',
        name: 'emoji-449',
        keyword: 'woman swimming woman-swimming'
    },
    {
        versions: [
            '⛹🏻',
            '⛹🏼',
            '⛹🏽',
            '⛹🏾',
            '⛹🏿'
        ],
        symbol: '⛹️',
        name: 'emoji-450',
        keyword: 'person with ball person bouncing ball'
    },
    {
        versions: [
            '⛹🏻‍♂️',
            '⛹🏼‍♂️',
            '⛹🏽‍♂️',
            '⛹🏾‍♂️',
            '⛹🏿‍♂️'
        ],
        symbol: '⛹️‍♂️',
        name: 'emoji-451',
        keyword: 'man bouncing ball man-bouncing-ball'
    },
    {
        versions: [
            '⛹🏻‍♀️',
            '⛹🏼‍♀️',
            '⛹🏽‍♀️',
            '⛹🏾‍♀️',
            '⛹🏿‍♀️'
        ],
        symbol: '⛹️‍♀️',
        name: 'emoji-452',
        keyword: 'woman bouncing ball woman-bouncing-ball'
    },
    {
        versions: [
            '🏋🏻',
            '🏋🏼',
            '🏋🏽',
            '🏋🏾',
            '🏋🏿'
        ],
        symbol: '🏋️',
        name: 'emoji-453',
        keyword: 'weight lifter person lifting weights'
    },
    {
        versions: [
            '🏋🏻‍♂️',
            '🏋🏼‍♂️',
            '🏋🏽‍♂️',
            '🏋🏾‍♂️',
            '🏋🏿‍♂️'
        ],
        symbol: '🏋️‍♂️',
        name: 'emoji-454',
        keyword: 'man lifting weights man-lifting-weights'
    },
    {
        versions: [
            '🏋🏻‍♀️',
            '🏋🏼‍♀️',
            '🏋🏽‍♀️',
            '🏋🏾‍♀️',
            '🏋🏿‍♀️'
        ],
        symbol: '🏋️‍♀️',
        name: 'emoji-455',
        keyword: 'woman lifting weights woman-lifting-weights'
    },
    {
        versions: [
            '🚴🏻',
            '🚴🏼',
            '🚴🏽',
            '🚴🏾',
            '🚴🏿'
        ],
        symbol: '🚴',
        name: 'emoji-456',
        keyword: 'bicyclist'
    },
    {
        versions: [
            '🚴🏻‍♂️',
            '🚴🏼‍♂️',
            '🚴🏽‍♂️',
            '🚴🏾‍♂️',
            '🚴🏿‍♂️'
        ],
        symbol: '🚴‍♂️',
        name: 'emoji-457',
        keyword: 'man biking man-biking'
    },
    {
        versions: [
            '🚴🏻‍♀️',
            '🚴🏼‍♀️',
            '🚴🏽‍♀️',
            '🚴🏾‍♀️',
            '🚴🏿‍♀️'
        ],
        symbol: '🚴‍♀️',
        name: 'emoji-458',
        keyword: 'woman biking woman-biking'
    },
    {
        versions: [
            '🚵🏻',
            '🚵🏼',
            '🚵🏽',
            '🚵🏾',
            '🚵🏿'
        ],
        symbol: '🚵',
        name: 'emoji-459',
        keyword: 'mountain bicyclist'
    },
    {
        versions: [
            '🚵🏻‍♂️',
            '🚵🏼‍♂️',
            '🚵🏽‍♂️',
            '🚵🏾‍♂️',
            '🚵🏿‍♂️'
        ],
        symbol: '🚵‍♂️',
        name: 'emoji-460',
        keyword: 'man mountain biking man-mountain-biking'
    },
    {
        versions: [
            '🚵🏻‍♀️',
            '🚵🏼‍♀️',
            '🚵🏽‍♀️',
            '🚵🏾‍♀️',
            '🚵🏿‍♀️'
        ],
        symbol: '🚵‍♀️',
        name: 'emoji-461',
        keyword: 'woman mountain biking woman-mountain-biking'
    },
    {
        versions: [
            '🤸🏻',
            '🤸🏼',
            '🤸🏽',
            '🤸🏾',
            '🤸🏿'
        ],
        symbol: '🤸',
        name: 'emoji-462',
        keyword: 'person doing cartwheel'
    },
    {
        versions: [
            '🤸🏻‍♂️',
            '🤸🏼‍♂️',
            '🤸🏽‍♂️',
            '🤸🏾‍♂️',
            '🤸🏿‍♂️'
        ],
        symbol: '🤸‍♂️',
        name: 'emoji-463',
        keyword: 'man cartwheeling man-cartwheeling'
    },
    {
        versions: [
            '🤸🏻‍♀️',
            '🤸🏼‍♀️',
            '🤸🏽‍♀️',
            '🤸🏾‍♀️',
            '🤸🏿‍♀️'
        ],
        symbol: '🤸‍♀️',
        name: 'emoji-464',
        keyword: 'woman cartwheeling woman-cartwheeling'
    },
    {
        symbol: '🤼',
        name: 'emoji-465',
        keyword: 'wrestlers'
    },
    {
        symbol: '🤼‍♂️',
        name: 'emoji-466',
        keyword: 'men wrestling man-wrestling'
    },
    {
        symbol: '🤼‍♀️',
        name: 'emoji-467',
        keyword: 'women wrestling woman-wrestling'
    },
    {
        versions: [
            '🤽🏻',
            '🤽🏼',
            '🤽🏽',
            '🤽🏾',
            '🤽🏿'
        ],
        symbol: '🤽',
        name: 'emoji-468',
        keyword: 'water polo'
    },
    {
        versions: [
            '🤽🏻‍♂️',
            '🤽🏼‍♂️',
            '🤽🏽‍♂️',
            '🤽🏾‍♂️',
            '🤽🏿‍♂️'
        ],
        symbol: '🤽‍♂️',
        name: 'emoji-469',
        keyword: 'man playing water polo man-playing-water-polo'
    },
    {
        versions: [
            '🤽🏻‍♀️',
            '🤽🏼‍♀️',
            '🤽🏽‍♀️',
            '🤽🏾‍♀️',
            '🤽🏿‍♀️'
        ],
        symbol: '🤽‍♀️',
        name: 'emoji-470',
        keyword: 'woman playing water polo woman-playing-water-polo'
    },
    {
        versions: [
            '🤾🏻',
            '🤾🏼',
            '🤾🏽',
            '🤾🏾',
            '🤾🏿'
        ],
        symbol: '🤾',
        name: 'emoji-471',
        keyword: 'handball'
    },
    {
        versions: [
            '🤾🏻‍♂️',
            '🤾🏼‍♂️',
            '🤾🏽‍♂️',
            '🤾🏾‍♂️',
            '🤾🏿‍♂️'
        ],
        symbol: '🤾‍♂️',
        name: 'emoji-472',
        keyword: 'man playing handball man-playing-handball'
    },
    {
        versions: [
            '🤾🏻‍♀️',
            '🤾🏼‍♀️',
            '🤾🏽‍♀️',
            '🤾🏾‍♀️',
            '🤾🏿‍♀️'
        ],
        symbol: '🤾‍♀️',
        name: 'emoji-473',
        keyword: 'woman playing handball woman-playing-handball'
    },
    {
        versions: [
            '🤹🏻',
            '🤹🏼',
            '🤹🏽',
            '🤹🏾',
            '🤹🏿'
        ],
        symbol: '🤹',
        name: 'emoji-474',
        keyword: 'juggling'
    },
    {
        versions: [
            '🤹🏻‍♂️',
            '🤹🏼‍♂️',
            '🤹🏽‍♂️',
            '🤹🏾‍♂️',
            '🤹🏿‍♂️'
        ],
        symbol: '🤹‍♂️',
        name: 'emoji-475',
        keyword: 'man juggling man-juggling'
    },
    {
        versions: [
            '🤹🏻‍♀️',
            '🤹🏼‍♀️',
            '🤹🏽‍♀️',
            '🤹🏾‍♀️',
            '🤹🏿‍♀️'
        ],
        symbol: '🤹‍♀️',
        name: 'emoji-476',
        keyword: 'woman juggling woman-juggling'
    },
    {
        versions: [
            '🧘🏻',
            '🧘🏼',
            '🧘🏽',
            '🧘🏾',
            '🧘🏿'
        ],
        symbol: '🧘',
        name: 'emoji-477',
        keyword: 'person in lotus position'
    },
    {
        versions: [
            '🧘🏻‍♂️',
            '🧘🏼‍♂️',
            '🧘🏽‍♂️',
            '🧘🏾‍♂️',
            '🧘🏿‍♂️'
        ],
        symbol: '🧘‍♂️',
        name: 'emoji-478',
        keyword: 'man in lotus position'
    },
    {
        versions: [
            '🧘🏻‍♀️',
            '🧘🏼‍♀️',
            '🧘🏽‍♀️',
            '🧘🏾‍♀️',
            '🧘🏿‍♀️'
        ],
        symbol: '🧘‍♀️',
        name: 'emoji-479',
        keyword: 'woman in lotus position'
    },
    {
        versions: [
            '🛀🏻',
            '🛀🏼',
            '🛀🏽',
            '🛀🏾',
            '🛀🏿'
        ],
        symbol: '🛀',
        name: 'emoji-480',
        keyword: 'bath'
    },
    {
        versions: [
            '🛌🏻',
            '🛌🏼',
            '🛌🏽',
            '🛌🏾',
            '🛌🏿'
        ],
        symbol: '🛌',
        name: 'emoji-481',
        keyword: 'sleeping accommodation'
    },
    {
        versions: [
            '🧑🏻‍🤝‍🧑🏻',
            '🧑🏻‍🤝‍🧑🏼',
            '🧑🏻‍🤝‍🧑🏽',
            '🧑🏻‍🤝‍🧑🏾',
            '🧑🏻‍🤝‍🧑🏿',
            '🧑🏼‍🤝‍🧑🏻',
            '🧑🏼‍🤝‍🧑🏼',
            '🧑🏼‍🤝‍🧑🏽',
            '🧑🏼‍🤝‍🧑🏾',
            '🧑🏼‍🤝‍🧑🏿',
            '🧑🏽‍🤝‍🧑🏻',
            '🧑🏽‍🤝‍🧑🏼',
            '🧑🏽‍🤝‍🧑🏽',
            '🧑🏽‍🤝‍🧑🏾',
            '🧑🏽‍🤝‍🧑🏿',
            '🧑🏾‍🤝‍🧑🏻',
            '🧑🏾‍🤝‍🧑🏼',
            '🧑🏾‍🤝‍🧑🏽',
            '🧑🏾‍🤝‍🧑🏾',
            '🧑🏾‍🤝‍🧑🏿',
            '🧑🏿‍🤝‍🧑🏻',
            '🧑🏿‍🤝‍🧑🏼',
            '🧑🏿‍🤝‍🧑🏽',
            '🧑🏿‍🤝‍🧑🏾',
            '🧑🏿‍🤝‍🧑🏿'
        ],
        symbol: '🧑‍🤝‍🧑',
        name: 'emoji-482',
        keyword: 'people holding hands'
    },
    {
        versions: [
            '👭🏻',
            '👭🏼',
            '👭🏽',
            '👭🏾',
            '👭🏿',
            '👩🏻‍🤝‍👩🏼',
            '👩🏻‍🤝‍👩🏽',
            '👩🏻‍🤝‍👩🏾',
            '👩🏻‍🤝‍👩🏿',
            '👩🏼‍🤝‍👩🏻',
            '👩🏼‍🤝‍👩🏽',
            '👩🏼‍🤝‍👩🏾',
            '👩🏼‍🤝‍👩🏿',
            '👩🏽‍🤝‍👩🏻',
            '👩🏽‍🤝‍👩🏼',
            '👩🏽‍🤝‍👩🏾',
            '👩🏽‍🤝‍👩🏿',
            '👩🏾‍🤝‍👩🏻',
            '👩🏾‍🤝‍👩🏼',
            '👩🏾‍🤝‍👩🏽',
            '👩🏾‍🤝‍👩🏿',
            '👩🏿‍🤝‍👩🏻',
            '👩🏿‍🤝‍👩🏼',
            '👩🏿‍🤝‍👩🏽',
            '👩🏿‍🤝‍👩🏾'
        ],
        symbol: '👭',
        name: 'emoji-483',
        keyword: 'women holding hands two women holding hands'
    },
    {
        versions: [
            '👫🏻',
            '👫🏼',
            '👫🏽',
            '👫🏾',
            '👫🏿',
            '👩🏻‍🤝‍👨🏼',
            '👩🏻‍🤝‍👨🏽',
            '👩🏻‍🤝‍👨🏾',
            '👩🏻‍🤝‍👨🏿',
            '👩🏼‍🤝‍👨🏻',
            '👩🏼‍🤝‍👨🏽',
            '👩🏼‍🤝‍👨🏾',
            '👩🏼‍🤝‍👨🏿',
            '👩🏽‍🤝‍👨🏻',
            '👩🏽‍🤝‍👨🏼',
            '👩🏽‍🤝‍👨🏾',
            '👩🏽‍🤝‍👨🏿',
            '👩🏾‍🤝‍👨🏻',
            '👩🏾‍🤝‍👨🏼',
            '👩🏾‍🤝‍👨🏽',
            '👩🏾‍🤝‍👨🏿',
            '👩🏿‍🤝‍👨🏻',
            '👩🏿‍🤝‍👨🏼',
            '👩🏿‍🤝‍👨🏽',
            '👩🏿‍🤝‍👨🏾'
        ],
        symbol: '👫',
        name: 'emoji-484',
        keyword: 'couple man and woman holding hands woman and man holding hands'
    },
    {
        versions: [
            '👬🏻',
            '👬🏼',
            '👬🏽',
            '👬🏾',
            '👬🏿',
            '👨🏻‍🤝‍👨🏼',
            '👨🏻‍🤝‍👨🏽',
            '👨🏻‍🤝‍👨🏾',
            '👨🏻‍🤝‍👨🏿',
            '👨🏼‍🤝‍👨🏻',
            '👨🏼‍🤝‍👨🏽',
            '👨🏼‍🤝‍👨🏾',
            '👨🏼‍🤝‍👨🏿',
            '👨🏽‍🤝‍👨🏻',
            '👨🏽‍🤝‍👨🏼',
            '👨🏽‍🤝‍👨🏾',
            '👨🏽‍🤝‍👨🏿',
            '👨🏾‍🤝‍👨🏻',
            '👨🏾‍🤝‍👨🏼',
            '👨🏾‍🤝‍👨🏽',
            '👨🏾‍🤝‍👨🏿',
            '👨🏿‍🤝‍👨🏻',
            '👨🏿‍🤝‍👨🏼',
            '👨🏿‍🤝‍👨🏽',
            '👨🏿‍🤝‍👨🏾'
        ],
        symbol: '👬',
        name: 'emoji-485',
        keyword: 'men holding hands two men holding hands'
    },
    {
        versions: [
            '💏🏻',
            '💏🏼',
            '💏🏽',
            '💏🏾',
            '💏🏿',
            '🧑🏻‍❤️‍💋‍🧑🏼',
            '🧑🏻‍❤️‍💋‍🧑🏽',
            '🧑🏻‍❤️‍💋‍🧑🏾',
            '🧑🏻‍❤️‍💋‍🧑🏿',
            '🧑🏼‍❤️‍💋‍🧑🏻',
            '🧑🏼‍❤️‍💋‍🧑🏽',
            '🧑🏼‍❤️‍💋‍🧑🏾',
            '🧑🏼‍❤️‍💋‍🧑🏿',
            '🧑🏽‍❤️‍💋‍🧑🏻',
            '🧑🏽‍❤️‍💋‍🧑🏼',
            '🧑🏽‍❤️‍💋‍🧑🏾',
            '🧑🏽‍❤️‍💋‍🧑🏿',
            '🧑🏾‍❤️‍💋‍🧑🏻',
            '🧑🏾‍❤️‍💋‍🧑🏼',
            '🧑🏾‍❤️‍💋‍🧑🏽',
            '🧑🏾‍❤️‍💋‍🧑🏿',
            '🧑🏿‍❤️‍💋‍🧑🏻',
            '🧑🏿‍❤️‍💋‍🧑🏼',
            '🧑🏿‍❤️‍💋‍🧑🏽',
            '🧑🏿‍❤️‍💋‍🧑🏾'
        ],
        symbol: '💏',
        name: 'emoji-486',
        keyword: 'kiss couplekiss'
    },
    {
        versions: [
            '👩🏻‍❤️‍💋‍👨🏻',
            '👩🏻‍❤️‍💋‍👨🏼',
            '👩🏻‍❤️‍💋‍👨🏽',
            '👩🏻‍❤️‍💋‍👨🏾',
            '👩🏻‍❤️‍💋‍👨🏿',
            '👩🏼‍❤️‍💋‍👨🏻',
            '👩🏼‍❤️‍💋‍👨🏼',
            '👩🏼‍❤️‍💋‍👨🏽',
            '👩🏼‍❤️‍💋‍👨🏾',
            '👩🏼‍❤️‍💋‍👨🏿',
            '👩🏽‍❤️‍💋‍👨🏻',
            '👩🏽‍❤️‍💋‍👨🏼',
            '👩🏽‍❤️‍💋‍👨🏽',
            '👩🏽‍❤️‍💋‍👨🏾',
            '👩🏽‍❤️‍💋‍👨🏿',
            '👩🏾‍❤️‍💋‍👨🏻',
            '👩🏾‍❤️‍💋‍👨🏼',
            '👩🏾‍❤️‍💋‍👨🏽',
            '👩🏾‍❤️‍💋‍👨🏾',
            '👩🏾‍❤️‍💋‍👨🏿',
            '👩🏿‍❤️‍💋‍👨🏻',
            '👩🏿‍❤️‍💋‍👨🏼',
            '👩🏿‍❤️‍💋‍👨🏽',
            '👩🏿‍❤️‍💋‍👨🏾',
            '👩🏿‍❤️‍💋‍👨🏿'
        ],
        symbol: '👩‍❤️‍💋‍👨',
        name: 'emoji-487',
        keyword: 'woman-kiss-man kiss: woman, man'
    },
    {
        versions: [
            '👨🏻‍❤️‍💋‍👨🏻',
            '👨🏻‍❤️‍💋‍👨🏼',
            '👨🏻‍❤️‍💋‍👨🏽',
            '👨🏻‍❤️‍💋‍👨🏾',
            '👨🏻‍❤️‍💋‍👨🏿',
            '👨🏼‍❤️‍💋‍👨🏻',
            '👨🏼‍❤️‍💋‍👨🏼',
            '👨🏼‍❤️‍💋‍👨🏽',
            '👨🏼‍❤️‍💋‍👨🏾',
            '👨🏼‍❤️‍💋‍👨🏿',
            '👨🏽‍❤️‍💋‍👨🏻',
            '👨🏽‍❤️‍💋‍👨🏼',
            '👨🏽‍❤️‍💋‍👨🏽',
            '👨🏽‍❤️‍💋‍👨🏾',
            '👨🏽‍❤️‍💋‍👨🏿',
            '👨🏾‍❤️‍💋‍👨🏻',
            '👨🏾‍❤️‍💋‍👨🏼',
            '👨🏾‍❤️‍💋‍👨🏽',
            '👨🏾‍❤️‍💋‍👨🏾',
            '👨🏾‍❤️‍💋‍👨🏿',
            '👨🏿‍❤️‍💋‍👨🏻',
            '👨🏿‍❤️‍💋‍👨🏼',
            '👨🏿‍❤️‍💋‍👨🏽',
            '👨🏿‍❤️‍💋‍👨🏾',
            '👨🏿‍❤️‍💋‍👨🏿'
        ],
        symbol: '👨‍❤️‍💋‍👨',
        name: 'emoji-488',
        keyword: 'man-kiss-man kiss: man, man'
    },
    {
        versions: [
            '👩🏻‍❤️‍💋‍👩🏻',
            '👩🏻‍❤️‍💋‍👩🏼',
            '👩🏻‍❤️‍💋‍👩🏽',
            '👩🏻‍❤️‍💋‍👩🏾',
            '👩🏻‍❤️‍💋‍👩🏿',
            '👩🏼‍❤️‍💋‍👩🏻',
            '👩🏼‍❤️‍💋‍👩🏼',
            '👩🏼‍❤️‍💋‍👩🏽',
            '👩🏼‍❤️‍💋‍👩🏾',
            '👩🏼‍❤️‍💋‍👩🏿',
            '👩🏽‍❤️‍💋‍👩🏻',
            '👩🏽‍❤️‍💋‍👩🏼',
            '👩🏽‍❤️‍💋‍👩🏽',
            '👩🏽‍❤️‍💋‍👩🏾',
            '👩🏽‍❤️‍💋‍👩🏿',
            '👩🏾‍❤️‍💋‍👩🏻',
            '👩🏾‍❤️‍💋‍👩🏼',
            '👩🏾‍❤️‍💋‍👩🏽',
            '👩🏾‍❤️‍💋‍👩🏾',
            '👩🏾‍❤️‍💋‍👩🏿',
            '👩🏿‍❤️‍💋‍👩🏻',
            '👩🏿‍❤️‍💋‍👩🏼',
            '👩🏿‍❤️‍💋‍👩🏽',
            '👩🏿‍❤️‍💋‍👩🏾',
            '👩🏿‍❤️‍💋‍👩🏿'
        ],
        symbol: '👩‍❤️‍💋‍👩',
        name: 'emoji-489',
        keyword: 'woman-kiss-woman kiss: woman, woman'
    },
    {
        versions: [
            '💑🏻',
            '💑🏼',
            '💑🏽',
            '💑🏾',
            '💑🏿',
            '🧑🏻‍❤️‍🧑🏼',
            '🧑🏻‍❤️‍🧑🏽',
            '🧑🏻‍❤️‍🧑🏾',
            '🧑🏻‍❤️‍🧑🏿',
            '🧑🏼‍❤️‍🧑🏻',
            '🧑🏼‍❤️‍🧑🏽',
            '🧑🏼‍❤️‍🧑🏾',
            '🧑🏼‍❤️‍🧑🏿',
            '🧑🏽‍❤️‍🧑🏻',
            '🧑🏽‍❤️‍🧑🏼',
            '🧑🏽‍❤️‍🧑🏾',
            '🧑🏽‍❤️‍🧑🏿',
            '🧑🏾‍❤️‍🧑🏻',
            '🧑🏾‍❤️‍🧑🏼',
            '🧑🏾‍❤️‍🧑🏽',
            '🧑🏾‍❤️‍🧑🏿',
            '🧑🏿‍❤️‍🧑🏻',
            '🧑🏿‍❤️‍🧑🏼',
            '🧑🏿‍❤️‍🧑🏽',
            '🧑🏿‍❤️‍🧑🏾'
        ],
        symbol: '💑',
        name: 'emoji-490',
        keyword: 'couple with heart'
    },
    {
        versions: [
            '👩🏻‍❤️‍👨🏻',
            '👩🏻‍❤️‍👨🏼',
            '👩🏻‍❤️‍👨🏽',
            '👩🏻‍❤️‍👨🏾',
            '👩🏻‍❤️‍👨🏿',
            '👩🏼‍❤️‍👨🏻',
            '👩🏼‍❤️‍👨🏼',
            '👩🏼‍❤️‍👨🏽',
            '👩🏼‍❤️‍👨🏾',
            '👩🏼‍❤️‍👨🏿',
            '👩🏽‍❤️‍👨🏻',
            '👩🏽‍❤️‍👨🏼',
            '👩🏽‍❤️‍👨🏽',
            '👩🏽‍❤️‍👨🏾',
            '👩🏽‍❤️‍👨🏿',
            '👩🏾‍❤️‍👨🏻',
            '👩🏾‍❤️‍👨🏼',
            '👩🏾‍❤️‍👨🏽',
            '👩🏾‍❤️‍👨🏾',
            '👩🏾‍❤️‍👨🏿',
            '👩🏿‍❤️‍👨🏻',
            '👩🏿‍❤️‍👨🏼',
            '👩🏿‍❤️‍👨🏽',
            '👩🏿‍❤️‍👨🏾',
            '👩🏿‍❤️‍👨🏿'
        ],
        symbol: '👩‍❤️‍👨',
        name: 'emoji-491',
        keyword: 'woman-heart-man couple with heart: woman, man'
    },
    {
        versions: [
            '👨🏻‍❤️‍👨🏻',
            '👨🏻‍❤️‍👨🏼',
            '👨🏻‍❤️‍👨🏽',
            '👨🏻‍❤️‍👨🏾',
            '👨🏻‍❤️‍👨🏿',
            '👨🏼‍❤️‍👨🏻',
            '👨🏼‍❤️‍👨🏼',
            '👨🏼‍❤️‍👨🏽',
            '👨🏼‍❤️‍👨🏾',
            '👨🏼‍❤️‍👨🏿',
            '👨🏽‍❤️‍👨🏻',
            '👨🏽‍❤️‍👨🏼',
            '👨🏽‍❤️‍👨🏽',
            '👨🏽‍❤️‍👨🏾',
            '👨🏽‍❤️‍👨🏿',
            '👨🏾‍❤️‍👨🏻',
            '👨🏾‍❤️‍👨🏼',
            '👨🏾‍❤️‍👨🏽',
            '👨🏾‍❤️‍👨🏾',
            '👨🏾‍❤️‍👨🏿',
            '👨🏿‍❤️‍👨🏻',
            '👨🏿‍❤️‍👨🏼',
            '👨🏿‍❤️‍👨🏽',
            '👨🏿‍❤️‍👨🏾',
            '👨🏿‍❤️‍👨🏿'
        ],
        symbol: '👨‍❤️‍👨',
        name: 'emoji-492',
        keyword: 'man-heart-man couple with heart: man, man'
    },
    {
        versions: [
            '👩🏻‍❤️‍👩🏻',
            '👩🏻‍❤️‍👩🏼',
            '👩🏻‍❤️‍👩🏽',
            '👩🏻‍❤️‍👩🏾',
            '👩🏻‍❤️‍👩🏿',
            '👩🏼‍❤️‍👩🏻',
            '👩🏼‍❤️‍👩🏼',
            '👩🏼‍❤️‍👩🏽',
            '👩🏼‍❤️‍👩🏾',
            '👩🏼‍❤️‍👩🏿',
            '👩🏽‍❤️‍👩🏻',
            '👩🏽‍❤️‍👩🏼',
            '👩🏽‍❤️‍👩🏽',
            '👩🏽‍❤️‍👩🏾',
            '👩🏽‍❤️‍👩🏿',
            '👩🏾‍❤️‍👩🏻',
            '👩🏾‍❤️‍👩🏼',
            '👩🏾‍❤️‍👩🏽',
            '👩🏾‍❤️‍👩🏾',
            '👩🏾‍❤️‍👩🏿',
            '👩🏿‍❤️‍👩🏻',
            '👩🏿‍❤️‍👩🏼',
            '👩🏿‍❤️‍👩🏽',
            '👩🏿‍❤️‍👩🏾',
            '👩🏿‍❤️‍👩🏿'
        ],
        symbol: '👩‍❤️‍👩',
        name: 'emoji-493',
        keyword: 'woman-heart-woman couple with heart: woman, woman'
    },
    {
        symbol: '👪',
        name: 'emoji-494',
        keyword: 'family'
    },
    {
        symbol: '👨‍👩‍👦',
        name: 'emoji-495',
        keyword: 'man-woman-boy family: man, woman, boy'
    },
    {
        symbol: '👨‍👩‍👧',
        name: 'emoji-496',
        keyword: 'man-woman-girl family: man, woman, girl'
    },
    {
        symbol: '👨‍👩‍👧‍👦',
        name: 'emoji-497',
        keyword: 'man-woman-girl-boy family: man, woman, girl, boy'
    },
    {
        symbol: '👨‍👩‍👦‍👦',
        name: 'emoji-498',
        keyword: 'man-woman-boy-boy family: man, woman, boy, boy'
    },
    {
        symbol: '👨‍👩‍👧‍👧',
        name: 'emoji-499',
        keyword: 'man-woman-girl-girl family: man, woman, girl, girl'
    },
    {
        symbol: '👨‍👨‍👦',
        name: 'emoji-500',
        keyword: 'man-man-boy family: man, man, boy'
    },
    {
        symbol: '👨‍👨‍👧',
        name: 'emoji-501',
        keyword: 'man-man-girl family: man, man, girl'
    },
    {
        symbol: '👨‍👨‍👧‍👦',
        name: 'emoji-502',
        keyword: 'man-man-girl-boy family: man, man, girl, boy'
    },
    {
        symbol: '👨‍👨‍👦‍👦',
        name: 'emoji-503',
        keyword: 'man-man-boy-boy family: man, man, boy, boy'
    },
    {
        symbol: '👨‍👨‍👧‍👧',
        name: 'emoji-504',
        keyword: 'man-man-girl-girl family: man, man, girl, girl'
    },
    {
        symbol: '👩‍👩‍👦',
        name: 'emoji-505',
        keyword: 'woman-woman-boy family: woman, woman, boy'
    },
    {
        symbol: '👩‍👩‍👧',
        name: 'emoji-506',
        keyword: 'woman-woman-girl family: woman, woman, girl'
    },
    {
        symbol: '👩‍👩‍👧‍👦',
        name: 'emoji-507',
        keyword: 'woman-woman-girl-boy family: woman, woman, girl, boy'
    },
    {
        symbol: '👩‍👩‍👦‍👦',
        name: 'emoji-508',
        keyword: 'woman-woman-boy-boy family: woman, woman, boy, boy'
    },
    {
        symbol: '👩‍👩‍👧‍👧',
        name: 'emoji-509',
        keyword: 'woman-woman-girl-girl family: woman, woman, girl, girl'
    },
    {
        symbol: '👨‍👦',
        name: 'emoji-510',
        keyword: 'man-boy family: man, boy'
    },
    {
        symbol: '👨‍👦‍👦',
        name: 'emoji-511',
        keyword: 'man-boy-boy family: man, boy, boy'
    },
    {
        symbol: '👨‍👧',
        name: 'emoji-512',
        keyword: 'man-girl family: man, girl'
    },
    {
        symbol: '👨‍👧‍👦',
        name: 'emoji-513',
        keyword: 'man-girl-boy family: man, girl, boy'
    },
    {
        symbol: '👨‍👧‍👧',
        name: 'emoji-514',
        keyword: 'man-girl-girl family: man, girl, girl'
    },
    {
        symbol: '👩‍👦',
        name: 'emoji-515',
        keyword: 'woman-boy family: woman, boy'
    },
    {
        symbol: '👩‍👦‍👦',
        name: 'emoji-516',
        keyword: 'woman-boy-boy family: woman, boy, boy'
    },
    {
        symbol: '👩‍👧',
        name: 'emoji-517',
        keyword: 'woman-girl family: woman, girl'
    },
    {
        symbol: '👩‍👧‍👦',
        name: 'emoji-518',
        keyword: 'woman-girl-boy family: woman, girl, boy'
    },
    {
        symbol: '👩‍👧‍👧',
        name: 'emoji-519',
        keyword: 'woman-girl-girl family: woman, girl, girl'
    },
    {
        symbol: '🗣️',
        name: 'emoji-520',
        keyword: 'speaking head speaking head in silhouette'
    },
    {
        symbol: '👤',
        name: 'emoji-521',
        keyword: 'bust in silhouette'
    },
    {
        symbol: '👥',
        name: 'emoji-522',
        keyword: 'busts in silhouette'
    },
    {
        symbol: '🫂',
        name: 'emoji-523',
        keyword: 'people hugging'
    },
    {
        symbol: '👣',
        name: 'emoji-524',
        keyword: 'footprints'
    },
    {
        symbol: '🐵',
        name: 'emoji-525',
        keyword: 'monkey face'
    },
    {
        symbol: '🐒',
        name: 'emoji-526',
        keyword: 'monkey'
    },
    {
        symbol: '🦍',
        name: 'emoji-527',
        keyword: 'gorilla'
    },
    {
        symbol: '🦧',
        name: 'emoji-528',
        keyword: 'orangutan'
    },
    {
        symbol: '🐶',
        name: 'emoji-529',
        keyword: 'dog dog face'
    },
    {
        symbol: '🐕',
        name: 'emoji-530',
        keyword: 'dog dog2'
    },
    {
        symbol: '🦮',
        name: 'emoji-531',
        keyword: 'guide dog'
    },
    {
        symbol: '🐕‍🦺',
        name: 'emoji-532',
        keyword: 'service dog'
    },
    {
        symbol: '🐩',
        name: 'emoji-533',
        keyword: 'poodle'
    },
    {
        symbol: '🐺',
        name: 'emoji-534',
        keyword: 'wolf wolf face'
    },
    {
        symbol: '🦊',
        name: 'emoji-535',
        keyword: 'fox face'
    },
    {
        symbol: '🦝',
        name: 'emoji-536',
        keyword: 'raccoon'
    },
    {
        symbol: '🐱',
        name: 'emoji-537',
        keyword: 'cat cat face'
    },
    {
        symbol: '🐈',
        name: 'emoji-538',
        keyword: 'cat cat2'
    },
    {
        symbol: '🐈‍⬛',
        name: 'emoji-539',
        keyword: 'black cat'
    },
    {
        symbol: '🦁',
        name: 'emoji-540',
        keyword: 'lion face'
    },
    {
        symbol: '🐯',
        name: 'emoji-541',
        keyword: 'tiger tiger face'
    },
    {
        symbol: '🐅',
        name: 'emoji-542',
        keyword: 'tiger tiger2'
    },
    {
        symbol: '🐆',
        name: 'emoji-543',
        keyword: 'leopard'
    },
    {
        symbol: '🐴',
        name: 'emoji-544',
        keyword: 'horse horse face'
    },
    {
        symbol: '🐎',
        name: 'emoji-545',
        keyword: 'horse racehorse'
    },
    {
        symbol: '🦄',
        name: 'emoji-546',
        keyword: 'unicorn face'
    },
    {
        symbol: '🦓',
        name: 'emoji-547',
        keyword: 'zebra face'
    },
    {
        symbol: '🦌',
        name: 'emoji-548',
        keyword: 'deer'
    },
    {
        symbol: '🦬',
        name: 'emoji-549',
        keyword: 'bison'
    },
    {
        symbol: '🐮',
        name: 'emoji-550',
        keyword: 'cow cow face'
    },
    {
        symbol: '🐂',
        name: 'emoji-551',
        keyword: 'ox'
    },
    {
        symbol: '🐃',
        name: 'emoji-552',
        keyword: 'water buffalo'
    },
    {
        symbol: '🐄',
        name: 'emoji-553',
        keyword: 'cow cow2'
    },
    {
        symbol: '🐷',
        name: 'emoji-554',
        keyword: 'pig pig face'
    },
    {
        symbol: '🐖',
        name: 'emoji-555',
        keyword: 'pig pig2'
    },
    {
        symbol: '🐗',
        name: 'emoji-556',
        keyword: 'boar'
    },
    {
        symbol: '🐽',
        name: 'emoji-557',
        keyword: 'pig nose'
    },
    {
        symbol: '🐏',
        name: 'emoji-558',
        keyword: 'ram'
    },
    {
        symbol: '🐑',
        name: 'emoji-559',
        keyword: 'sheep'
    },
    {
        symbol: '🐐',
        name: 'emoji-560',
        keyword: 'goat'
    },
    {
        symbol: '🐪',
        name: 'emoji-561',
        keyword: 'dromedary camel'
    },
    {
        symbol: '🐫',
        name: 'emoji-562',
        keyword: 'camel bactrian camel'
    },
    {
        symbol: '🦙',
        name: 'emoji-563',
        keyword: 'llama'
    },
    {
        symbol: '🦒',
        name: 'emoji-564',
        keyword: 'giraffe face'
    },
    {
        symbol: '🐘',
        name: 'emoji-565',
        keyword: 'elephant'
    },
    {
        symbol: '🦣',
        name: 'emoji-566',
        keyword: 'mammoth'
    },
    {
        symbol: '🦏',
        name: 'emoji-567',
        keyword: 'rhinoceros'
    },
    {
        symbol: '🦛',
        name: 'emoji-568',
        keyword: 'hippopotamus'
    },
    {
        symbol: '🐭',
        name: 'emoji-569',
        keyword: 'mouse mouse face'
    },
    {
        symbol: '🐁',
        name: 'emoji-570',
        keyword: 'mouse mouse2'
    },
    {
        symbol: '🐀',
        name: 'emoji-571',
        keyword: 'rat'
    },
    {
        symbol: '🐹',
        name: 'emoji-572',
        keyword: 'hamster hamster face'
    },
    {
        symbol: '🐰',
        name: 'emoji-573',
        keyword: 'rabbit rabbit face'
    },
    {
        symbol: '🐇',
        name: 'emoji-574',
        keyword: 'rabbit rabbit2'
    },
    {
        symbol: '🐿️',
        name: 'emoji-575',
        keyword: 'chipmunk'
    },
    {
        symbol: '🦫',
        name: 'emoji-576',
        keyword: 'beaver'
    },
    {
        symbol: '🦔',
        name: 'emoji-577',
        keyword: 'hedgehog'
    },
    {
        symbol: '🦇',
        name: 'emoji-578',
        keyword: 'bat'
    },
    {
        symbol: '🐻',
        name: 'emoji-579',
        keyword: 'bear bear face'
    },
    {
        symbol: '🐻‍❄️',
        name: 'emoji-580',
        keyword: 'polar bear'
    },
    {
        symbol: '🐨',
        name: 'emoji-581',
        keyword: 'koala'
    },
    {
        symbol: '🐼',
        name: 'emoji-582',
        keyword: 'panda face'
    },
    {
        symbol: '🦥',
        name: 'emoji-583',
        keyword: 'sloth'
    },
    {
        symbol: '🦦',
        name: 'emoji-584',
        keyword: 'otter'
    },
    {
        symbol: '🦨',
        name: 'emoji-585',
        keyword: 'skunk'
    },
    {
        symbol: '🦘',
        name: 'emoji-586',
        keyword: 'kangaroo'
    },
    {
        symbol: '🦡',
        name: 'emoji-587',
        keyword: 'badger'
    },
    {
        symbol: '🐾',
        name: 'emoji-588',
        keyword: 'feet paw prints'
    },
    {
        symbol: '🦃',
        name: 'emoji-589',
        keyword: 'turkey'
    },
    {
        symbol: '🐔',
        name: 'emoji-590',
        keyword: 'chicken'
    },
    {
        symbol: '🐓',
        name: 'emoji-591',
        keyword: 'rooster'
    },
    {
        symbol: '🐣',
        name: 'emoji-592',
        keyword: 'hatching chick'
    },
    {
        symbol: '🐤',
        name: 'emoji-593',
        keyword: 'baby chick'
    },
    {
        symbol: '🐥',
        name: 'emoji-594',
        keyword: 'hatched chick front-facing baby chick'
    },
    {
        symbol: '🐦',
        name: 'emoji-595',
        keyword: 'bird'
    },
    {
        symbol: '🐧',
        name: 'emoji-596',
        keyword: 'penguin'
    },
    {
        symbol: '🕊️',
        name: 'emoji-597',
        keyword: 'dove dove of peace'
    },
    {
        symbol: '🦅',
        name: 'emoji-598',
        keyword: 'eagle'
    },
    {
        symbol: '🦆',
        name: 'emoji-599',
        keyword: 'duck'
    },
    {
        symbol: '🦢',
        name: 'emoji-600',
        keyword: 'swan'
    },
    {
        symbol: '🦉',
        name: 'emoji-601',
        keyword: 'owl'
    },
    {
        symbol: '🦤',
        name: 'emoji-602',
        keyword: 'dodo'
    },
    {
        symbol: '🪶',
        name: 'emoji-603',
        keyword: 'feather'
    },
    {
        symbol: '🦩',
        name: 'emoji-604',
        keyword: 'flamingo'
    },
    {
        symbol: '🦚',
        name: 'emoji-605',
        keyword: 'peacock'
    },
    {
        symbol: '🦜',
        name: 'emoji-606',
        keyword: 'parrot'
    },
    {
        symbol: '🐸',
        name: 'emoji-607',
        keyword: 'frog frog face'
    },
    {
        symbol: '🐊',
        name: 'emoji-608',
        keyword: 'crocodile'
    },
    {
        symbol: '🐢',
        name: 'emoji-609',
        keyword: 'turtle'
    },
    {
        symbol: '🦎',
        name: 'emoji-610',
        keyword: 'lizard'
    },
    {
        symbol: '🐍',
        name: 'emoji-611',
        keyword: 'snake'
    },
    {
        symbol: '🐲',
        name: 'emoji-612',
        keyword: 'dragon face'
    },
    {
        symbol: '🐉',
        name: 'emoji-613',
        keyword: 'dragon'
    },
    {
        symbol: '🦕',
        name: 'emoji-614',
        keyword: 'sauropod'
    },
    {
        symbol: '🦖',
        name: 'emoji-615',
        keyword: 't-rex'
    },
    {
        symbol: '🐳',
        name: 'emoji-616',
        keyword: 'whale spouting whale'
    },
    {
        symbol: '🐋',
        name: 'emoji-617',
        keyword: 'whale whale2'
    },
    {
        symbol: '🐬',
        name: 'emoji-618',
        keyword: 'dolphin flipper'
    },
    {
        symbol: '🦭',
        name: 'emoji-619',
        keyword: 'seal'
    },
    {
        symbol: '🐟',
        name: 'emoji-620',
        keyword: 'fish'
    },
    {
        symbol: '🐠',
        name: 'emoji-621',
        keyword: 'tropical fish'
    },
    {
        symbol: '🐡',
        name: 'emoji-622',
        keyword: 'blowfish'
    },
    {
        symbol: '🦈',
        name: 'emoji-623',
        keyword: 'shark'
    },
    {
        symbol: '🐙',
        name: 'emoji-624',
        keyword: 'octopus'
    },
    {
        symbol: '🐚',
        name: 'emoji-625',
        keyword: 'shell spiral shell'
    },
    {
        symbol: '🪸',
        name: 'emoji-626',
        keyword: 'coral'
    },
    {
        symbol: '🐌',
        name: 'emoji-627',
        keyword: 'snail'
    },
    {
        symbol: '🦋',
        name: 'emoji-628',
        keyword: 'butterfly'
    },
    {
        symbol: '🐛',
        name: 'emoji-629',
        keyword: 'bug'
    },
    {
        symbol: '🐜',
        name: 'emoji-630',
        keyword: 'ant'
    },
    {
        symbol: '🐝',
        name: 'emoji-631',
        keyword: 'bee honeybee'
    },
    {
        symbol: '🪲',
        name: 'emoji-632',
        keyword: 'beetle'
    },
    {
        symbol: '🐞',
        name: 'emoji-633',
        keyword: 'ladybug lady beetle'
    },
    {
        symbol: '🦗',
        name: 'emoji-634',
        keyword: 'cricket'
    },
    {
        symbol: '🪳',
        name: 'emoji-635',
        keyword: 'cockroach'
    },
    {
        symbol: '🕷️',
        name: 'emoji-636',
        keyword: 'spider'
    },
    {
        symbol: '🕸️',
        name: 'emoji-637',
        keyword: 'spider web'
    },
    {
        symbol: '🦂',
        name: 'emoji-638',
        keyword: 'scorpion'
    },
    {
        symbol: '🦟',
        name: 'emoji-639',
        keyword: 'mosquito'
    },
    {
        symbol: '🪰',
        name: 'emoji-640',
        keyword: 'fly'
    },
    {
        symbol: '🪱',
        name: 'emoji-641',
        keyword: 'worm'
    },
    {
        symbol: '🦠',
        name: 'emoji-642',
        keyword: 'microbe'
    },
    {
        symbol: '💐',
        name: 'emoji-643',
        keyword: 'bouquet'
    },
    {
        symbol: '🌸',
        name: 'emoji-644',
        keyword: 'cherry blossom'
    },
    {
        symbol: '💮',
        name: 'emoji-645',
        keyword: 'white flower'
    },
    {
        symbol: '🪷',
        name: 'emoji-646',
        keyword: 'lotus'
    },
    {
        symbol: '🏵️',
        name: 'emoji-647',
        keyword: 'rosette'
    },
    {
        symbol: '🌹',
        name: 'emoji-648',
        keyword: 'rose'
    },
    {
        symbol: '🥀',
        name: 'emoji-649',
        keyword: 'wilted flower'
    },
    {
        symbol: '🌺',
        name: 'emoji-650',
        keyword: 'hibiscus'
    },
    {
        symbol: '🌻',
        name: 'emoji-651',
        keyword: 'sunflower'
    },
    {
        symbol: '🌼',
        name: 'emoji-652',
        keyword: 'blossom'
    },
    {
        symbol: '🌷',
        name: 'emoji-653',
        keyword: 'tulip'
    },
    {
        symbol: '🌱',
        name: 'emoji-654',
        keyword: 'seedling'
    },
    {
        symbol: '🪴',
        name: 'emoji-655',
        keyword: 'potted plant'
    },
    {
        symbol: '🌲',
        name: 'emoji-656',
        keyword: 'evergreen tree'
    },
    {
        symbol: '🌳',
        name: 'emoji-657',
        keyword: 'deciduous tree'
    },
    {
        symbol: '🌴',
        name: 'emoji-658',
        keyword: 'palm tree'
    },
    {
        symbol: '🌵',
        name: 'emoji-659',
        keyword: 'cactus'
    },
    {
        symbol: '🌾',
        name: 'emoji-660',
        keyword: 'ear of rice'
    },
    {
        symbol: '🌿',
        name: 'emoji-661',
        keyword: 'herb'
    },
    {
        symbol: '☘️',
        name: 'emoji-662',
        keyword: 'shamrock'
    },
    {
        symbol: '🍀',
        name: 'emoji-663',
        keyword: 'four leaf clover'
    },
    {
        symbol: '🍁',
        name: 'emoji-664',
        keyword: 'maple leaf'
    },
    {
        symbol: '🍂',
        name: 'emoji-665',
        keyword: 'fallen leaf'
    },
    {
        symbol: '🍃',
        name: 'emoji-666',
        keyword: 'leaves leaf fluttering in wind'
    },
    {
        symbol: '🪹',
        name: 'emoji-667',
        keyword: 'empty nest'
    },
    {
        symbol: '🪺',
        name: 'emoji-668',
        keyword: 'nest with eggs'
    },
    {
        symbol: '🍇',
        name: 'emoji-669',
        keyword: 'grapes'
    },
    {
        symbol: '🍈',
        name: 'emoji-670',
        keyword: 'melon'
    },
    {
        symbol: '🍉',
        name: 'emoji-671',
        keyword: 'watermelon'
    },
    {
        symbol: '🍊',
        name: 'emoji-672',
        keyword: 'tangerine'
    },
    {
        symbol: '🍋',
        name: 'emoji-673',
        keyword: 'lemon'
    },
    {
        symbol: '🍌',
        name: 'emoji-674',
        keyword: 'banana'
    },
    {
        symbol: '🍍',
        name: 'emoji-675',
        keyword: 'pineapple'
    },
    {
        symbol: '🥭',
        name: 'emoji-676',
        keyword: 'mango'
    },
    {
        symbol: '🍎',
        name: 'emoji-677',
        keyword: 'apple red apple'
    },
    {
        symbol: '🍏',
        name: 'emoji-678',
        keyword: 'green apple'
    },
    {
        symbol: '🍐',
        name: 'emoji-679',
        keyword: 'pear'
    },
    {
        symbol: '🍑',
        name: 'emoji-680',
        keyword: 'peach'
    },
    {
        symbol: '🍒',
        name: 'emoji-681',
        keyword: 'cherries'
    },
    {
        symbol: '🍓',
        name: 'emoji-682',
        keyword: 'strawberry'
    },
    {
        symbol: '🫐',
        name: 'emoji-683',
        keyword: 'blueberries'
    },
    {
        symbol: '🥝',
        name: 'emoji-684',
        keyword: 'kiwifruit'
    },
    {
        symbol: '🍅',
        name: 'emoji-685',
        keyword: 'tomato'
    },
    {
        symbol: '🫒',
        name: 'emoji-686',
        keyword: 'olive'
    },
    {
        symbol: '🥥',
        name: 'emoji-687',
        keyword: 'coconut'
    },
    {
        symbol: '🥑',
        name: 'emoji-688',
        keyword: 'avocado'
    },
    {
        symbol: '🍆',
        name: 'emoji-689',
        keyword: 'eggplant aubergine'
    },
    {
        symbol: '🥔',
        name: 'emoji-690',
        keyword: 'potato'
    },
    {
        symbol: '🥕',
        name: 'emoji-691',
        keyword: 'carrot'
    },
    {
        symbol: '🌽',
        name: 'emoji-692',
        keyword: 'corn ear of maize'
    },
    {
        symbol: '🌶️',
        name: 'emoji-693',
        keyword: 'hot pepper'
    },
    {
        symbol: '🫑',
        name: 'emoji-694',
        keyword: 'bell pepper'
    },
    {
        symbol: '🥒',
        name: 'emoji-695',
        keyword: 'cucumber'
    },
    {
        symbol: '🥬',
        name: 'emoji-696',
        keyword: 'leafy green'
    },
    {
        symbol: '🥦',
        name: 'emoji-697',
        keyword: 'broccoli'
    },
    {
        symbol: '🧄',
        name: 'emoji-698',
        keyword: 'garlic'
    },
    {
        symbol: '🧅',
        name: 'emoji-699',
        keyword: 'onion'
    },
    {
        symbol: '🍄',
        name: 'emoji-700',
        keyword: 'mushroom'
    },
    {
        symbol: '🥜',
        name: 'emoji-701',
        keyword: 'peanuts'
    },
    {
        symbol: '🫘',
        name: 'emoji-702',
        keyword: 'beans'
    },
    {
        symbol: '🌰',
        name: 'emoji-703',
        keyword: 'chestnut'
    },
    {
        symbol: '🍞',
        name: 'emoji-704',
        keyword: 'bread'
    },
    {
        symbol: '🥐',
        name: 'emoji-705',
        keyword: 'croissant'
    },
    {
        symbol: '🥖',
        name: 'emoji-706',
        keyword: 'baguette bread'
    },
    {
        symbol: '🫓',
        name: 'emoji-707',
        keyword: 'flatbread'
    },
    {
        symbol: '🥨',
        name: 'emoji-708',
        keyword: 'pretzel'
    },
    {
        symbol: '🥯',
        name: 'emoji-709',
        keyword: 'bagel'
    },
    {
        symbol: '🥞',
        name: 'emoji-710',
        keyword: 'pancakes'
    },
    {
        symbol: '🧇',
        name: 'emoji-711',
        keyword: 'waffle'
    },
    {
        symbol: '🧀',
        name: 'emoji-712',
        keyword: 'cheese wedge'
    },
    {
        symbol: '🍖',
        name: 'emoji-713',
        keyword: 'meat on bone'
    },
    {
        symbol: '🍗',
        name: 'emoji-714',
        keyword: 'poultry leg'
    },
    {
        symbol: '🥩',
        name: 'emoji-715',
        keyword: 'cut of meat'
    },
    {
        symbol: '🥓',
        name: 'emoji-716',
        keyword: 'bacon'
    },
    {
        symbol: '🍔',
        name: 'emoji-717',
        keyword: 'hamburger'
    },
    {
        symbol: '🍟',
        name: 'emoji-718',
        keyword: 'fries french fries'
    },
    {
        symbol: '🍕',
        name: 'emoji-719',
        keyword: 'pizza slice of pizza'
    },
    {
        symbol: '🌭',
        name: 'emoji-720',
        keyword: 'hotdog hot dog'
    },
    {
        symbol: '🥪',
        name: 'emoji-721',
        keyword: 'sandwich'
    },
    {
        symbol: '🌮',
        name: 'emoji-722',
        keyword: 'taco'
    },
    {
        symbol: '🌯',
        name: 'emoji-723',
        keyword: 'burrito'
    },
    {
        symbol: '🫔',
        name: 'emoji-724',
        keyword: 'tamale'
    },
    {
        symbol: '🥙',
        name: 'emoji-725',
        keyword: 'stuffed flatbread'
    },
    {
        symbol: '🧆',
        name: 'emoji-726',
        keyword: 'falafel'
    },
    {
        symbol: '🥚',
        name: 'emoji-727',
        keyword: 'egg'
    },
    {
        symbol: '🍳',
        name: 'emoji-728',
        keyword: 'cooking fried egg'
    },
    {
        symbol: '🥘',
        name: 'emoji-729',
        keyword: 'shallow pan of food'
    },
    {
        symbol: '🍲',
        name: 'emoji-730',
        keyword: 'stew pot of food'
    },
    {
        symbol: '🫕',
        name: 'emoji-731',
        keyword: 'fondue'
    },
    {
        symbol: '🥣',
        name: 'emoji-732',
        keyword: 'bowl with spoon'
    },
    {
        symbol: '🥗',
        name: 'emoji-733',
        keyword: 'green salad'
    },
    {
        symbol: '🍿',
        name: 'emoji-734',
        keyword: 'popcorn'
    },
    {
        symbol: '🧈',
        name: 'emoji-735',
        keyword: 'butter'
    },
    {
        symbol: '🧂',
        name: 'emoji-736',
        keyword: 'salt salt shaker'
    },
    {
        symbol: '🥫',
        name: 'emoji-737',
        keyword: 'canned food'
    },
    {
        symbol: '🍱',
        name: 'emoji-738',
        keyword: 'bento bento box'
    },
    {
        symbol: '🍘',
        name: 'emoji-739',
        keyword: 'rice cracker'
    },
    {
        symbol: '🍙',
        name: 'emoji-740',
        keyword: 'rice ball'
    },
    {
        symbol: '🍚',
        name: 'emoji-741',
        keyword: 'rice cooked rice'
    },
    {
        symbol: '🍛',
        name: 'emoji-742',
        keyword: 'curry curry and rice'
    },
    {
        symbol: '🍜',
        name: 'emoji-743',
        keyword: 'ramen steaming bowl'
    },
    {
        symbol: '🍝',
        name: 'emoji-744',
        keyword: 'spaghetti'
    },
    {
        symbol: '🍠',
        name: 'emoji-745',
        keyword: 'sweet potato roasted sweet potato'
    },
    {
        symbol: '🍢',
        name: 'emoji-746',
        keyword: 'oden'
    },
    {
        symbol: '🍣',
        name: 'emoji-747',
        keyword: 'sushi'
    },
    {
        symbol: '🍤',
        name: 'emoji-748',
        keyword: 'fried shrimp'
    },
    {
        symbol: '🍥',
        name: 'emoji-749',
        keyword: 'fish cake fish cake with swirl design'
    },
    {
        symbol: '🥮',
        name: 'emoji-750',
        keyword: 'moon cake'
    },
    {
        symbol: '🍡',
        name: 'emoji-751',
        keyword: 'dango'
    },
    {
        symbol: '🥟',
        name: 'emoji-752',
        keyword: 'dumpling'
    },
    {
        symbol: '🥠',
        name: 'emoji-753',
        keyword: 'fortune cookie'
    },
    {
        symbol: '🥡',
        name: 'emoji-754',
        keyword: 'takeout box'
    },
    {
        symbol: '🦀',
        name: 'emoji-755',
        keyword: 'crab'
    },
    {
        symbol: '🦞',
        name: 'emoji-756',
        keyword: 'lobster'
    },
    {
        symbol: '🦐',
        name: 'emoji-757',
        keyword: 'shrimp'
    },
    {
        symbol: '🦑',
        name: 'emoji-758',
        keyword: 'squid'
    },
    {
        symbol: '🦪',
        name: 'emoji-759',
        keyword: 'oyster'
    },
    {
        symbol: '🍦',
        name: 'emoji-760',
        keyword: 'icecream soft ice cream'
    },
    {
        symbol: '🍧',
        name: 'emoji-761',
        keyword: 'shaved ice'
    },
    {
        symbol: '🍨',
        name: 'emoji-762',
        keyword: 'ice cream'
    },
    {
        symbol: '🍩',
        name: 'emoji-763',
        keyword: 'doughnut'
    },
    {
        symbol: '🍪',
        name: 'emoji-764',
        keyword: 'cookie'
    },
    {
        symbol: '🎂',
        name: 'emoji-765',
        keyword: 'birthday birthday cake'
    },
    {
        symbol: '🍰',
        name: 'emoji-766',
        keyword: 'cake shortcake'
    },
    {
        symbol: '🧁',
        name: 'emoji-767',
        keyword: 'cupcake'
    },
    {
        symbol: '🥧',
        name: 'emoji-768',
        keyword: 'pie'
    },
    {
        symbol: '🍫',
        name: 'emoji-769',
        keyword: 'chocolate bar'
    },
    {
        symbol: '🍬',
        name: 'emoji-770',
        keyword: 'candy'
    },
    {
        symbol: '🍭',
        name: 'emoji-771',
        keyword: 'lollipop'
    },
    {
        symbol: '🍮',
        name: 'emoji-772',
        keyword: 'custard'
    },
    {
        symbol: '🍯',
        name: 'emoji-773',
        keyword: 'honey pot'
    },
    {
        symbol: '🍼',
        name: 'emoji-774',
        keyword: 'baby bottle'
    },
    {
        symbol: '🥛',
        name: 'emoji-775',
        keyword: 'glass of milk'
    },
    {
        symbol: '☕',
        name: 'emoji-776',
        keyword: 'coffee hot beverage'
    },
    {
        symbol: '🫖',
        name: 'emoji-777',
        keyword: 'teapot'
    },
    {
        symbol: '🍵',
        name: 'emoji-778',
        keyword: 'tea teacup without handle'
    },
    {
        symbol: '🍶',
        name: 'emoji-779',
        keyword: 'sake sake bottle and cup'
    },
    {
        symbol: '🍾',
        name: 'emoji-780',
        keyword: 'champagne bottle with popping cork'
    },
    {
        symbol: '🍷',
        name: 'emoji-781',
        keyword: 'wine glass'
    },
    {
        symbol: '🍸',
        name: 'emoji-782',
        keyword: 'cocktail cocktail glass'
    },
    {
        symbol: '🍹',
        name: 'emoji-783',
        keyword: 'tropical drink'
    },
    {
        symbol: '🍺',
        name: 'emoji-784',
        keyword: 'beer beer mug'
    },
    {
        symbol: '🍻',
        name: 'emoji-785',
        keyword: 'beers clinking beer mugs'
    },
    {
        symbol: '🥂',
        name: 'emoji-786',
        keyword: 'clinking glasses'
    },
    {
        symbol: '🥃',
        name: 'emoji-787',
        keyword: 'tumbler glass'
    },
    {
        symbol: '🫗',
        name: 'emoji-788',
        keyword: 'pouring liquid'
    },
    {
        symbol: '🥤',
        name: 'emoji-789',
        keyword: 'cup with straw'
    },
    {
        symbol: '🧋',
        name: 'emoji-790',
        keyword: 'bubble tea'
    },
    {
        symbol: '🧃',
        name: 'emoji-791',
        keyword: 'beverage box'
    },
    {
        symbol: '🧉',
        name: 'emoji-792',
        keyword: 'mate drink'
    },
    {
        symbol: '🧊',
        name: 'emoji-793',
        keyword: 'ice cube'
    },
    {
        symbol: '🥢',
        name: 'emoji-794',
        keyword: 'chopsticks'
    },
    {
        symbol: '🍽️',
        name: 'emoji-795',
        keyword: 'knife fork plate fork and knife with plate'
    },
    {
        symbol: '🍴',
        name: 'emoji-796',
        keyword: 'fork and knife'
    },
    {
        symbol: '🥄',
        name: 'emoji-797',
        keyword: 'spoon'
    },
    {
        symbol: '🔪',
        name: 'emoji-798',
        keyword: 'hocho knife'
    },
    {
        symbol: '🫙',
        name: 'emoji-799',
        keyword: 'jar'
    },
    {
        symbol: '🏺',
        name: 'emoji-800',
        keyword: 'amphora'
    },
    {
        symbol: '🌍',
        name: 'emoji-801',
        keyword: 'earth africa earth globe europe-africa'
    },
    {
        symbol: '🌎',
        name: 'emoji-802',
        keyword: 'earth americas earth globe americas'
    },
    {
        symbol: '🌏',
        name: 'emoji-803',
        keyword: 'earth asia earth globe asia-australia'
    },
    {
        symbol: '🌐',
        name: 'emoji-804',
        keyword: 'globe with meridians'
    },
    {
        symbol: '🗺️',
        name: 'emoji-805',
        keyword: 'world map'
    },
    {
        symbol: '🗾',
        name: 'emoji-806',
        keyword: 'japan silhouette of japan'
    },
    {
        symbol: '🧭',
        name: 'emoji-807',
        keyword: 'compass'
    },
    {
        symbol: '🏔️',
        name: 'emoji-808',
        keyword: 'snow-capped mountain snow capped mountain'
    },
    {
        symbol: '⛰️',
        name: 'emoji-809',
        keyword: 'mountain'
    },
    {
        symbol: '🌋',
        name: 'emoji-810',
        keyword: 'volcano'
    },
    {
        symbol: '🗻',
        name: 'emoji-811',
        keyword: 'mount fuji'
    },
    {
        symbol: '🏕️',
        name: 'emoji-812',
        keyword: 'camping'
    },
    {
        symbol: '🏖️',
        name: 'emoji-813',
        keyword: 'beach with umbrella'
    },
    {
        symbol: '🏜️',
        name: 'emoji-814',
        keyword: 'desert'
    },
    {
        symbol: '🏝️',
        name: 'emoji-815',
        keyword: 'desert island'
    },
    {
        symbol: '🏞️',
        name: 'emoji-816',
        keyword: 'national park'
    },
    {
        symbol: '🏟️',
        name: 'emoji-817',
        keyword: 'stadium'
    },
    {
        symbol: '🏛️',
        name: 'emoji-818',
        keyword: 'classical building'
    },
    {
        symbol: '🏗️',
        name: 'emoji-819',
        keyword: 'building construction'
    },
    {
        symbol: '🧱',
        name: 'emoji-820',
        keyword: 'brick bricks'
    },
    {
        symbol: '🪨',
        name: 'emoji-821',
        keyword: 'rock'
    },
    {
        symbol: '🪵',
        name: 'emoji-822',
        keyword: 'wood'
    },
    {
        symbol: '🛖',
        name: 'emoji-823',
        keyword: 'hut'
    },
    {
        symbol: '🏘️',
        name: 'emoji-824',
        keyword: 'houses house buildings'
    },
    {
        symbol: '🏚️',
        name: 'emoji-825',
        keyword: 'derelict house derelict house building'
    },
    {
        symbol: '🏠',
        name: 'emoji-826',
        keyword: 'house house building'
    },
    {
        symbol: '🏡',
        name: 'emoji-827',
        keyword: 'house with garden'
    },
    {
        symbol: '🏢',
        name: 'emoji-828',
        keyword: 'office office building'
    },
    {
        symbol: '🏣',
        name: 'emoji-829',
        keyword: 'post office japanese post office'
    },
    {
        symbol: '🏤',
        name: 'emoji-830',
        keyword: 'european post office'
    },
    {
        symbol: '🏥',
        name: 'emoji-831',
        keyword: 'hospital'
    },
    {
        symbol: '🏦',
        name: 'emoji-832',
        keyword: 'bank'
    },
    {
        symbol: '🏨',
        name: 'emoji-833',
        keyword: 'hotel'
    },
    {
        symbol: '🏩',
        name: 'emoji-834',
        keyword: 'love hotel'
    },
    {
        symbol: '🏪',
        name: 'emoji-835',
        keyword: 'convenience store'
    },
    {
        symbol: '🏫',
        name: 'emoji-836',
        keyword: 'school'
    },
    {
        symbol: '🏬',
        name: 'emoji-837',
        keyword: 'department store'
    },
    {
        symbol: '🏭',
        name: 'emoji-838',
        keyword: 'factory'
    },
    {
        symbol: '🏯',
        name: 'emoji-839',
        keyword: 'japanese castle'
    },
    {
        symbol: '🏰',
        name: 'emoji-840',
        keyword: 'european castle'
    },
    {
        symbol: '💒',
        name: 'emoji-841',
        keyword: 'wedding'
    },
    {
        symbol: '🗼',
        name: 'emoji-842',
        keyword: 'tokyo tower'
    },
    {
        symbol: '🗽',
        name: 'emoji-843',
        keyword: 'statue of liberty'
    },
    {
        symbol: '⛪',
        name: 'emoji-844',
        keyword: 'church'
    },
    {
        symbol: '🕌',
        name: 'emoji-845',
        keyword: 'mosque'
    },
    {
        symbol: '🛕',
        name: 'emoji-846',
        keyword: 'hindu temple'
    },
    {
        symbol: '🕍',
        name: 'emoji-847',
        keyword: 'synagogue'
    },
    {
        symbol: '⛩️',
        name: 'emoji-848',
        keyword: 'shinto shrine'
    },
    {
        symbol: '🕋',
        name: 'emoji-849',
        keyword: 'kaaba'
    },
    {
        symbol: '⛲',
        name: 'emoji-850',
        keyword: 'fountain'
    },
    {
        symbol: '⛺',
        name: 'emoji-851',
        keyword: 'tent'
    },
    {
        symbol: '🌁',
        name: 'emoji-852',
        keyword: 'foggy'
    },
    {
        symbol: '🌃',
        name: 'emoji-853',
        keyword: 'night with stars'
    },
    {
        symbol: '🏙️',
        name: 'emoji-854',
        keyword: 'cityscape'
    },
    {
        symbol: '🌄',
        name: 'emoji-855',
        keyword: 'sunrise over mountains'
    },
    {
        symbol: '🌅',
        name: 'emoji-856',
        keyword: 'sunrise'
    },
    {
        symbol: '🌆',
        name: 'emoji-857',
        keyword: 'city sunset cityscape at dusk'
    },
    {
        symbol: '🌇',
        name: 'emoji-858',
        keyword: 'city sunrise sunset over buildings'
    },
    {
        symbol: '🌉',
        name: 'emoji-859',
        keyword: 'bridge at night'
    },
    {
        symbol: '♨️',
        name: 'emoji-860',
        keyword: 'hotsprings hot springs'
    },
    {
        symbol: '🎠',
        name: 'emoji-861',
        keyword: 'carousel horse'
    },
    {
        symbol: '🛝',
        name: 'emoji-862',
        keyword: 'playground slide'
    },
    {
        symbol: '🎡',
        name: 'emoji-863',
        keyword: 'ferris wheel'
    },
    {
        symbol: '🎢',
        name: 'emoji-864',
        keyword: 'roller coaster'
    },
    {
        symbol: '💈',
        name: 'emoji-865',
        keyword: 'barber barber pole'
    },
    {
        symbol: '🎪',
        name: 'emoji-866',
        keyword: 'circus tent'
    },
    {
        symbol: '🚂',
        name: 'emoji-867',
        keyword: 'steam locomotive'
    },
    {
        symbol: '🚃',
        name: 'emoji-868',
        keyword: 'railway car'
    },
    {
        symbol: '🚄',
        name: 'emoji-869',
        keyword: 'high-speed train bullettrain side'
    },
    {
        symbol: '🚅',
        name: 'emoji-870',
        keyword: 'bullettrain front high-speed train with bullet nose'
    },
    {
        symbol: '🚆',
        name: 'emoji-871',
        keyword: 'train train2'
    },
    {
        symbol: '🚇',
        name: 'emoji-872',
        keyword: 'metro'
    },
    {
        symbol: '🚈',
        name: 'emoji-873',
        keyword: 'light rail'
    },
    {
        symbol: '🚉',
        name: 'emoji-874',
        keyword: 'station'
    },
    {
        symbol: '🚊',
        name: 'emoji-875',
        keyword: 'tram'
    },
    {
        symbol: '🚝',
        name: 'emoji-876',
        keyword: 'monorail'
    },
    {
        symbol: '🚞',
        name: 'emoji-877',
        keyword: 'mountain railway'
    },
    {
        symbol: '🚋',
        name: 'emoji-878',
        keyword: 'train tram car'
    },
    {
        symbol: '🚌',
        name: 'emoji-879',
        keyword: 'bus'
    },
    {
        symbol: '🚍',
        name: 'emoji-880',
        keyword: 'oncoming bus'
    },
    {
        symbol: '🚎',
        name: 'emoji-881',
        keyword: 'trolleybus'
    },
    {
        symbol: '🚐',
        name: 'emoji-882',
        keyword: 'minibus'
    },
    {
        symbol: '🚑',
        name: 'emoji-883',
        keyword: 'ambulance'
    },
    {
        symbol: '🚒',
        name: 'emoji-884',
        keyword: 'fire engine'
    },
    {
        symbol: '🚓',
        name: 'emoji-885',
        keyword: 'police car'
    },
    {
        symbol: '🚔',
        name: 'emoji-886',
        keyword: 'oncoming police car'
    },
    {
        symbol: '🚕',
        name: 'emoji-887',
        keyword: 'taxi'
    },
    {
        symbol: '🚖',
        name: 'emoji-888',
        keyword: 'oncoming taxi'
    },
    {
        symbol: '🚗',
        name: 'emoji-889',
        keyword: 'car red car automobile'
    },
    {
        symbol: '🚘',
        name: 'emoji-890',
        keyword: 'oncoming automobile'
    },
    {
        symbol: '🚙',
        name: 'emoji-891',
        keyword: 'blue car recreational vehicle'
    },
    {
        symbol: '🛻',
        name: 'emoji-892',
        keyword: 'pickup truck'
    },
    {
        symbol: '🚚',
        name: 'emoji-893',
        keyword: 'truck delivery truck'
    },
    {
        symbol: '🚛',
        name: 'emoji-894',
        keyword: 'articulated lorry'
    },
    {
        symbol: '🚜',
        name: 'emoji-895',
        keyword: 'tractor'
    },
    {
        symbol: '🏎️',
        name: 'emoji-896',
        keyword: 'racing car'
    },
    {
        symbol: '🏍️',
        name: 'emoji-897',
        keyword: 'motorcycle racing motorcycle'
    },
    {
        symbol: '🛵',
        name: 'emoji-898',
        keyword: 'motor scooter'
    },
    {
        symbol: '🦽',
        name: 'emoji-899',
        keyword: 'manual wheelchair'
    },
    {
        symbol: '🦼',
        name: 'emoji-900',
        keyword: 'motorized wheelchair'
    },
    {
        symbol: '🛺',
        name: 'emoji-901',
        keyword: 'auto rickshaw'
    },
    {
        symbol: '🚲',
        name: 'emoji-902',
        keyword: 'bike bicycle'
    },
    {
        symbol: '🛴',
        name: 'emoji-903',
        keyword: 'scooter'
    },
    {
        symbol: '🛹',
        name: 'emoji-904',
        keyword: 'skateboard'
    },
    {
        symbol: '🛼',
        name: 'emoji-905',
        keyword: 'roller skate'
    },
    {
        symbol: '🚏',
        name: 'emoji-906',
        keyword: 'busstop bus stop'
    },
    {
        symbol: '🛣️',
        name: 'emoji-907',
        keyword: 'motorway'
    },
    {
        symbol: '🛤️',
        name: 'emoji-908',
        keyword: 'railway track'
    },
    {
        symbol: '🛢️',
        name: 'emoji-909',
        keyword: 'oil drum'
    },
    {
        symbol: '⛽',
        name: 'emoji-910',
        keyword: 'fuelpump fuel pump'
    },
    {
        symbol: '🛞',
        name: 'emoji-911',
        keyword: 'wheel'
    },
    {
        symbol: '🚨',
        name: 'emoji-912',
        keyword: 'rotating light police cars revolving light'
    },
    {
        symbol: '🚥',
        name: 'emoji-913',
        keyword: 'traffic light horizontal traffic light'
    },
    {
        symbol: '🚦',
        name: 'emoji-914',
        keyword: 'vertical traffic light'
    },
    {
        symbol: '🛑',
        name: 'emoji-915',
        keyword: 'octagonal sign'
    },
    {
        symbol: '🚧',
        name: 'emoji-916',
        keyword: 'construction construction sign'
    },
    {
        symbol: '⚓',
        name: 'emoji-917',
        keyword: 'anchor'
    },
    {
        symbol: '🛟',
        name: 'emoji-918',
        keyword: 'ring buoy'
    },
    {
        symbol: '⛵',
        name: 'emoji-919',
        keyword: 'boat sailboat'
    },
    {
        symbol: '🛶',
        name: 'emoji-920',
        keyword: 'canoe'
    },
    {
        symbol: '🚤',
        name: 'emoji-921',
        keyword: 'speedboat'
    },
    {
        symbol: '🛳️',
        name: 'emoji-922',
        keyword: 'passenger ship'
    },
    {
        symbol: '⛴️',
        name: 'emoji-923',
        keyword: 'ferry'
    },
    {
        symbol: '🛥️',
        name: 'emoji-924',
        keyword: 'motor boat'
    },
    {
        symbol: '🚢',
        name: 'emoji-925',
        keyword: 'ship'
    },
    {
        symbol: '✈️',
        name: 'emoji-926',
        keyword: 'airplane'
    },
    {
        symbol: '🛩️',
        name: 'emoji-927',
        keyword: 'small airplane'
    },
    {
        symbol: '🛫',
        name: 'emoji-928',
        keyword: 'airplane departure'
    },
    {
        symbol: '🛬',
        name: 'emoji-929',
        keyword: 'airplane arriving'
    },
    {
        symbol: '🪂',
        name: 'emoji-930',
        keyword: 'parachute'
    },
    {
        symbol: '💺',
        name: 'emoji-931',
        keyword: 'seat'
    },
    {
        symbol: '🚁',
        name: 'emoji-932',
        keyword: 'helicopter'
    },
    {
        symbol: '🚟',
        name: 'emoji-933',
        keyword: 'suspension railway'
    },
    {
        symbol: '🚠',
        name: 'emoji-934',
        keyword: 'mountain cableway'
    },
    {
        symbol: '🚡',
        name: 'emoji-935',
        keyword: 'aerial tramway'
    },
    {
        symbol: '🛰️',
        name: 'emoji-936',
        keyword: 'satellite'
    },
    {
        symbol: '🚀',
        name: 'emoji-937',
        keyword: 'rocket'
    },
    {
        symbol: '🛸',
        name: 'emoji-938',
        keyword: 'flying saucer'
    },
    {
        symbol: '🛎️',
        name: 'emoji-939',
        keyword: 'bellhop bell'
    },
    {
        symbol: '🧳',
        name: 'emoji-940',
        keyword: 'luggage'
    },
    {
        symbol: '⌛',
        name: 'emoji-941',
        keyword: 'hourglass'
    },
    {
        symbol: '⏳',
        name: 'emoji-942',
        keyword: 'hourglass flowing sand hourglass with flowing sand'
    },
    {
        symbol: '⌚',
        name: 'emoji-943',
        keyword: 'watch'
    },
    {
        symbol: '⏰',
        name: 'emoji-944',
        keyword: 'alarm clock'
    },
    {
        symbol: '⏱️',
        name: 'emoji-945',
        keyword: 'stopwatch'
    },
    {
        symbol: '⏲️',
        name: 'emoji-946',
        keyword: 'timer clock'
    },
    {
        symbol: '🕰️',
        name: 'emoji-947',
        keyword: 'mantelpiece clock'
    },
    {
        symbol: '🕛',
        name: 'emoji-948',
        keyword: 'clock12 clock face twelve oclock'
    },
    {
        symbol: '🕧',
        name: 'emoji-949',
        keyword: 'clock1230 clock face twelve-thirty'
    },
    {
        symbol: '🕐',
        name: 'emoji-950',
        keyword: 'clock1 clock face one oclock'
    },
    {
        symbol: '🕜',
        name: 'emoji-951',
        keyword: 'clock130 clock face one-thirty'
    },
    {
        symbol: '🕑',
        name: 'emoji-952',
        keyword: 'clock2 clock face two oclock'
    },
    {
        symbol: '🕝',
        name: 'emoji-953',
        keyword: 'clock230 clock face two-thirty'
    },
    {
        symbol: '🕒',
        name: 'emoji-954',
        keyword: 'clock3 clock face three oclock'
    },
    {
        symbol: '🕞',
        name: 'emoji-955',
        keyword: 'clock330 clock face three-thirty'
    },
    {
        symbol: '🕓',
        name: 'emoji-956',
        keyword: 'clock4 clock face four oclock'
    },
    {
        symbol: '🕟',
        name: 'emoji-957',
        keyword: 'clock430 clock face four-thirty'
    },
    {
        symbol: '🕔',
        name: 'emoji-958',
        keyword: 'clock5 clock face five oclock'
    },
    {
        symbol: '🕠',
        name: 'emoji-959',
        keyword: 'clock530 clock face five-thirty'
    },
    {
        symbol: '🕕',
        name: 'emoji-960',
        keyword: 'clock6 clock face six oclock'
    },
    {
        symbol: '🕡',
        name: 'emoji-961',
        keyword: 'clock630 clock face six-thirty'
    },
    {
        symbol: '🕖',
        name: 'emoji-962',
        keyword: 'clock7 clock face seven oclock'
    },
    {
        symbol: '🕢',
        name: 'emoji-963',
        keyword: 'clock730 clock face seven-thirty'
    },
    {
        symbol: '🕗',
        name: 'emoji-964',
        keyword: 'clock8 clock face eight oclock'
    },
    {
        symbol: '🕣',
        name: 'emoji-965',
        keyword: 'clock830 clock face eight-thirty'
    },
    {
        symbol: '🕘',
        name: 'emoji-966',
        keyword: 'clock9 clock face nine oclock'
    },
    {
        symbol: '🕤',
        name: 'emoji-967',
        keyword: 'clock930 clock face nine-thirty'
    },
    {
        symbol: '🕙',
        name: 'emoji-968',
        keyword: 'clock10 clock face ten oclock'
    },
    {
        symbol: '🕥',
        name: 'emoji-969',
        keyword: 'clock1030 clock face ten-thirty'
    },
    {
        symbol: '🕚',
        name: 'emoji-970',
        keyword: 'clock11 clock face eleven oclock'
    },
    {
        symbol: '🕦',
        name: 'emoji-971',
        keyword: 'clock1130 clock face eleven-thirty'
    },
    {
        symbol: '🌑',
        name: 'emoji-972',
        keyword: 'new moon new moon symbol'
    },
    {
        symbol: '🌒',
        name: 'emoji-973',
        keyword: 'waxing crescent moon waxing crescent moon symbol'
    },
    {
        symbol: '🌓',
        name: 'emoji-974',
        keyword: 'first quarter moon first quarter moon symbol'
    },
    {
        symbol: '🌔',
        name: 'emoji-975',
        keyword: 'moon waxing gibbous moon waxing gibbous moon symbol'
    },
    {
        symbol: '🌕',
        name: 'emoji-976',
        keyword: 'full moon full moon symbol'
    },
    {
        symbol: '🌖',
        name: 'emoji-977',
        keyword: 'waning gibbous moon waning gibbous moon symbol'
    },
    {
        symbol: '🌗',
        name: 'emoji-978',
        keyword: 'last quarter moon last quarter moon symbol'
    },
    {
        symbol: '🌘',
        name: 'emoji-979',
        keyword: 'waning crescent moon waning crescent moon symbol'
    },
    {
        symbol: '🌙',
        name: 'emoji-980',
        keyword: 'crescent moon'
    },
    {
        symbol: '🌚',
        name: 'emoji-981',
        keyword: 'new moon with face'
    },
    {
        symbol: '🌛',
        name: 'emoji-982',
        keyword: 'first quarter moon with face'
    },
    {
        symbol: '🌜',
        name: 'emoji-983',
        keyword: 'last quarter moon with face'
    },
    {
        symbol: '🌡️',
        name: 'emoji-984',
        keyword: 'thermometer'
    },
    {
        symbol: '☀️',
        name: 'emoji-985',
        keyword: 'sunny black sun with rays'
    },
    {
        symbol: '🌝',
        name: 'emoji-986',
        keyword: 'full moon with face'
    },
    {
        symbol: '🌞',
        name: 'emoji-987',
        keyword: 'sun with face'
    },
    {
        symbol: '🪐',
        name: 'emoji-988',
        keyword: 'ringed planet'
    },
    {
        symbol: '⭐',
        name: 'emoji-989',
        keyword: 'star white medium star'
    },
    {
        symbol: '🌟',
        name: 'emoji-990',
        keyword: 'star2 glowing star'
    },
    {
        symbol: '🌠',
        name: 'emoji-991',
        keyword: 'stars shooting star'
    },
    {
        symbol: '🌌',
        name: 'emoji-992',
        keyword: 'milky way'
    },
    {
        symbol: '☁️',
        name: 'emoji-993',
        keyword: 'cloud'
    },
    {
        symbol: '⛅',
        name: 'emoji-994',
        keyword: 'partly sunny sun behind cloud'
    },
    {
        symbol: '⛈️',
        name: 'emoji-995',
        keyword: 'thunder cloud and rain cloud with lightning and rain'
    },
    {
        symbol: '🌤️',
        name: 'emoji-996',
        keyword: 'mostly sunny sun small cloud sun behind small cloud'
    },
    {
        symbol: '🌥️',
        name: 'emoji-997',
        keyword: 'barely sunny sun behind cloud sun behind large cloud'
    },
    {
        symbol: '🌦️',
        name: 'emoji-998',
        keyword: 'partly sunny rain sun behind rain cloud'
    },
    {
        symbol: '🌧️',
        name: 'emoji-999',
        keyword: 'rain cloud cloud with rain'
    },
    {
        symbol: '🌨️',
        name: 'emoji-1000',
        keyword: 'snow cloud cloud with snow'
    },
    {
        symbol: '🌩️',
        name: 'emoji-1001',
        keyword: 'lightning lightning cloud cloud with lightning'
    },
    {
        symbol: '🌪️',
        name: 'emoji-1002',
        keyword: 'tornado tornado cloud'
    },
    {
        symbol: '🌫️',
        name: 'emoji-1003',
        keyword: 'fog'
    },
    {
        symbol: '🌬️',
        name: 'emoji-1004',
        keyword: 'wind face wind blowing face'
    },
    {
        symbol: '🌀',
        name: 'emoji-1005',
        keyword: 'cyclone'
    },
    {
        symbol: '🌈',
        name: 'emoji-1006',
        keyword: 'rainbow'
    },
    {
        symbol: '🌂',
        name: 'emoji-1007',
        keyword: 'closed umbrella'
    },
    {
        symbol: '☂️',
        name: 'emoji-1008',
        keyword: 'umbrella'
    },
    {
        symbol: '☔',
        name: 'emoji-1009',
        keyword: 'umbrella with rain drops'
    },
    {
        symbol: '⛱️',
        name: 'emoji-1010',
        keyword: 'umbrella on ground'
    },
    {
        symbol: '⚡',
        name: 'emoji-1011',
        keyword: 'zap high voltage sign'
    },
    {
        symbol: '❄️',
        name: 'emoji-1012',
        keyword: 'snowflake'
    },
    {
        symbol: '☃️',
        name: 'emoji-1013',
        keyword: 'snowman'
    },
    {
        symbol: '⛄',
        name: 'emoji-1014',
        keyword: 'snowman without snow'
    },
    {
        symbol: '☄️',
        name: 'emoji-1015',
        keyword: 'comet'
    },
    {
        symbol: '🔥',
        name: 'emoji-1016',
        keyword: 'fire'
    },
    {
        symbol: '💧',
        name: 'emoji-1017',
        keyword: 'droplet'
    },
    {
        symbol: '🌊',
        name: 'emoji-1018',
        keyword: 'ocean water wave'
    },
    {
        symbol: '🎃',
        name: 'emoji-1019',
        keyword: 'jack-o-lantern jack o lantern'
    },
    {
        symbol: '🎄',
        name: 'emoji-1020',
        keyword: 'christmas tree'
    },
    {
        symbol: '🎆',
        name: 'emoji-1021',
        keyword: 'fireworks'
    },
    {
        symbol: '🎇',
        name: 'emoji-1022',
        keyword: 'sparkler firework sparkler'
    },
    {
        symbol: '🧨',
        name: 'emoji-1023',
        keyword: 'firecracker'
    },
    {
        symbol: '✨',
        name: 'emoji-1024',
        keyword: 'sparkles'
    },
    {
        symbol: '🎈',
        name: 'emoji-1025',
        keyword: 'balloon'
    },
    {
        symbol: '🎉',
        name: 'emoji-1026',
        keyword: 'tada party popper'
    },
    {
        symbol: '🎊',
        name: 'emoji-1027',
        keyword: 'confetti ball'
    },
    {
        symbol: '🎋',
        name: 'emoji-1028',
        keyword: 'tanabata tree'
    },
    {
        symbol: '🎍',
        name: 'emoji-1029',
        keyword: 'bamboo pine decoration'
    },
    {
        symbol: '🎎',
        name: 'emoji-1030',
        keyword: 'dolls japanese dolls'
    },
    {
        symbol: '🎏',
        name: 'emoji-1031',
        keyword: 'flags carp streamer'
    },
    {
        symbol: '🎐',
        name: 'emoji-1032',
        keyword: 'wind chime'
    },
    {
        symbol: '🎑',
        name: 'emoji-1033',
        keyword: 'rice scene moon viewing ceremony'
    },
    {
        symbol: '🧧',
        name: 'emoji-1034',
        keyword: 'red envelope red gift envelope'
    },
    {
        symbol: '🎀',
        name: 'emoji-1035',
        keyword: 'ribbon'
    },
    {
        symbol: '🎁',
        name: 'emoji-1036',
        keyword: 'gift wrapped present'
    },
    {
        symbol: '🎗️',
        name: 'emoji-1037',
        keyword: 'reminder ribbon'
    },
    {
        symbol: '🎟️',
        name: 'emoji-1038',
        keyword: 'admission tickets'
    },
    {
        symbol: '🎫',
        name: 'emoji-1039',
        keyword: 'ticket'
    },
    {
        symbol: '🎖️',
        name: 'emoji-1040',
        keyword: 'medal military medal'
    },
    {
        symbol: '🏆',
        name: 'emoji-1041',
        keyword: 'trophy'
    },
    {
        symbol: '🏅',
        name: 'emoji-1042',
        keyword: 'sports medal'
    },
    {
        symbol: '🥇',
        name: 'emoji-1043',
        keyword: 'first place medal'
    },
    {
        symbol: '🥈',
        name: 'emoji-1044',
        keyword: 'second place medal'
    },
    {
        symbol: '🥉',
        name: 'emoji-1045',
        keyword: 'third place medal'
    },
    {
        symbol: '⚽',
        name: 'emoji-1046',
        keyword: 'soccer soccer ball'
    },
    {
        symbol: '⚾',
        name: 'emoji-1047',
        keyword: 'baseball'
    },
    {
        symbol: '🥎',
        name: 'emoji-1048',
        keyword: 'softball'
    },
    {
        symbol: '🏀',
        name: 'emoji-1049',
        keyword: 'basketball basketball and hoop'
    },
    {
        symbol: '🏐',
        name: 'emoji-1050',
        keyword: 'volleyball'
    },
    {
        symbol: '🏈',
        name: 'emoji-1051',
        keyword: 'football american football'
    },
    {
        symbol: '🏉',
        name: 'emoji-1052',
        keyword: 'rugby football'
    },
    {
        symbol: '🎾',
        name: 'emoji-1053',
        keyword: 'tennis tennis racquet and ball'
    },
    {
        symbol: '🥏',
        name: 'emoji-1054',
        keyword: 'flying disc'
    },
    {
        symbol: '🎳',
        name: 'emoji-1055',
        keyword: 'bowling'
    },
    {
        symbol: '🏏',
        name: 'emoji-1056',
        keyword: 'cricket bat and ball'
    },
    {
        symbol: '🏑',
        name: 'emoji-1057',
        keyword: 'field hockey stick and ball'
    },
    {
        symbol: '🏒',
        name: 'emoji-1058',
        keyword: 'ice hockey stick and puck'
    },
    {
        symbol: '🥍',
        name: 'emoji-1059',
        keyword: 'lacrosse lacrosse stick and ball'
    },
    {
        symbol: '🏓',
        name: 'emoji-1060',
        keyword: 'table tennis paddle and ball'
    },
    {
        symbol: '🏸',
        name: 'emoji-1061',
        keyword: 'badminton racquet and shuttlecock'
    },
    {
        symbol: '🥊',
        name: 'emoji-1062',
        keyword: 'boxing glove'
    },
    {
        symbol: '🥋',
        name: 'emoji-1063',
        keyword: 'martial arts uniform'
    },
    {
        symbol: '🥅',
        name: 'emoji-1064',
        keyword: 'goal net'
    },
    {
        symbol: '⛳',
        name: 'emoji-1065',
        keyword: 'golf flag in hole'
    },
    {
        symbol: '⛸️',
        name: 'emoji-1066',
        keyword: 'ice skate'
    },
    {
        symbol: '🎣',
        name: 'emoji-1067',
        keyword: 'fishing pole and fish'
    },
    {
        symbol: '🤿',
        name: 'emoji-1068',
        keyword: 'diving mask'
    },
    {
        symbol: '🎽',
        name: 'emoji-1069',
        keyword: 'running shirt with sash'
    },
    {
        symbol: '🎿',
        name: 'emoji-1070',
        keyword: 'ski ski and ski boot'
    },
    {
        symbol: '🛷',
        name: 'emoji-1071',
        keyword: 'sled'
    },
    {
        symbol: '🥌',
        name: 'emoji-1072',
        keyword: 'curling stone'
    },
    {
        symbol: '🎯',
        name: 'emoji-1073',
        keyword: 'dart direct hit'
    },
    {
        symbol: '🪀',
        name: 'emoji-1074',
        keyword: 'yo-yo'
    },
    {
        symbol: '🪁',
        name: 'emoji-1075',
        keyword: 'kite'
    },
    {
        symbol: '🎱',
        name: 'emoji-1076',
        keyword: '8ball billiards'
    },
    {
        symbol: '🔮',
        name: 'emoji-1077',
        keyword: 'crystal ball'
    },
    {
        symbol: '🪄',
        name: 'emoji-1078',
        keyword: 'magic wand'
    },
    {
        symbol: '🧿',
        name: 'emoji-1079',
        keyword: 'nazar amulet'
    },
    {
        symbol: '🪬',
        name: 'emoji-1080',
        keyword: 'hamsa'
    },
    {
        symbol: '🎮',
        name: 'emoji-1081',
        keyword: 'video game'
    },
    {
        symbol: '🕹️',
        name: 'emoji-1082',
        keyword: 'joystick'
    },
    {
        symbol: '🎰',
        name: 'emoji-1083',
        keyword: 'slot machine'
    },
    {
        symbol: '🎲',
        name: 'emoji-1084',
        keyword: 'game die'
    },
    {
        symbol: '🧩',
        name: 'emoji-1085',
        keyword: 'jigsaw jigsaw puzzle piece'
    },
    {
        symbol: '🧸',
        name: 'emoji-1086',
        keyword: 'teddy bear'
    },
    {
        symbol: '🪅',
        name: 'emoji-1087',
        keyword: 'pinata'
    },
    {
        symbol: '🪩',
        name: 'emoji-1088',
        keyword: 'mirror ball'
    },
    {
        symbol: '🪆',
        name: 'emoji-1089',
        keyword: 'nesting dolls'
    },
    {
        symbol: '♠️',
        name: 'emoji-1090',
        keyword: 'spades black spade suit'
    },
    {
        symbol: '♥️',
        name: 'emoji-1091',
        keyword: 'hearts black heart suit'
    },
    {
        symbol: '♦️',
        name: 'emoji-1092',
        keyword: 'diamonds black diamond suit'
    },
    {
        symbol: '♣️',
        name: 'emoji-1093',
        keyword: 'clubs black club suit'
    },
    {
        symbol: '♟️',
        name: 'emoji-1094',
        keyword: 'chess pawn'
    },
    {
        symbol: '🃏',
        name: 'emoji-1095',
        keyword: 'black joker playing card black joker'
    },
    {
        symbol: '🀄',
        name: 'emoji-1096',
        keyword: 'mahjong mahjong tile red dragon'
    },
    {
        symbol: '🎴',
        name: 'emoji-1097',
        keyword: 'flower playing cards'
    },
    {
        symbol: '🎭',
        name: 'emoji-1098',
        keyword: 'performing arts'
    },
    {
        symbol: '🖼️',
        name: 'emoji-1099',
        keyword: 'framed picture frame with picture'
    },
    {
        symbol: '🎨',
        name: 'emoji-1100',
        keyword: 'art artist palette'
    },
    {
        symbol: '🧵',
        name: 'emoji-1101',
        keyword: 'thread spool of thread'
    },
    {
        symbol: '🪡',
        name: 'emoji-1102',
        keyword: 'sewing needle'
    },
    {
        symbol: '🧶',
        name: 'emoji-1103',
        keyword: 'yarn ball of yarn'
    },
    {
        symbol: '🪢',
        name: 'emoji-1104',
        keyword: 'knot'
    },
    {
        symbol: '👓',
        name: 'emoji-1105',
        keyword: 'eyeglasses'
    },
    {
        symbol: '🕶️',
        name: 'emoji-1106',
        keyword: 'sunglasses dark sunglasses'
    },
    {
        symbol: '🥽',
        name: 'emoji-1107',
        keyword: 'goggles'
    },
    {
        symbol: '🥼',
        name: 'emoji-1108',
        keyword: 'lab coat'
    },
    {
        symbol: '🦺',
        name: 'emoji-1109',
        keyword: 'safety vest'
    },
    {
        symbol: '👔',
        name: 'emoji-1110',
        keyword: 'necktie'
    },
    {
        symbol: '👕',
        name: 'emoji-1111',
        keyword: 'shirt tshirt t-shirt'
    },
    {
        symbol: '👖',
        name: 'emoji-1112',
        keyword: 'jeans'
    },
    {
        symbol: '🧣',
        name: 'emoji-1113',
        keyword: 'scarf'
    },
    {
        symbol: '🧤',
        name: 'emoji-1114',
        keyword: 'gloves'
    },
    {
        symbol: '🧥',
        name: 'emoji-1115',
        keyword: 'coat'
    },
    {
        symbol: '🧦',
        name: 'emoji-1116',
        keyword: 'socks'
    },
    {
        symbol: '👗',
        name: 'emoji-1117',
        keyword: 'dress'
    },
    {
        symbol: '👘',
        name: 'emoji-1118',
        keyword: 'kimono'
    },
    {
        symbol: '🥻',
        name: 'emoji-1119',
        keyword: 'sari'
    },
    {
        symbol: '🩱',
        name: 'emoji-1120',
        keyword: 'one-piece swimsuit'
    },
    {
        symbol: '🩲',
        name: 'emoji-1121',
        keyword: 'briefs'
    },
    {
        symbol: '🩳',
        name: 'emoji-1122',
        keyword: 'shorts'
    },
    {
        symbol: '👙',
        name: 'emoji-1123',
        keyword: 'bikini'
    },
    {
        symbol: '👚',
        name: 'emoji-1124',
        keyword: 'womans clothes'
    },
    {
        symbol: '👛',
        name: 'emoji-1125',
        keyword: 'purse'
    },
    {
        symbol: '👜',
        name: 'emoji-1126',
        keyword: 'handbag'
    },
    {
        symbol: '👝',
        name: 'emoji-1127',
        keyword: 'pouch'
    },
    {
        symbol: '🛍️',
        name: 'emoji-1128',
        keyword: 'shopping bags'
    },
    {
        symbol: '🎒',
        name: 'emoji-1129',
        keyword: 'school satchel'
    },
    {
        symbol: '🩴',
        name: 'emoji-1130',
        keyword: 'thong sandal'
    },
    {
        symbol: '👞',
        name: 'emoji-1131',
        keyword: 'shoe mans shoe'
    },
    {
        symbol: '👟',
        name: 'emoji-1132',
        keyword: 'athletic shoe'
    },
    {
        symbol: '🥾',
        name: 'emoji-1133',
        keyword: 'hiking boot'
    },
    {
        symbol: '🥿',
        name: 'emoji-1134',
        keyword: 'flat shoe womans flat shoe'
    },
    {
        symbol: '👠',
        name: 'emoji-1135',
        keyword: 'high heel high-heeled shoe'
    },
    {
        symbol: '👡',
        name: 'emoji-1136',
        keyword: 'sandal womans sandal'
    },
    {
        symbol: '🩰',
        name: 'emoji-1137',
        keyword: 'ballet shoes'
    },
    {
        symbol: '👢',
        name: 'emoji-1138',
        keyword: 'boot womans boots'
    },
    {
        symbol: '👑',
        name: 'emoji-1139',
        keyword: 'crown'
    },
    {
        symbol: '👒',
        name: 'emoji-1140',
        keyword: 'womans hat'
    },
    {
        symbol: '🎩',
        name: 'emoji-1141',
        keyword: 'tophat top hat'
    },
    {
        symbol: '🎓',
        name: 'emoji-1142',
        keyword: 'mortar board graduation cap'
    },
    {
        symbol: '🧢',
        name: 'emoji-1143',
        keyword: 'billed cap'
    },
    {
        symbol: '🪖',
        name: 'emoji-1144',
        keyword: 'military helmet'
    },
    {
        symbol: '⛑️',
        name: 'emoji-1145',
        keyword: 'rescue worker’s helmet helmet with white cross'
    },
    {
        symbol: '📿',
        name: 'emoji-1146',
        keyword: 'prayer beads'
    },
    {
        symbol: '💄',
        name: 'emoji-1147',
        keyword: 'lipstick'
    },
    {
        symbol: '💍',
        name: 'emoji-1148',
        keyword: 'ring'
    },
    {
        symbol: '💎',
        name: 'emoji-1149',
        keyword: 'gem gem stone'
    },
    {
        symbol: '🔇',
        name: 'emoji-1150',
        keyword: 'mute speaker with cancellation stroke'
    },
    {
        symbol: '🔈',
        name: 'emoji-1151',
        keyword: 'speaker'
    },
    {
        symbol: '🔉',
        name: 'emoji-1152',
        keyword: 'sound speaker with one sound wave'
    },
    {
        symbol: '🔊',
        name: 'emoji-1153',
        keyword: 'loud sound speaker with three sound waves'
    },
    {
        symbol: '📢',
        name: 'emoji-1154',
        keyword: 'loudspeaker public address loudspeaker'
    },
    {
        symbol: '📣',
        name: 'emoji-1155',
        keyword: 'mega cheering megaphone'
    },
    {
        symbol: '📯',
        name: 'emoji-1156',
        keyword: 'postal horn'
    },
    {
        symbol: '🔔',
        name: 'emoji-1157',
        keyword: 'bell'
    },
    {
        symbol: '🔕',
        name: 'emoji-1158',
        keyword: 'no bell bell with cancellation stroke'
    },
    {
        symbol: '🎼',
        name: 'emoji-1159',
        keyword: 'musical score'
    },
    {
        symbol: '🎵',
        name: 'emoji-1160',
        keyword: 'musical note'
    },
    {
        symbol: '🎶',
        name: 'emoji-1161',
        keyword: 'notes multiple musical notes'
    },
    {
        symbol: '🎙️',
        name: 'emoji-1162',
        keyword: 'studio microphone'
    },
    {
        symbol: '🎚️',
        name: 'emoji-1163',
        keyword: 'level slider'
    },
    {
        symbol: '🎛️',
        name: 'emoji-1164',
        keyword: 'control knobs'
    },
    {
        symbol: '🎤',
        name: 'emoji-1165',
        keyword: 'microphone'
    },
    {
        symbol: '🎧',
        name: 'emoji-1166',
        keyword: 'headphone headphones'
    },
    {
        symbol: '📻',
        name: 'emoji-1167',
        keyword: 'radio'
    },
    {
        symbol: '🎷',
        name: 'emoji-1168',
        keyword: 'saxophone'
    },
    {
        symbol: '🪗',
        name: 'emoji-1169',
        keyword: 'accordion'
    },
    {
        symbol: '🎸',
        name: 'emoji-1170',
        keyword: 'guitar'
    },
    {
        symbol: '🎹',
        name: 'emoji-1171',
        keyword: 'musical keyboard'
    },
    {
        symbol: '🎺',
        name: 'emoji-1172',
        keyword: 'trumpet'
    },
    {
        symbol: '🎻',
        name: 'emoji-1173',
        keyword: 'violin'
    },
    {
        symbol: '🪕',
        name: 'emoji-1174',
        keyword: 'banjo'
    },
    {
        symbol: '🥁',
        name: 'emoji-1175',
        keyword: 'drum with drumsticks'
    },
    {
        symbol: '🪘',
        name: 'emoji-1176',
        keyword: 'long drum'
    },
    {
        symbol: '📱',
        name: 'emoji-1177',
        keyword: 'iphone mobile phone'
    },
    {
        symbol: '📲',
        name: 'emoji-1178',
        keyword: 'calling mobile phone with rightwards arrow at left'
    },
    {
        symbol: '☎️',
        name: 'emoji-1179',
        keyword: 'phone telephone black telephone'
    },
    {
        symbol: '📞',
        name: 'emoji-1180',
        keyword: 'telephone receiver'
    },
    {
        symbol: '📟',
        name: 'emoji-1181',
        keyword: 'pager'
    },
    {
        symbol: '📠',
        name: 'emoji-1182',
        keyword: 'fax fax machine'
    },
    {
        symbol: '🔋',
        name: 'emoji-1183',
        keyword: 'battery'
    },
    {
        symbol: '🪫',
        name: 'emoji-1184',
        keyword: 'low battery'
    },
    {
        symbol: '🔌',
        name: 'emoji-1185',
        keyword: 'electric plug'
    },
    {
        symbol: '💻',
        name: 'emoji-1186',
        keyword: 'computer personal computer'
    },
    {
        symbol: '🖥️',
        name: 'emoji-1187',
        keyword: 'desktop computer'
    },
    {
        symbol: '🖨️',
        name: 'emoji-1188',
        keyword: 'printer'
    },
    {
        symbol: '⌨️',
        name: 'emoji-1189',
        keyword: 'keyboard'
    },
    {
        symbol: '🖱️',
        name: 'emoji-1190',
        keyword: 'computer mouse three button mouse'
    },
    {
        symbol: '🖲️',
        name: 'emoji-1191',
        keyword: 'trackball'
    },
    {
        symbol: '💽',
        name: 'emoji-1192',
        keyword: 'minidisc'
    },
    {
        symbol: '💾',
        name: 'emoji-1193',
        keyword: 'floppy disk'
    },
    {
        symbol: '💿',
        name: 'emoji-1194',
        keyword: 'cd optical disc'
    },
    {
        symbol: '📀',
        name: 'emoji-1195',
        keyword: 'dvd'
    },
    {
        symbol: '🧮',
        name: 'emoji-1196',
        keyword: 'abacus'
    },
    {
        symbol: '🎥',
        name: 'emoji-1197',
        keyword: 'movie camera'
    },
    {
        symbol: '🎞️',
        name: 'emoji-1198',
        keyword: 'film frames'
    },
    {
        symbol: '📽️',
        name: 'emoji-1199',
        keyword: 'film projector'
    },
    {
        symbol: '🎬',
        name: 'emoji-1200',
        keyword: 'clapper clapper board'
    },
    {
        symbol: '📺',
        name: 'emoji-1201',
        keyword: 'tv television'
    },
    {
        symbol: '📷',
        name: 'emoji-1202',
        keyword: 'camera'
    },
    {
        symbol: '📸',
        name: 'emoji-1203',
        keyword: 'camera with flash'
    },
    {
        symbol: '📹',
        name: 'emoji-1204',
        keyword: 'video camera'
    },
    {
        symbol: '📼',
        name: 'emoji-1205',
        keyword: 'vhs videocassette'
    },
    {
        symbol: '🔍',
        name: 'emoji-1206',
        keyword: 'mag left-pointing magnifying glass'
    },
    {
        symbol: '🔎',
        name: 'emoji-1207',
        keyword: 'mag right right-pointing magnifying glass'
    },
    {
        symbol: '🕯️',
        name: 'emoji-1208',
        keyword: 'candle'
    },
    {
        symbol: '💡',
        name: 'emoji-1209',
        keyword: 'bulb electric light bulb'
    },
    {
        symbol: '🔦',
        name: 'emoji-1210',
        keyword: 'flashlight electric torch'
    },
    {
        symbol: '🏮',
        name: 'emoji-1211',
        keyword: 'lantern izakaya lantern'
    },
    {
        symbol: '🪔',
        name: 'emoji-1212',
        keyword: 'diya lamp'
    },
    {
        symbol: '📔',
        name: 'emoji-1213',
        keyword: 'notebook with decorative cover'
    },
    {
        symbol: '📕',
        name: 'emoji-1214',
        keyword: 'closed book'
    },
    {
        symbol: '📖',
        name: 'emoji-1215',
        keyword: 'book open book'
    },
    {
        symbol: '📗',
        name: 'emoji-1216',
        keyword: 'green book'
    },
    {
        symbol: '📘',
        name: 'emoji-1217',
        keyword: 'blue book'
    },
    {
        symbol: '📙',
        name: 'emoji-1218',
        keyword: 'orange book'
    },
    {
        symbol: '📚',
        name: 'emoji-1219',
        keyword: 'books'
    },
    {
        symbol: '📓',
        name: 'emoji-1220',
        keyword: 'notebook'
    },
    {
        symbol: '📒',
        name: 'emoji-1221',
        keyword: 'ledger'
    },
    {
        symbol: '📃',
        name: 'emoji-1222',
        keyword: 'page with curl'
    },
    {
        symbol: '📜',
        name: 'emoji-1223',
        keyword: 'scroll'
    },
    {
        symbol: '📄',
        name: 'emoji-1224',
        keyword: 'page facing up'
    },
    {
        symbol: '📰',
        name: 'emoji-1225',
        keyword: 'newspaper'
    },
    {
        symbol: '🗞️',
        name: 'emoji-1226',
        keyword: 'rolled-up newspaper rolled up newspaper'
    },
    {
        symbol: '📑',
        name: 'emoji-1227',
        keyword: 'bookmark tabs'
    },
    {
        symbol: '🔖',
        name: 'emoji-1228',
        keyword: 'bookmark'
    },
    {
        symbol: '🏷️',
        name: 'emoji-1229',
        keyword: 'label'
    },
    {
        symbol: '💰',
        name: 'emoji-1230',
        keyword: 'moneybag money bag'
    },
    {
        symbol: '🪙',
        name: 'emoji-1231',
        keyword: 'coin'
    },
    {
        symbol: '💴',
        name: 'emoji-1232',
        keyword: 'yen banknote with yen sign'
    },
    {
        symbol: '💵',
        name: 'emoji-1233',
        keyword: 'dollar banknote with dollar sign'
    },
    {
        symbol: '💶',
        name: 'emoji-1234',
        keyword: 'euro banknote with euro sign'
    },
    {
        symbol: '💷',
        name: 'emoji-1235',
        keyword: 'pound banknote with pound sign'
    },
    {
        symbol: '💸',
        name: 'emoji-1236',
        keyword: 'money with wings'
    },
    {
        symbol: '💳',
        name: 'emoji-1237',
        keyword: 'credit card'
    },
    {
        symbol: '🧾',
        name: 'emoji-1238',
        keyword: 'receipt'
    },
    {
        symbol: '💹',
        name: 'emoji-1239',
        keyword: 'chart chart with upwards trend and yen sign'
    },
    {
        symbol: '✉️',
        name: 'emoji-1240',
        keyword: 'email envelope'
    },
    {
        symbol: '📧',
        name: 'emoji-1241',
        keyword: 'e-mail e-mail symbol'
    },
    {
        symbol: '📨',
        name: 'emoji-1242',
        keyword: 'incoming envelope'
    },
    {
        symbol: '📩',
        name: 'emoji-1243',
        keyword: 'envelope with arrow envelope with downwards arrow above'
    },
    {
        symbol: '📤',
        name: 'emoji-1244',
        keyword: 'outbox tray'
    },
    {
        symbol: '📥',
        name: 'emoji-1245',
        keyword: 'inbox tray'
    },
    {
        symbol: '📦',
        name: 'emoji-1246',
        keyword: 'package'
    },
    {
        symbol: '📫',
        name: 'emoji-1247',
        keyword: 'mailbox closed mailbox with raised flag'
    },
    {
        symbol: '📪',
        name: 'emoji-1248',
        keyword: 'mailbox closed closed mailbox with lowered flag'
    },
    {
        symbol: '📬',
        name: 'emoji-1249',
        keyword: 'mailbox with mail open mailbox with raised flag'
    },
    {
        symbol: '📭',
        name: 'emoji-1250',
        keyword: 'mailbox with no mail open mailbox with lowered flag'
    },
    {
        symbol: '📮',
        name: 'emoji-1251',
        keyword: 'postbox'
    },
    {
        symbol: '🗳️',
        name: 'emoji-1252',
        keyword: 'ballot box with ballot'
    },
    {
        symbol: '✏️',
        name: 'emoji-1253',
        keyword: 'pencil pencil2'
    },
    {
        symbol: '✒️',
        name: 'emoji-1254',
        keyword: 'black nib'
    },
    {
        symbol: '🖋️',
        name: 'emoji-1255',
        keyword: 'fountain pen lower left fountain pen'
    },
    {
        symbol: '🖊️',
        name: 'emoji-1256',
        keyword: 'pen lower left ballpoint pen'
    },
    {
        symbol: '🖌️',
        name: 'emoji-1257',
        keyword: 'paintbrush lower left paintbrush'
    },
    {
        symbol: '🖍️',
        name: 'emoji-1258',
        keyword: 'crayon lower left crayon'
    },
    {
        symbol: '📝',
        name: 'emoji-1259',
        keyword: 'memo pencil'
    },
    {
        symbol: '💼',
        name: 'emoji-1260',
        keyword: 'briefcase'
    },
    {
        symbol: '📁',
        name: 'emoji-1261',
        keyword: 'file folder'
    },
    {
        symbol: '📂',
        name: 'emoji-1262',
        keyword: 'open file folder'
    },
    {
        symbol: '🗂️',
        name: 'emoji-1263',
        keyword: 'card index dividers'
    },
    {
        symbol: '📅',
        name: 'emoji-1264',
        keyword: 'date calendar'
    },
    {
        symbol: '📆',
        name: 'emoji-1265',
        keyword: 'calendar tear-off calendar'
    },
    {
        symbol: '🗒️',
        name: 'emoji-1266',
        keyword: 'spiral notepad spiral note pad'
    },
    {
        symbol: '🗓️',
        name: 'emoji-1267',
        keyword: 'spiral calendar spiral calendar pad'
    },
    {
        symbol: '📇',
        name: 'emoji-1268',
        keyword: 'card index'
    },
    {
        symbol: '📈',
        name: 'emoji-1269',
        keyword: 'chart with upwards trend'
    },
    {
        symbol: '📉',
        name: 'emoji-1270',
        keyword: 'chart with downwards trend'
    },
    {
        symbol: '📊',
        name: 'emoji-1271',
        keyword: 'bar chart'
    },
    {
        symbol: '📋',
        name: 'emoji-1272',
        keyword: 'clipboard'
    },
    {
        symbol: '📌',
        name: 'emoji-1273',
        keyword: 'pushpin'
    },
    {
        symbol: '📍',
        name: 'emoji-1274',
        keyword: 'round pushpin'
    },
    {
        symbol: '📎',
        name: 'emoji-1275',
        keyword: 'paperclip'
    },
    {
        symbol: '🖇️',
        name: 'emoji-1276',
        keyword: 'linked paperclips'
    },
    {
        symbol: '📏',
        name: 'emoji-1277',
        keyword: 'straight ruler'
    },
    {
        symbol: '📐',
        name: 'emoji-1278',
        keyword: 'triangular ruler'
    },
    {
        symbol: '✂️',
        name: 'emoji-1279',
        keyword: 'scissors black scissors'
    },
    {
        symbol: '🗃️',
        name: 'emoji-1280',
        keyword: 'card file box'
    },
    {
        symbol: '🗄️',
        name: 'emoji-1281',
        keyword: 'file cabinet'
    },
    {
        symbol: '🗑️',
        name: 'emoji-1282',
        keyword: 'wastebasket'
    },
    {
        symbol: '🔒',
        name: 'emoji-1283',
        keyword: 'lock'
    },
    {
        symbol: '🔓',
        name: 'emoji-1284',
        keyword: 'unlock open lock'
    },
    {
        symbol: '🔏',
        name: 'emoji-1285',
        keyword: 'lock with ink pen'
    },
    {
        symbol: '🔐',
        name: 'emoji-1286',
        keyword: 'closed lock with key'
    },
    {
        symbol: '🔑',
        name: 'emoji-1287',
        keyword: 'key'
    },
    {
        symbol: '🗝️',
        name: 'emoji-1288',
        keyword: 'old key'
    },
    {
        symbol: '🔨',
        name: 'emoji-1289',
        keyword: 'hammer'
    },
    {
        symbol: '🪓',
        name: 'emoji-1290',
        keyword: 'axe'
    },
    {
        symbol: '⛏️',
        name: 'emoji-1291',
        keyword: 'pick'
    },
    {
        symbol: '⚒️',
        name: 'emoji-1292',
        keyword: 'hammer and pick'
    },
    {
        symbol: '🛠️',
        name: 'emoji-1293',
        keyword: 'hammer and wrench'
    },
    {
        symbol: '🗡️',
        name: 'emoji-1294',
        keyword: 'dagger dagger knife'
    },
    {
        symbol: '⚔️',
        name: 'emoji-1295',
        keyword: 'crossed swords'
    },
    {
        symbol: '🔫',
        name: 'emoji-1296',
        keyword: 'gun pistol'
    },
    {
        symbol: '🪃',
        name: 'emoji-1297',
        keyword: 'boomerang'
    },
    {
        symbol: '🏹',
        name: 'emoji-1298',
        keyword: 'bow and arrow'
    },
    {
        symbol: '🛡️',
        name: 'emoji-1299',
        keyword: 'shield'
    },
    {
        symbol: '🪚',
        name: 'emoji-1300',
        keyword: 'carpentry saw'
    },
    {
        symbol: '🔧',
        name: 'emoji-1301',
        keyword: 'wrench'
    },
    {
        symbol: '🪛',
        name: 'emoji-1302',
        keyword: 'screwdriver'
    },
    {
        symbol: '🔩',
        name: 'emoji-1303',
        keyword: 'nut and bolt'
    },
    {
        symbol: '⚙️',
        name: 'emoji-1304',
        keyword: 'gear'
    },
    {
        symbol: '🗜️',
        name: 'emoji-1305',
        keyword: 'clamp compression'
    },
    {
        symbol: '⚖️',
        name: 'emoji-1306',
        keyword: 'scales balance scale'
    },
    {
        symbol: '🦯',
        name: 'emoji-1307',
        keyword: 'probing cane'
    },
    {
        symbol: '🔗',
        name: 'emoji-1308',
        keyword: 'link link symbol'
    },
    {
        symbol: '⛓️',
        name: 'emoji-1309',
        keyword: 'chains'
    },
    {
        symbol: '🪝',
        name: 'emoji-1310',
        keyword: 'hook'
    },
    {
        symbol: '🧰',
        name: 'emoji-1311',
        keyword: 'toolbox'
    },
    {
        symbol: '🧲',
        name: 'emoji-1312',
        keyword: 'magnet'
    },
    {
        symbol: '🪜',
        name: 'emoji-1313',
        keyword: 'ladder'
    },
    {
        symbol: '⚗️',
        name: 'emoji-1314',
        keyword: 'alembic'
    },
    {
        symbol: '🧪',
        name: 'emoji-1315',
        keyword: 'test tube'
    },
    {
        symbol: '🧫',
        name: 'emoji-1316',
        keyword: 'petri dish'
    },
    {
        symbol: '🧬',
        name: 'emoji-1317',
        keyword: 'dna dna double helix'
    },
    {
        symbol: '🔬',
        name: 'emoji-1318',
        keyword: 'microscope'
    },
    {
        symbol: '🔭',
        name: 'emoji-1319',
        keyword: 'telescope'
    },
    {
        symbol: '📡',
        name: 'emoji-1320',
        keyword: 'satellite antenna'
    },
    {
        symbol: '💉',
        name: 'emoji-1321',
        keyword: 'syringe'
    },
    {
        symbol: '🩸',
        name: 'emoji-1322',
        keyword: 'drop of blood'
    },
    {
        symbol: '💊',
        name: 'emoji-1323',
        keyword: 'pill'
    },
    {
        symbol: '🩹',
        name: 'emoji-1324',
        keyword: 'adhesive bandage'
    },
    {
        symbol: '🩼',
        name: 'emoji-1325',
        keyword: 'crutch'
    },
    {
        symbol: '🩺',
        name: 'emoji-1326',
        keyword: 'stethoscope'
    },
    {
        symbol: '🩻',
        name: 'emoji-1327',
        keyword: 'x-ray'
    },
    {
        symbol: '🚪',
        name: 'emoji-1328',
        keyword: 'door'
    },
    {
        symbol: '🛗',
        name: 'emoji-1329',
        keyword: 'elevator'
    },
    {
        symbol: '🪞',
        name: 'emoji-1330',
        keyword: 'mirror'
    },
    {
        symbol: '🪟',
        name: 'emoji-1331',
        keyword: 'window'
    },
    {
        symbol: '🛏️',
        name: 'emoji-1332',
        keyword: 'bed'
    },
    {
        symbol: '🛋️',
        name: 'emoji-1333',
        keyword: 'couch and lamp'
    },
    {
        symbol: '🪑',
        name: 'emoji-1334',
        keyword: 'chair'
    },
    {
        symbol: '🚽',
        name: 'emoji-1335',
        keyword: 'toilet'
    },
    {
        symbol: '🪠',
        name: 'emoji-1336',
        keyword: 'plunger'
    },
    {
        symbol: '🚿',
        name: 'emoji-1337',
        keyword: 'shower'
    },
    {
        symbol: '🛁',
        name: 'emoji-1338',
        keyword: 'bathtub'
    },
    {
        symbol: '🪤',
        name: 'emoji-1339',
        keyword: 'mouse trap'
    },
    {
        symbol: '🪒',
        name: 'emoji-1340',
        keyword: 'razor'
    },
    {
        symbol: '🧴',
        name: 'emoji-1341',
        keyword: 'lotion bottle'
    },
    {
        symbol: '🧷',
        name: 'emoji-1342',
        keyword: 'safety pin'
    },
    {
        symbol: '🧹',
        name: 'emoji-1343',
        keyword: 'broom'
    },
    {
        symbol: '🧺',
        name: 'emoji-1344',
        keyword: 'basket'
    },
    {
        symbol: '🧻',
        name: 'emoji-1345',
        keyword: 'roll of paper'
    },
    {
        symbol: '🪣',
        name: 'emoji-1346',
        keyword: 'bucket'
    },
    {
        symbol: '🧼',
        name: 'emoji-1347',
        keyword: 'soap bar of soap'
    },
    {
        symbol: '🫧',
        name: 'emoji-1348',
        keyword: 'bubbles'
    },
    {
        symbol: '🪥',
        name: 'emoji-1349',
        keyword: 'toothbrush'
    },
    {
        symbol: '🧽',
        name: 'emoji-1350',
        keyword: 'sponge'
    },
    {
        symbol: '🧯',
        name: 'emoji-1351',
        keyword: 'fire extinguisher'
    },
    {
        symbol: '🛒',
        name: 'emoji-1352',
        keyword: 'shopping trolley'
    },
    {
        symbol: '🚬',
        name: 'emoji-1353',
        keyword: 'smoking smoking symbol'
    },
    {
        symbol: '⚰️',
        name: 'emoji-1354',
        keyword: 'coffin'
    },
    {
        symbol: '🪦',
        name: 'emoji-1355',
        keyword: 'headstone'
    },
    {
        symbol: '⚱️',
        name: 'emoji-1356',
        keyword: 'funeral urn'
    },
    {
        symbol: '🗿',
        name: 'emoji-1357',
        keyword: 'moyai'
    },
    {
        symbol: '🪧',
        name: 'emoji-1358',
        keyword: 'placard'
    },
    {
        symbol: '🪪',
        name: 'emoji-1359',
        keyword: 'identification card'
    },
    {
        symbol: '🏧',
        name: 'emoji-1360',
        keyword: 'atm automated teller machine'
    },
    {
        symbol: '🚮',
        name: 'emoji-1361',
        keyword: 'put litter in its place put litter in its place symbol'
    },
    {
        symbol: '🚰',
        name: 'emoji-1362',
        keyword: 'potable water potable water symbol'
    },
    {
        symbol: '♿',
        name: 'emoji-1363',
        keyword: 'wheelchair wheelchair symbol'
    },
    {
        symbol: '🚹',
        name: 'emoji-1364',
        keyword: 'mens mens symbol'
    },
    {
        symbol: '🚺',
        name: 'emoji-1365',
        keyword: 'womens womens symbol'
    },
    {
        symbol: '🚻',
        name: 'emoji-1366',
        keyword: 'restroom'
    },
    {
        symbol: '🚼',
        name: 'emoji-1367',
        keyword: 'baby symbol'
    },
    {
        symbol: '🚾',
        name: 'emoji-1368',
        keyword: 'wc water closet'
    },
    {
        symbol: '🛂',
        name: 'emoji-1369',
        keyword: 'passport control'
    },
    {
        symbol: '🛃',
        name: 'emoji-1370',
        keyword: 'customs'
    },
    {
        symbol: '🛄',
        name: 'emoji-1371',
        keyword: 'baggage claim'
    },
    {
        symbol: '🛅',
        name: 'emoji-1372',
        keyword: 'left luggage'
    },
    {
        symbol: '⚠️',
        name: 'emoji-1373',
        keyword: 'warning warning sign'
    },
    {
        symbol: '🚸',
        name: 'emoji-1374',
        keyword: 'children crossing'
    },
    {
        symbol: '⛔',
        name: 'emoji-1375',
        keyword: 'no entry'
    },
    {
        symbol: '🚫',
        name: 'emoji-1376',
        keyword: 'no entry sign'
    },
    {
        symbol: '🚳',
        name: 'emoji-1377',
        keyword: 'no bicycles'
    },
    {
        symbol: '🚭',
        name: 'emoji-1378',
        keyword: 'no smoking no smoking symbol'
    },
    {
        symbol: '🚯',
        name: 'emoji-1379',
        keyword: 'do not litter do not litter symbol'
    },
    {
        symbol: '🚱',
        name: 'emoji-1380',
        keyword: 'non-potable water non-potable water symbol'
    },
    {
        symbol: '🚷',
        name: 'emoji-1381',
        keyword: 'no pedestrians'
    },
    {
        symbol: '📵',
        name: 'emoji-1382',
        keyword: 'no mobile phones'
    },
    {
        symbol: '🔞',
        name: 'emoji-1383',
        keyword: 'underage no one under eighteen symbol'
    },
    {
        symbol: '☢️',
        name: 'emoji-1384',
        keyword: 'radioactive radioactive sign'
    },
    {
        symbol: '☣️',
        name: 'emoji-1385',
        keyword: 'biohazard biohazard sign'
    },
    {
        symbol: '⬆️',
        name: 'emoji-1386',
        keyword: 'arrow up upwards black arrow'
    },
    {
        symbol: '↗️',
        name: 'emoji-1387',
        keyword: 'north east arrow arrow upper right'
    },
    {
        symbol: '➡️',
        name: 'emoji-1388',
        keyword: 'arrow right black rightwards arrow'
    },
    {
        symbol: '↘️',
        name: 'emoji-1389',
        keyword: 'south east arrow arrow lower right'
    },
    {
        symbol: '⬇️',
        name: 'emoji-1390',
        keyword: 'arrow down downwards black arrow'
    },
    {
        symbol: '↙️',
        name: 'emoji-1391',
        keyword: 'south west arrow arrow lower left'
    },
    {
        symbol: '⬅️',
        name: 'emoji-1392',
        keyword: 'arrow left leftwards black arrow'
    },
    {
        symbol: '↖️',
        name: 'emoji-1393',
        keyword: 'north west arrow arrow upper left'
    },
    {
        symbol: '↕️',
        name: 'emoji-1394',
        keyword: 'up down arrow arrow up down'
    },
    {
        symbol: '↔️',
        name: 'emoji-1395',
        keyword: 'left right arrow'
    },
    {
        symbol: '↩️',
        name: 'emoji-1396',
        keyword: 'leftwards arrow with hook'
    },
    {
        symbol: '↪️',
        name: 'emoji-1397',
        keyword: 'arrow right hook rightwards arrow with hook'
    },
    {
        symbol: '⤴️',
        name: 'emoji-1398',
        keyword: 'arrow heading up arrow pointing rightwards then curving upwards'
    },
    {
        symbol: '⤵️',
        name: 'emoji-1399',
        keyword: 'arrow heading down arrow pointing rightwards then curving downwards'
    },
    {
        symbol: '🔃',
        name: 'emoji-1400',
        keyword: 'arrows clockwise clockwise downwards and upwards open circle arrows'
    },
    {
        symbol: '🔄',
        name: 'emoji-1401',
        keyword: 'arrows counterclockwise anticlockwise downwards and upwards open circle arrows'
    },
    {
        symbol: '🔙',
        name: 'emoji-1402',
        keyword: 'back back with leftwards arrow above'
    },
    {
        symbol: '🔚',
        name: 'emoji-1403',
        keyword: 'end end with leftwards arrow above'
    },
    {
        symbol: '🔛',
        name: 'emoji-1404',
        keyword: 'on on with exclamation mark with left right arrow above'
    },
    {
        symbol: '🔜',
        name: 'emoji-1405',
        keyword: 'soon soon with rightwards arrow above'
    },
    {
        symbol: '🔝',
        name: 'emoji-1406',
        keyword: 'top top with upwards arrow above'
    },
    {
        symbol: '🛐',
        name: 'emoji-1407',
        keyword: 'place of worship'
    },
    {
        symbol: '⚛️',
        name: 'emoji-1408',
        keyword: 'atom symbol'
    },
    {
        symbol: '🕉️',
        name: 'emoji-1409',
        keyword: 'om om symbol'
    },
    {
        symbol: '✡️',
        name: 'emoji-1410',
        keyword: 'star of david'
    },
    {
        symbol: '☸️',
        name: 'emoji-1411',
        keyword: 'wheel of dharma'
    },
    {
        symbol: '☯️',
        name: 'emoji-1412',
        keyword: 'yin yang'
    },
    {
        symbol: '✝️',
        name: 'emoji-1413',
        keyword: 'latin cross'
    },
    {
        symbol: '☦️',
        name: 'emoji-1414',
        keyword: 'orthodox cross'
    },
    {
        symbol: '☪️',
        name: 'emoji-1415',
        keyword: 'star and crescent'
    },
    {
        symbol: '☮️',
        name: 'emoji-1416',
        keyword: 'peace symbol'
    },
    {
        symbol: '🕎',
        name: 'emoji-1417',
        keyword: 'menorah with nine branches'
    },
    {
        symbol: '🔯',
        name: 'emoji-1418',
        keyword: 'six pointed star six pointed star with middle dot'
    },
    {
        symbol: '♈',
        name: 'emoji-1419',
        keyword: 'aries'
    },
    {
        symbol: '♉',
        name: 'emoji-1420',
        keyword: 'taurus'
    },
    {
        symbol: '♊',
        name: 'emoji-1421',
        keyword: 'gemini'
    },
    {
        symbol: '♋',
        name: 'emoji-1422',
        keyword: 'cancer'
    },
    {
        symbol: '♌',
        name: 'emoji-1423',
        keyword: 'leo'
    },
    {
        symbol: '♍',
        name: 'emoji-1424',
        keyword: 'virgo'
    },
    {
        symbol: '♎',
        name: 'emoji-1425',
        keyword: 'libra'
    },
    {
        symbol: '♏',
        name: 'emoji-1426',
        keyword: 'scorpius'
    },
    {
        symbol: '♐',
        name: 'emoji-1427',
        keyword: 'sagittarius'
    },
    {
        symbol: '♑',
        name: 'emoji-1428',
        keyword: 'capricorn'
    },
    {
        symbol: '♒',
        name: 'emoji-1429',
        keyword: 'aquarius'
    },
    {
        symbol: '♓',
        name: 'emoji-1430',
        keyword: 'pisces'
    },
    {
        symbol: '⛎',
        name: 'emoji-1431',
        keyword: 'ophiuchus'
    },
    {
        symbol: '🔀',
        name: 'emoji-1432',
        keyword: 'twisted rightwards arrows'
    },
    {
        symbol: '🔁',
        name: 'emoji-1433',
        keyword: 'repeat clockwise rightwards and leftwards open circle arrows'
    },
    {
        symbol: '🔂',
        name: 'emoji-1434',
        keyword: 'repeat one clockwise rightwards and leftwards open circle arrows with circled one overlay'
    },
    {
        symbol: '▶️',
        name: 'emoji-1435',
        keyword: 'arrow forward black right-pointing triangle'
    },
    {
        symbol: '⏩',
        name: 'emoji-1436',
        keyword: 'fast forward black right-pointing double triangle'
    },
    {
        symbol: '⏭️',
        name: 'emoji-1437',
        keyword: 'next track button black right pointing double triangle with vertical bar'
    },
    {
        symbol: '⏯️',
        name: 'emoji-1438',
        keyword: 'play or pause button black right pointing triangle with double vertical bar'
    },
    {
        symbol: '◀️',
        name: 'emoji-1439',
        keyword: 'arrow backward black left-pointing triangle'
    },
    {
        symbol: '⏪',
        name: 'emoji-1440',
        keyword: 'rewind black left-pointing double triangle'
    },
    {
        symbol: '⏮️',
        name: 'emoji-1441',
        keyword: 'last track button black left pointing double triangle with vertical bar'
    },
    {
        symbol: '🔼',
        name: 'emoji-1442',
        keyword: 'arrow up small up-pointing small red triangle'
    },
    {
        symbol: '⏫',
        name: 'emoji-1443',
        keyword: 'arrow double up black up-pointing double triangle'
    },
    {
        symbol: '🔽',
        name: 'emoji-1444',
        keyword: 'arrow down small down-pointing small red triangle'
    },
    {
        symbol: '⏬',
        name: 'emoji-1445',
        keyword: 'arrow double down black down-pointing double triangle'
    },
    {
        symbol: '⏸️',
        name: 'emoji-1446',
        keyword: 'pause button double vertical bar'
    },
    {
        symbol: '⏹️',
        name: 'emoji-1447',
        keyword: 'stop button black square for stop'
    },
    {
        symbol: '⏺️',
        name: 'emoji-1448',
        keyword: 'record button black circle for record'
    },
    {
        symbol: '⏏️',
        name: 'emoji-1449',
        keyword: 'eject eject button'
    },
    {
        symbol: '🎦',
        name: 'emoji-1450',
        keyword: 'cinema'
    },
    {
        symbol: '🔅',
        name: 'emoji-1451',
        keyword: 'low brightness low brightness symbol'
    },
    {
        symbol: '🔆',
        name: 'emoji-1452',
        keyword: 'high brightness high brightness symbol'
    },
    {
        symbol: '📶',
        name: 'emoji-1453',
        keyword: 'signal strength antenna with bars'
    },
    {
        symbol: '📳',
        name: 'emoji-1454',
        keyword: 'vibration mode'
    },
    {
        symbol: '📴',
        name: 'emoji-1455',
        keyword: 'mobile phone off'
    },
    {
        symbol: '♀️',
        name: 'emoji-1456',
        keyword: 'female sign'
    },
    {
        symbol: '♂️',
        name: 'emoji-1457',
        keyword: 'male sign'
    },
    {
        symbol: '⚧️',
        name: 'emoji-1458',
        keyword: 'transgender symbol'
    },
    {
        symbol: '✖️',
        name: 'emoji-1459',
        keyword: 'heavy multiplication x'
    },
    {
        symbol: '➕',
        name: 'emoji-1460',
        keyword: 'heavy plus sign'
    },
    {
        symbol: '➖',
        name: 'emoji-1461',
        keyword: 'heavy minus sign'
    },
    {
        symbol: '➗',
        name: 'emoji-1462',
        keyword: 'heavy division sign'
    },
    {
        symbol: '🟰',
        name: 'emoji-1463',
        keyword: 'heavy equals sign'
    },
    {
        symbol: '♾️',
        name: 'emoji-1464',
        keyword: 'infinity'
    },
    {
        symbol: '‼️',
        name: 'emoji-1465',
        keyword: 'bangbang double exclamation mark'
    },
    {
        symbol: '⁉️',
        name: 'emoji-1466',
        keyword: 'interrobang exclamation question mark'
    },
    {
        symbol: '❓',
        name: 'emoji-1467',
        keyword: 'question black question mark ornament'
    },
    {
        symbol: '❔',
        name: 'emoji-1468',
        keyword: 'grey question white question mark ornament'
    },
    {
        symbol: '❕',
        name: 'emoji-1469',
        keyword: 'grey exclamation white exclamation mark ornament'
    },
    {
        symbol: '❗',
        name: 'emoji-1470',
        keyword: 'exclamation heavy exclamation mark heavy exclamation mark symbol'
    },
    {
        symbol: '〰️',
        name: 'emoji-1471',
        keyword: 'wavy dash'
    },
    {
        symbol: '💱',
        name: 'emoji-1472',
        keyword: 'currency exchange'
    },
    {
        symbol: '💲',
        name: 'emoji-1473',
        keyword: 'heavy dollar sign'
    },
    {
        symbol: '⚕️',
        name: 'emoji-1474',
        keyword: 'medical symbol staff of aesculapius'
    },
    {
        symbol: '♻️',
        name: 'emoji-1475',
        keyword: 'recycle black universal recycling symbol'
    },
    {
        symbol: '⚜️',
        name: 'emoji-1476',
        keyword: 'fleur-de-lis fleur de lis'
    },
    {
        symbol: '🔱',
        name: 'emoji-1477',
        keyword: 'trident trident emblem'
    },
    {
        symbol: '📛',
        name: 'emoji-1478',
        keyword: 'name badge'
    },
    {
        symbol: '🔰',
        name: 'emoji-1479',
        keyword: 'beginner japanese symbol for beginner'
    },
    {
        symbol: '⭕',
        name: 'emoji-1480',
        keyword: 'o heavy large circle'
    },
    {
        symbol: '✅',
        name: 'emoji-1481',
        keyword: 'white check mark white heavy check mark'
    },
    {
        symbol: '☑️',
        name: 'emoji-1482',
        keyword: 'ballot box with check'
    },
    {
        symbol: '✔️',
        name: 'emoji-1483',
        keyword: 'heavy check mark'
    },
    {
        symbol: '❌',
        name: 'emoji-1484',
        keyword: 'x cross mark'
    },
    {
        symbol: '❎',
        name: 'emoji-1485',
        keyword: 'negative squared cross mark'
    },
    {
        symbol: '➰',
        name: 'emoji-1486',
        keyword: 'curly loop'
    },
    {
        symbol: '➿',
        name: 'emoji-1487',
        keyword: 'loop double curly loop'
    },
    {
        symbol: '〽️',
        name: 'emoji-1488',
        keyword: 'part alternation mark'
    },
    {
        symbol: '✳️',
        name: 'emoji-1489',
        keyword: 'eight spoked asterisk'
    },
    {
        symbol: '✴️',
        name: 'emoji-1490',
        keyword: 'eight pointed black star'
    },
    {
        symbol: '❇️',
        name: 'emoji-1491',
        keyword: 'sparkle'
    },
    {
        symbol: '©️',
        name: 'emoji-1492',
        keyword: 'copyright copyright sign'
    },
    {
        symbol: '®️',
        name: 'emoji-1493',
        keyword: 'registered registered sign'
    },
    {
        symbol: '™️',
        name: 'emoji-1494',
        keyword: 'tm trade mark sign'
    },
    {
        symbol: '#️⃣',
        name: 'emoji-1495',
        keyword: 'hash hash key'
    },
    {
        symbol: '*️⃣',
        name: 'emoji-1496',
        keyword: 'keycap: * keycap star'
    },
    {
        symbol: '0️⃣',
        name: 'emoji-1497',
        keyword: 'zero keycap 0'
    },
    {
        symbol: '1️⃣',
        name: 'emoji-1498',
        keyword: 'one keycap 1'
    },
    {
        symbol: '2️⃣',
        name: 'emoji-1499',
        keyword: 'two keycap 2'
    },
    {
        symbol: '3️⃣',
        name: 'emoji-1500',
        keyword: 'three keycap 3'
    },
    {
        symbol: '4️⃣',
        name: 'emoji-1501',
        keyword: 'four keycap 4'
    },
    {
        symbol: '5️⃣',
        name: 'emoji-1502',
        keyword: 'five keycap 5'
    },
    {
        symbol: '6️⃣',
        name: 'emoji-1503',
        keyword: 'six keycap 6'
    },
    {
        symbol: '7️⃣',
        name: 'emoji-1504',
        keyword: 'seven keycap 7'
    },
    {
        symbol: '8️⃣',
        name: 'emoji-1505',
        keyword: 'eight keycap 8'
    },
    {
        symbol: '9️⃣',
        name: 'emoji-1506',
        keyword: 'nine keycap 9'
    },
    {
        symbol: '🔟',
        name: 'emoji-1507',
        keyword: 'keycap ten'
    },
    {
        symbol: '🔠',
        name: 'emoji-1508',
        keyword: 'capital abcd input symbol for latin capital letters'
    },
    {
        symbol: '🔡',
        name: 'emoji-1509',
        keyword: 'abcd input symbol for latin small letters'
    },
    {
        symbol: '🔢',
        name: 'emoji-1510',
        keyword: '1234 input symbol for numbers'
    },
    {
        symbol: '🔣',
        name: 'emoji-1511',
        keyword: 'symbols input symbol for symbols'
    },
    {
        symbol: '🔤',
        name: 'emoji-1512',
        keyword: 'abc input symbol for latin letters'
    },
    {
        symbol: '🅰️',
        name: 'emoji-1513',
        keyword: 'a negative squared latin capital letter a'
    },
    {
        symbol: '🆎',
        name: 'emoji-1514',
        keyword: 'ab negative squared ab'
    },
    {
        symbol: '🅱️',
        name: 'emoji-1515',
        keyword: 'b negative squared latin capital letter b'
    },
    {
        symbol: '🆑',
        name: 'emoji-1516',
        keyword: 'cl squared cl'
    },
    {
        symbol: '🆒',
        name: 'emoji-1517',
        keyword: 'cool squared cool'
    },
    {
        symbol: '🆓',
        name: 'emoji-1518',
        keyword: 'free squared free'
    },
    {
        symbol: 'ℹ️',
        name: 'emoji-1519',
        keyword: 'information source'
    },
    {
        symbol: '🆔',
        name: 'emoji-1520',
        keyword: 'id squared id'
    },
    {
        symbol: 'Ⓜ️',
        name: 'emoji-1521',
        keyword: 'm circled latin capital letter m'
    },
    {
        symbol: '🆕',
        name: 'emoji-1522',
        keyword: 'new squared new'
    },
    {
        symbol: '🆖',
        name: 'emoji-1523',
        keyword: 'ng squared ng'
    },
    {
        symbol: '🅾️',
        name: 'emoji-1524',
        keyword: 'o2 negative squared latin capital letter o'
    },
    {
        symbol: '🆗',
        name: 'emoji-1525',
        keyword: 'ok squared ok'
    },
    {
        symbol: '🅿️',
        name: 'emoji-1526',
        keyword: 'parking negative squared latin capital letter p'
    },
    {
        symbol: '🆘',
        name: 'emoji-1527',
        keyword: 'sos squared sos'
    },
    {
        symbol: '🆙',
        name: 'emoji-1528',
        keyword: 'up squared up with exclamation mark'
    },
    {
        symbol: '🆚',
        name: 'emoji-1529',
        keyword: 'vs squared vs'
    },
    {
        symbol: '🈁',
        name: 'emoji-1530',
        keyword: 'koko squared katakana koko'
    },
    {
        symbol: '🈂️',
        name: 'emoji-1531',
        keyword: 'sa squared katakana sa'
    },
    {
        symbol: '🈷️',
        name: 'emoji-1532',
        keyword: 'u6708 squared cjk unified ideograph-6708'
    },
    {
        symbol: '🈶',
        name: 'emoji-1533',
        keyword: 'u6709 squared cjk unified ideograph-6709'
    },
    {
        symbol: '🈯',
        name: 'emoji-1534',
        keyword: 'u6307 squared cjk unified ideograph-6307'
    },
    {
        symbol: '🉐',
        name: 'emoji-1535',
        keyword: 'ideograph advantage circled ideograph advantage'
    },
    {
        symbol: '🈹',
        name: 'emoji-1536',
        keyword: 'u5272 squared cjk unified ideograph-5272'
    },
    {
        symbol: '🈚',
        name: 'emoji-1537',
        keyword: 'u7121 squared cjk unified ideograph-7121'
    },
    {
        symbol: '🈲',
        name: 'emoji-1538',
        keyword: 'u7981 squared cjk unified ideograph-7981'
    },
    {
        symbol: '🉑',
        name: 'emoji-1539',
        keyword: 'accept circled ideograph accept'
    },
    {
        symbol: '🈸',
        name: 'emoji-1540',
        keyword: 'u7533 squared cjk unified ideograph-7533'
    },
    {
        symbol: '🈴',
        name: 'emoji-1541',
        keyword: 'u5408 squared cjk unified ideograph-5408'
    },
    {
        symbol: '🈳',
        name: 'emoji-1542',
        keyword: 'u7a7a squared cjk unified ideograph-7a7a'
    },
    {
        symbol: '㊗️',
        name: 'emoji-1543',
        keyword: 'congratulations circled ideograph congratulation'
    },
    {
        symbol: '㊙️',
        name: 'emoji-1544',
        keyword: 'secret circled ideograph secret'
    },
    {
        symbol: '🈺',
        name: 'emoji-1545',
        keyword: 'u55b6 squared cjk unified ideograph-55b6'
    },
    {
        symbol: '🈵',
        name: 'emoji-1546',
        keyword: 'u6e80 squared cjk unified ideograph-6e80'
    },
    {
        symbol: '🔴',
        name: 'emoji-1547',
        keyword: 'red circle large red circle'
    },
    {
        symbol: '🟠',
        name: 'emoji-1548',
        keyword: 'large orange circle'
    },
    {
        symbol: '🟡',
        name: 'emoji-1549',
        keyword: 'large yellow circle'
    },
    {
        symbol: '🟢',
        name: 'emoji-1550',
        keyword: 'large green circle'
    },
    {
        symbol: '🔵',
        name: 'emoji-1551',
        keyword: 'large blue circle'
    },
    {
        symbol: '🟣',
        name: 'emoji-1552',
        keyword: 'large purple circle'
    },
    {
        symbol: '🟤',
        name: 'emoji-1553',
        keyword: 'large brown circle'
    },
    {
        symbol: '⚫',
        name: 'emoji-1554',
        keyword: 'black circle medium black circle'
    },
    {
        symbol: '⚪',
        name: 'emoji-1555',
        keyword: 'white circle medium white circle'
    },
    {
        symbol: '🟥',
        name: 'emoji-1556',
        keyword: 'large red square'
    },
    {
        symbol: '🟧',
        name: 'emoji-1557',
        keyword: 'large orange square'
    },
    {
        symbol: '🟨',
        name: 'emoji-1558',
        keyword: 'large yellow square'
    },
    {
        symbol: '🟩',
        name: 'emoji-1559',
        keyword: 'large green square'
    },
    {
        symbol: '🟦',
        name: 'emoji-1560',
        keyword: 'large blue square'
    },
    {
        symbol: '🟪',
        name: 'emoji-1561',
        keyword: 'large purple square'
    },
    {
        symbol: '🟫',
        name: 'emoji-1562',
        keyword: 'large brown square'
    },
    {
        symbol: '⬛',
        name: 'emoji-1563',
        keyword: 'black large square'
    },
    {
        symbol: '⬜',
        name: 'emoji-1564',
        keyword: 'white large square'
    },
    {
        symbol: '◼️',
        name: 'emoji-1565',
        keyword: 'black medium square'
    },
    {
        symbol: '◻️',
        name: 'emoji-1566',
        keyword: 'white medium square'
    },
    {
        symbol: '◾',
        name: 'emoji-1567',
        keyword: 'black medium small square'
    },
    {
        symbol: '◽',
        name: 'emoji-1568',
        keyword: 'white medium small square'
    },
    {
        symbol: '▪️',
        name: 'emoji-1569',
        keyword: 'black small square'
    },
    {
        symbol: '▫️',
        name: 'emoji-1570',
        keyword: 'white small square'
    },
    {
        symbol: '🔶',
        name: 'emoji-1571',
        keyword: 'large orange diamond'
    },
    {
        symbol: '🔷',
        name: 'emoji-1572',
        keyword: 'large blue diamond'
    },
    {
        symbol: '🔸',
        name: 'emoji-1573',
        keyword: 'small orange diamond'
    },
    {
        symbol: '🔹',
        name: 'emoji-1574',
        keyword: 'small blue diamond'
    },
    {
        symbol: '🔺',
        name: 'emoji-1575',
        keyword: 'small red triangle up-pointing red triangle'
    },
    {
        symbol: '🔻',
        name: 'emoji-1576',
        keyword: 'small red triangle down down-pointing red triangle'
    },
    {
        symbol: '💠',
        name: 'emoji-1577',
        keyword: 'diamond shape with a dot inside'
    },
    {
        symbol: '🔘',
        name: 'emoji-1578',
        keyword: 'radio button'
    },
    {
        symbol: '🔳',
        name: 'emoji-1579',
        keyword: 'white square button'
    },
    {
        symbol: '🔲',
        name: 'emoji-1580',
        keyword: 'black square button'
    },
    {
        symbol: '🏁',
        name: 'emoji-1581',
        keyword: 'chequered flag checkered flag'
    },
    {
        symbol: '🚩',
        name: 'emoji-1582',
        keyword: 'triangular flag on post'
    },
    {
        symbol: '🎌',
        name: 'emoji-1583',
        keyword: 'crossed flags'
    },
    {
        symbol: '🏴',
        name: 'emoji-1584',
        keyword: 'waving black flag'
    },
    {
        symbol: '🏳️',
        name: 'emoji-1585',
        keyword: 'white flag waving white flag'
    },
    {
        symbol: '🏳️‍🌈',
        name: 'emoji-1586',
        keyword: 'rainbow flag rainbow-flag'
    },
    {
        symbol: '🏳️‍⚧️',
        name: 'emoji-1587',
        keyword: 'transgender flag'
    },
    {
        symbol: '🏴‍☠️',
        name: 'emoji-1588',
        keyword: 'pirate flag'
    },
    {
        symbol: '🇦🇨',
        name: 'emoji-1589',
        keyword: 'flag-ac ascension island flag'
    },
    {
        symbol: '🇦🇩',
        name: 'emoji-1590',
        keyword: 'flag-ad andorra flag'
    },
    {
        symbol: '🇦🇪',
        name: 'emoji-1591',
        keyword: 'flag-ae united arab emirates flag'
    },
    {
        symbol: '🇦🇫',
        name: 'emoji-1592',
        keyword: 'flag-af afghanistan flag'
    },
    {
        symbol: '🇦🇬',
        name: 'emoji-1593',
        keyword: 'flag-ag antigua & barbuda flag'
    },
    {
        symbol: '🇦🇮',
        name: 'emoji-1594',
        keyword: 'flag-ai anguilla flag'
    },
    {
        symbol: '🇦🇱',
        name: 'emoji-1595',
        keyword: 'flag-al albania flag'
    },
    {
        symbol: '🇦🇲',
        name: 'emoji-1596',
        keyword: 'flag-am armenia flag'
    },
    {
        symbol: '🇦🇴',
        name: 'emoji-1597',
        keyword: 'flag-ao angola flag'
    },
    {
        symbol: '🇦🇶',
        name: 'emoji-1598',
        keyword: 'flag-aq antarctica flag'
    },
    {
        symbol: '🇦🇷',
        name: 'emoji-1599',
        keyword: 'flag-ar argentina flag'
    },
    {
        symbol: '🇦🇸',
        name: 'emoji-1600',
        keyword: 'flag-as american samoa flag'
    },
    {
        symbol: '🇦🇹',
        name: 'emoji-1601',
        keyword: 'flag-at austria flag'
    },
    {
        symbol: '🇦🇺',
        name: 'emoji-1602',
        keyword: 'flag-au australia flag'
    },
    {
        symbol: '🇦🇼',
        name: 'emoji-1603',
        keyword: 'flag-aw aruba flag'
    },
    {
        symbol: '🇦🇽',
        name: 'emoji-1604',
        keyword: 'flag-ax åland islands flag'
    },
    {
        symbol: '🇦🇿',
        name: 'emoji-1605',
        keyword: 'flag-az azerbaijan flag'
    },
    {
        symbol: '🇧🇦',
        name: 'emoji-1606',
        keyword: 'flag-ba bosnia & herzegovina flag'
    },
    {
        symbol: '🇧🇧',
        name: 'emoji-1607',
        keyword: 'flag-bb barbados flag'
    },
    {
        symbol: '🇧🇩',
        name: 'emoji-1608',
        keyword: 'flag-bd bangladesh flag'
    },
    {
        symbol: '🇧🇪',
        name: 'emoji-1609',
        keyword: 'flag-be belgium flag'
    },
    {
        symbol: '🇧🇫',
        name: 'emoji-1610',
        keyword: 'flag-bf burkina faso flag'
    },
    {
        symbol: '🇧🇬',
        name: 'emoji-1611',
        keyword: 'flag-bg bulgaria flag'
    },
    {
        symbol: '🇧🇭',
        name: 'emoji-1612',
        keyword: 'flag-bh bahrain flag'
    },
    {
        symbol: '🇧🇮',
        name: 'emoji-1613',
        keyword: 'flag-bi burundi flag'
    },
    {
        symbol: '🇧🇯',
        name: 'emoji-1614',
        keyword: 'flag-bj benin flag'
    },
    {
        symbol: '🇧🇱',
        name: 'emoji-1615',
        keyword: 'flag-bl st. barthélemy flag'
    },
    {
        symbol: '🇧🇲',
        name: 'emoji-1616',
        keyword: 'flag-bm bermuda flag'
    },
    {
        symbol: '🇧🇳',
        name: 'emoji-1617',
        keyword: 'flag-bn brunei flag'
    },
    {
        symbol: '🇧🇴',
        name: 'emoji-1618',
        keyword: 'flag-bo bolivia flag'
    },
    {
        symbol: '🇧🇶',
        name: 'emoji-1619',
        keyword: 'flag-bq caribbean netherlands flag'
    },
    {
        symbol: '🇧🇷',
        name: 'emoji-1620',
        keyword: 'flag-br brazil flag'
    },
    {
        symbol: '🇧🇸',
        name: 'emoji-1621',
        keyword: 'flag-bs bahamas flag'
    },
    {
        symbol: '🇧🇹',
        name: 'emoji-1622',
        keyword: 'flag-bt bhutan flag'
    },
    {
        symbol: '🇧🇻',
        name: 'emoji-1623',
        keyword: 'flag-bv bouvet island flag'
    },
    {
        symbol: '🇧🇼',
        name: 'emoji-1624',
        keyword: 'flag-bw botswana flag'
    },
    {
        symbol: '🇧🇾',
        name: 'emoji-1625',
        keyword: 'flag-by belarus flag'
    },
    {
        symbol: '🇧🇿',
        name: 'emoji-1626',
        keyword: 'flag-bz belize flag'
    },
    {
        symbol: '🇨🇦',
        name: 'emoji-1627',
        keyword: 'flag-ca canada flag'
    },
    {
        symbol: '🇨🇨',
        name: 'emoji-1628',
        keyword: 'flag-cc cocos (keeling) islands flag'
    },
    {
        symbol: '🇨🇩',
        name: 'emoji-1629',
        keyword: 'flag-cd congo - kinshasa flag'
    },
    {
        symbol: '🇨🇫',
        name: 'emoji-1630',
        keyword: 'flag-cf central african republic flag'
    },
    {
        symbol: '🇨🇬',
        name: 'emoji-1631',
        keyword: 'flag-cg congo - brazzaville flag'
    },
    {
        symbol: '🇨🇭',
        name: 'emoji-1632',
        keyword: 'flag-ch switzerland flag'
    },
    {
        symbol: '🇨🇮',
        name: 'emoji-1633',
        keyword: 'flag-ci côte d’ivoire flag'
    },
    {
        symbol: '🇨🇰',
        name: 'emoji-1634',
        keyword: 'flag-ck cook islands flag'
    },
    {
        symbol: '🇨🇱',
        name: 'emoji-1635',
        keyword: 'flag-cl chile flag'
    },
    {
        symbol: '🇨🇲',
        name: 'emoji-1636',
        keyword: 'flag-cm cameroon flag'
    },
    {
        symbol: '🇨🇳',
        name: 'emoji-1637',
        keyword: 'cn flag-cn china flag'
    },
    {
        symbol: '🇨🇴',
        name: 'emoji-1638',
        keyword: 'flag-co colombia flag'
    },
    {
        symbol: '🇨🇵',
        name: 'emoji-1639',
        keyword: 'flag-cp clipperton island flag'
    },
    {
        symbol: '🇨🇷',
        name: 'emoji-1640',
        keyword: 'flag-cr costa rica flag'
    },
    {
        symbol: '🇨🇺',
        name: 'emoji-1641',
        keyword: 'flag-cu cuba flag'
    },
    {
        symbol: '🇨🇻',
        name: 'emoji-1642',
        keyword: 'flag-cv cape verde flag'
    },
    {
        symbol: '🇨🇼',
        name: 'emoji-1643',
        keyword: 'flag-cw curaçao flag'
    },
    {
        symbol: '🇨🇽',
        name: 'emoji-1644',
        keyword: 'flag-cx christmas island flag'
    },
    {
        symbol: '🇨🇾',
        name: 'emoji-1645',
        keyword: 'flag-cy cyprus flag'
    },
    {
        symbol: '🇨🇿',
        name: 'emoji-1646',
        keyword: 'flag-cz czechia flag'
    },
    {
        symbol: '🇩🇪',
        name: 'emoji-1647',
        keyword: 'de flag-de germany flag'
    },
    {
        symbol: '🇩🇬',
        name: 'emoji-1648',
        keyword: 'flag-dg diego garcia flag'
    },
    {
        symbol: '🇩🇯',
        name: 'emoji-1649',
        keyword: 'flag-dj djibouti flag'
    },
    {
        symbol: '🇩🇰',
        name: 'emoji-1650',
        keyword: 'flag-dk denmark flag'
    },
    {
        symbol: '🇩🇲',
        name: 'emoji-1651',
        keyword: 'flag-dm dominica flag'
    },
    {
        symbol: '🇩🇴',
        name: 'emoji-1652',
        keyword: 'flag-do dominican republic flag'
    },
    {
        symbol: '🇩🇿',
        name: 'emoji-1653',
        keyword: 'flag-dz algeria flag'
    },
    {
        symbol: '🇪🇦',
        name: 'emoji-1654',
        keyword: 'flag-ea ceuta & melilla flag'
    },
    {
        symbol: '🇪🇨',
        name: 'emoji-1655',
        keyword: 'flag-ec ecuador flag'
    },
    {
        symbol: '🇪🇪',
        name: 'emoji-1656',
        keyword: 'flag-ee estonia flag'
    },
    {
        symbol: '🇪🇬',
        name: 'emoji-1657',
        keyword: 'flag-eg egypt flag'
    },
    {
        symbol: '🇪🇭',
        name: 'emoji-1658',
        keyword: 'flag-eh western sahara flag'
    },
    {
        symbol: '🇪🇷',
        name: 'emoji-1659',
        keyword: 'flag-er eritrea flag'
    },
    {
        symbol: '🇪🇸',
        name: 'emoji-1660',
        keyword: 'es flag-es spain flag'
    },
    {
        symbol: '🇪🇹',
        name: 'emoji-1661',
        keyword: 'flag-et ethiopia flag'
    },
    {
        symbol: '🇪🇺',
        name: 'emoji-1662',
        keyword: 'flag-eu european union flag'
    },
    {
        symbol: '🇫🇮',
        name: 'emoji-1663',
        keyword: 'flag-fi finland flag'
    },
    {
        symbol: '🇫🇯',
        name: 'emoji-1664',
        keyword: 'flag-fj fiji flag'
    },
    {
        symbol: '🇫🇰',
        name: 'emoji-1665',
        keyword: 'flag-fk falkland islands flag'
    },
    {
        symbol: '🇫🇲',
        name: 'emoji-1666',
        keyword: 'flag-fm micronesia flag'
    },
    {
        symbol: '🇫🇴',
        name: 'emoji-1667',
        keyword: 'flag-fo faroe islands flag'
    },
    {
        symbol: '🇫🇷',
        name: 'emoji-1668',
        keyword: 'fr flag-fr france flag'
    },
    {
        symbol: '🇬🇦',
        name: 'emoji-1669',
        keyword: 'flag-ga gabon flag'
    },
    {
        symbol: '🇬🇧',
        name: 'emoji-1670',
        keyword: 'gb uk flag-gb united kingdom flag'
    },
    {
        symbol: '🇬🇩',
        name: 'emoji-1671',
        keyword: 'flag-gd grenada flag'
    },
    {
        symbol: '🇬🇪',
        name: 'emoji-1672',
        keyword: 'flag-ge georgia flag'
    },
    {
        symbol: '🇬🇫',
        name: 'emoji-1673',
        keyword: 'flag-gf french guiana flag'
    },
    {
        symbol: '🇬🇬',
        name: 'emoji-1674',
        keyword: 'flag-gg guernsey flag'
    },
    {
        symbol: '🇬🇭',
        name: 'emoji-1675',
        keyword: 'flag-gh ghana flag'
    },
    {
        symbol: '🇬🇮',
        name: 'emoji-1676',
        keyword: 'flag-gi gibraltar flag'
    },
    {
        symbol: '🇬🇱',
        name: 'emoji-1677',
        keyword: 'flag-gl greenland flag'
    },
    {
        symbol: '🇬🇲',
        name: 'emoji-1678',
        keyword: 'flag-gm gambia flag'
    },
    {
        symbol: '🇬🇳',
        name: 'emoji-1679',
        keyword: 'flag-gn guinea flag'
    },
    {
        symbol: '🇬🇵',
        name: 'emoji-1680',
        keyword: 'flag-gp guadeloupe flag'
    },
    {
        symbol: '🇬🇶',
        name: 'emoji-1681',
        keyword: 'flag-gq equatorial guinea flag'
    },
    {
        symbol: '🇬🇷',
        name: 'emoji-1682',
        keyword: 'flag-gr greece flag'
    },
    {
        symbol: '🇬🇸',
        name: 'emoji-1683',
        keyword: 'flag-gs south georgia & south sandwich islands flag'
    },
    {
        symbol: '🇬🇹',
        name: 'emoji-1684',
        keyword: 'flag-gt guatemala flag'
    },
    {
        symbol: '🇬🇺',
        name: 'emoji-1685',
        keyword: 'flag-gu guam flag'
    },
    {
        symbol: '🇬🇼',
        name: 'emoji-1686',
        keyword: 'flag-gw guinea-bissau flag'
    },
    {
        symbol: '🇬🇾',
        name: 'emoji-1687',
        keyword: 'flag-gy guyana flag'
    },
    {
        symbol: '🇭🇰',
        name: 'emoji-1688',
        keyword: 'flag-hk hong kong sar china flag'
    },
    {
        symbol: '🇭🇲',
        name: 'emoji-1689',
        keyword: 'flag-hm heard & mcdonald islands flag'
    },
    {
        symbol: '🇭🇳',
        name: 'emoji-1690',
        keyword: 'flag-hn honduras flag'
    },
    {
        symbol: '🇭🇷',
        name: 'emoji-1691',
        keyword: 'flag-hr croatia flag'
    },
    {
        symbol: '🇭🇹',
        name: 'emoji-1692',
        keyword: 'flag-ht haiti flag'
    },
    {
        symbol: '🇭🇺',
        name: 'emoji-1693',
        keyword: 'flag-hu hungary flag'
    },
    {
        symbol: '🇮🇨',
        name: 'emoji-1694',
        keyword: 'flag-ic canary islands flag'
    },
    {
        symbol: '🇮🇩',
        name: 'emoji-1695',
        keyword: 'flag-id indonesia flag'
    },
    {
        symbol: '🇮🇪',
        name: 'emoji-1696',
        keyword: 'flag-ie ireland flag'
    },
    {
        symbol: '🇮🇱',
        name: 'emoji-1697',
        keyword: 'flag-il israel flag'
    },
    {
        symbol: '🇮🇲',
        name: 'emoji-1698',
        keyword: 'flag-im isle of man flag'
    },
    {
        symbol: '🇮🇳',
        name: 'emoji-1699',
        keyword: 'flag-in india flag'
    },
    {
        symbol: '🇮🇴',
        name: 'emoji-1700',
        keyword: 'flag-io british indian ocean territory flag'
    },
    {
        symbol: '🇮🇶',
        name: 'emoji-1701',
        keyword: 'flag-iq iraq flag'
    },
    {
        symbol: '🇮🇷',
        name: 'emoji-1702',
        keyword: 'flag-ir iran flag'
    },
    {
        symbol: '🇮🇸',
        name: 'emoji-1703',
        keyword: 'flag-is iceland flag'
    },
    {
        symbol: '🇮🇹',
        name: 'emoji-1704',
        keyword: 'it flag-it italy flag'
    },
    {
        symbol: '🇯🇪',
        name: 'emoji-1705',
        keyword: 'flag-je jersey flag'
    },
    {
        symbol: '🇯🇲',
        name: 'emoji-1706',
        keyword: 'flag-jm jamaica flag'
    },
    {
        symbol: '🇯🇴',
        name: 'emoji-1707',
        keyword: 'flag-jo jordan flag'
    },
    {
        symbol: '🇯🇵',
        name: 'emoji-1708',
        keyword: 'jp flag-jp japan flag'
    },
    {
        symbol: '🇰🇪',
        name: 'emoji-1709',
        keyword: 'flag-ke kenya flag'
    },
    {
        symbol: '🇰🇬',
        name: 'emoji-1710',
        keyword: 'flag-kg kyrgyzstan flag'
    },
    {
        symbol: '🇰🇭',
        name: 'emoji-1711',
        keyword: 'flag-kh cambodia flag'
    },
    {
        symbol: '🇰🇮',
        name: 'emoji-1712',
        keyword: 'flag-ki kiribati flag'
    },
    {
        symbol: '🇰🇲',
        name: 'emoji-1713',
        keyword: 'flag-km comoros flag'
    },
    {
        symbol: '🇰🇳',
        name: 'emoji-1714',
        keyword: 'flag-kn st. kitts & nevis flag'
    },
    {
        symbol: '🇰🇵',
        name: 'emoji-1715',
        keyword: 'flag-kp north korea flag'
    },
    {
        symbol: '🇰🇷',
        name: 'emoji-1716',
        keyword: 'kr flag-kr south korea flag'
    },
    {
        symbol: '🇰🇼',
        name: 'emoji-1717',
        keyword: 'flag-kw kuwait flag'
    },
    {
        symbol: '🇰🇾',
        name: 'emoji-1718',
        keyword: 'flag-ky cayman islands flag'
    },
    {
        symbol: '🇰🇿',
        name: 'emoji-1719',
        keyword: 'flag-kz kazakhstan flag'
    },
    {
        symbol: '🇱🇦',
        name: 'emoji-1720',
        keyword: 'flag-la laos flag'
    },
    {
        symbol: '🇱🇧',
        name: 'emoji-1721',
        keyword: 'flag-lb lebanon flag'
    },
    {
        symbol: '🇱🇨',
        name: 'emoji-1722',
        keyword: 'flag-lc st. lucia flag'
    },
    {
        symbol: '🇱🇮',
        name: 'emoji-1723',
        keyword: 'flag-li liechtenstein flag'
    },
    {
        symbol: '🇱🇰',
        name: 'emoji-1724',
        keyword: 'flag-lk sri lanka flag'
    },
    {
        symbol: '🇱🇷',
        name: 'emoji-1725',
        keyword: 'flag-lr liberia flag'
    },
    {
        symbol: '🇱🇸',
        name: 'emoji-1726',
        keyword: 'flag-ls lesotho flag'
    },
    {
        symbol: '🇱🇹',
        name: 'emoji-1727',
        keyword: 'flag-lt lithuania flag'
    },
    {
        symbol: '🇱🇺',
        name: 'emoji-1728',
        keyword: 'flag-lu luxembourg flag'
    },
    {
        symbol: '🇱🇻',
        name: 'emoji-1729',
        keyword: 'flag-lv latvia flag'
    },
    {
        symbol: '🇱🇾',
        name: 'emoji-1730',
        keyword: 'flag-ly libya flag'
    },
    {
        symbol: '🇲🇦',
        name: 'emoji-1731',
        keyword: 'flag-ma morocco flag'
    },
    {
        symbol: '🇲🇨',
        name: 'emoji-1732',
        keyword: 'flag-mc monaco flag'
    },
    {
        symbol: '🇲🇩',
        name: 'emoji-1733',
        keyword: 'flag-md moldova flag'
    },
    {
        symbol: '🇲🇪',
        name: 'emoji-1734',
        keyword: 'flag-me montenegro flag'
    },
    {
        symbol: '🇲🇫',
        name: 'emoji-1735',
        keyword: 'flag-mf st. martin flag'
    },
    {
        symbol: '🇲🇬',
        name: 'emoji-1736',
        keyword: 'flag-mg madagascar flag'
    },
    {
        symbol: '🇲🇭',
        name: 'emoji-1737',
        keyword: 'flag-mh marshall islands flag'
    },
    {
        symbol: '🇲🇰',
        name: 'emoji-1738',
        keyword: 'flag-mk north macedonia flag'
    },
    {
        symbol: '🇲🇱',
        name: 'emoji-1739',
        keyword: 'flag-ml mali flag'
    },
    {
        symbol: '🇲🇲',
        name: 'emoji-1740',
        keyword: 'flag-mm myanmar (burma) flag'
    },
    {
        symbol: '🇲🇳',
        name: 'emoji-1741',
        keyword: 'flag-mn mongolia flag'
    },
    {
        symbol: '🇲🇴',
        name: 'emoji-1742',
        keyword: 'flag-mo macao sar china flag'
    },
    {
        symbol: '🇲🇵',
        name: 'emoji-1743',
        keyword: 'flag-mp northern mariana islands flag'
    },
    {
        symbol: '🇲🇶',
        name: 'emoji-1744',
        keyword: 'flag-mq martinique flag'
    },
    {
        symbol: '🇲🇷',
        name: 'emoji-1745',
        keyword: 'flag-mr mauritania flag'
    },
    {
        symbol: '🇲🇸',
        name: 'emoji-1746',
        keyword: 'flag-ms montserrat flag'
    },
    {
        symbol: '🇲🇹',
        name: 'emoji-1747',
        keyword: 'flag-mt malta flag'
    },
    {
        symbol: '🇲🇺',
        name: 'emoji-1748',
        keyword: 'flag-mu mauritius flag'
    },
    {
        symbol: '🇲🇻',
        name: 'emoji-1749',
        keyword: 'flag-mv maldives flag'
    },
    {
        symbol: '🇲🇼',
        name: 'emoji-1750',
        keyword: 'flag-mw malawi flag'
    },
    {
        symbol: '🇲🇽',
        name: 'emoji-1751',
        keyword: 'flag-mx mexico flag'
    },
    {
        symbol: '🇲🇾',
        name: 'emoji-1752',
        keyword: 'flag-my malaysia flag'
    },
    {
        symbol: '🇲🇿',
        name: 'emoji-1753',
        keyword: 'flag-mz mozambique flag'
    },
    {
        symbol: '🇳🇦',
        name: 'emoji-1754',
        keyword: 'flag-na namibia flag'
    },
    {
        symbol: '🇳🇨',
        name: 'emoji-1755',
        keyword: 'flag-nc new caledonia flag'
    },
    {
        symbol: '🇳🇪',
        name: 'emoji-1756',
        keyword: 'flag-ne niger flag'
    },
    {
        symbol: '🇳🇫',
        name: 'emoji-1757',
        keyword: 'flag-nf norfolk island flag'
    },
    {
        symbol: '🇳🇬',
        name: 'emoji-1758',
        keyword: 'flag-ng nigeria flag'
    },
    {
        symbol: '🇳🇮',
        name: 'emoji-1759',
        keyword: 'flag-ni nicaragua flag'
    },
    {
        symbol: '🇳🇱',
        name: 'emoji-1760',
        keyword: 'flag-nl netherlands flag'
    },
    {
        symbol: '🇳🇴',
        name: 'emoji-1761',
        keyword: 'flag-no norway flag'
    },
    {
        symbol: '🇳🇵',
        name: 'emoji-1762',
        keyword: 'flag-np nepal flag'
    },
    {
        symbol: '🇳🇷',
        name: 'emoji-1763',
        keyword: 'flag-nr nauru flag'
    },
    {
        symbol: '🇳🇺',
        name: 'emoji-1764',
        keyword: 'flag-nu niue flag'
    },
    {
        symbol: '🇳🇿',
        name: 'emoji-1765',
        keyword: 'flag-nz new zealand flag'
    },
    {
        symbol: '🇴🇲',
        name: 'emoji-1766',
        keyword: 'flag-om oman flag'
    },
    {
        symbol: '🇵🇦',
        name: 'emoji-1767',
        keyword: 'flag-pa panama flag'
    },
    {
        symbol: '🇵🇪',
        name: 'emoji-1768',
        keyword: 'flag-pe peru flag'
    },
    {
        symbol: '🇵🇫',
        name: 'emoji-1769',
        keyword: 'flag-pf french polynesia flag'
    },
    {
        symbol: '🇵🇬',
        name: 'emoji-1770',
        keyword: 'flag-pg papua new guinea flag'
    },
    {
        symbol: '🇵🇭',
        name: 'emoji-1771',
        keyword: 'flag-ph philippines flag'
    },
    {
        symbol: '🇵🇰',
        name: 'emoji-1772',
        keyword: 'flag-pk pakistan flag'
    },
    {
        symbol: '🇵🇱',
        name: 'emoji-1773',
        keyword: 'flag-pl poland flag'
    },
    {
        symbol: '🇵🇲',
        name: 'emoji-1774',
        keyword: 'flag-pm st. pierre & miquelon flag'
    },
    {
        symbol: '🇵🇳',
        name: 'emoji-1775',
        keyword: 'flag-pn pitcairn islands flag'
    },
    {
        symbol: '🇵🇷',
        name: 'emoji-1776',
        keyword: 'flag-pr puerto rico flag'
    },
    {
        symbol: '🇵🇸',
        name: 'emoji-1777',
        keyword: 'flag-ps palestinian territories flag'
    },
    {
        symbol: '🇵🇹',
        name: 'emoji-1778',
        keyword: 'flag-pt portugal flag'
    },
    {
        symbol: '🇵🇼',
        name: 'emoji-1779',
        keyword: 'flag-pw palau flag'
    },
    {
        symbol: '🇵🇾',
        name: 'emoji-1780',
        keyword: 'flag-py paraguay flag'
    },
    {
        symbol: '🇶🇦',
        name: 'emoji-1781',
        keyword: 'flag-qa qatar flag'
    },
    {
        symbol: '🇷🇪',
        name: 'emoji-1782',
        keyword: 'flag-re réunion flag'
    },
    {
        symbol: '🇷🇴',
        name: 'emoji-1783',
        keyword: 'flag-ro romania flag'
    },
    {
        symbol: '🇷🇸',
        name: 'emoji-1784',
        keyword: 'flag-rs serbia flag'
    },
    {
        symbol: '🇷🇺',
        name: 'emoji-1785',
        keyword: 'ru flag-ru russia flag'
    },
    {
        symbol: '🇷🇼',
        name: 'emoji-1786',
        keyword: 'flag-rw rwanda flag'
    },
    {
        symbol: '🇸🇦',
        name: 'emoji-1787',
        keyword: 'flag-sa saudi arabia flag'
    },
    {
        symbol: '🇸🇧',
        name: 'emoji-1788',
        keyword: 'flag-sb solomon islands flag'
    },
    {
        symbol: '🇸🇨',
        name: 'emoji-1789',
        keyword: 'flag-sc seychelles flag'
    },
    {
        symbol: '🇸🇩',
        name: 'emoji-1790',
        keyword: 'flag-sd sudan flag'
    },
    {
        symbol: '🇸🇪',
        name: 'emoji-1791',
        keyword: 'flag-se sweden flag'
    },
    {
        symbol: '🇸🇬',
        name: 'emoji-1792',
        keyword: 'flag-sg singapore flag'
    },
    {
        symbol: '🇸🇭',
        name: 'emoji-1793',
        keyword: 'flag-sh st. helena flag'
    },
    {
        symbol: '🇸🇮',
        name: 'emoji-1794',
        keyword: 'flag-si slovenia flag'
    },
    {
        symbol: '🇸🇯',
        name: 'emoji-1795',
        keyword: 'flag-sj svalbard & jan mayen flag'
    },
    {
        symbol: '🇸🇰',
        name: 'emoji-1796',
        keyword: 'flag-sk slovakia flag'
    },
    {
        symbol: '🇸🇱',
        name: 'emoji-1797',
        keyword: 'flag-sl sierra leone flag'
    },
    {
        symbol: '🇸🇲',
        name: 'emoji-1798',
        keyword: 'flag-sm san marino flag'
    },
    {
        symbol: '🇸🇳',
        name: 'emoji-1799',
        keyword: 'flag-sn senegal flag'
    },
    {
        symbol: '🇸🇴',
        name: 'emoji-1800',
        keyword: 'flag-so somalia flag'
    },
    {
        symbol: '🇸🇷',
        name: 'emoji-1801',
        keyword: 'flag-sr suriname flag'
    },
    {
        symbol: '🇸🇸',
        name: 'emoji-1802',
        keyword: 'flag-ss south sudan flag'
    },
    {
        symbol: '🇸🇹',
        name: 'emoji-1803',
        keyword: 'flag-st são tomé & príncipe flag'
    },
    {
        symbol: '🇸🇻',
        name: 'emoji-1804',
        keyword: 'flag-sv el salvador flag'
    },
    {
        symbol: '🇸🇽',
        name: 'emoji-1805',
        keyword: 'flag-sx sint maarten flag'
    },
    {
        symbol: '🇸🇾',
        name: 'emoji-1806',
        keyword: 'flag-sy syria flag'
    },
    {
        symbol: '🇸🇿',
        name: 'emoji-1807',
        keyword: 'flag-sz eswatini flag'
    },
    {
        symbol: '🇹🇦',
        name: 'emoji-1808',
        keyword: 'flag-ta tristan da cunha flag'
    },
    {
        symbol: '🇹🇨',
        name: 'emoji-1809',
        keyword: 'flag-tc turks & caicos islands flag'
    },
    {
        symbol: '🇹🇩',
        name: 'emoji-1810',
        keyword: 'flag-td chad flag'
    },
    {
        symbol: '🇹🇫',
        name: 'emoji-1811',
        keyword: 'flag-tf french southern territories flag'
    },
    {
        symbol: '🇹🇬',
        name: 'emoji-1812',
        keyword: 'flag-tg togo flag'
    },
    {
        symbol: '🇹🇭',
        name: 'emoji-1813',
        keyword: 'flag-th thailand flag'
    },
    {
        symbol: '🇹🇯',
        name: 'emoji-1814',
        keyword: 'flag-tj tajikistan flag'
    },
    {
        symbol: '🇹🇰',
        name: 'emoji-1815',
        keyword: 'flag-tk tokelau flag'
    },
    {
        symbol: '🇹🇱',
        name: 'emoji-1816',
        keyword: 'flag-tl timor-leste flag'
    },
    {
        symbol: '🇹🇲',
        name: 'emoji-1817',
        keyword: 'flag-tm turkmenistan flag'
    },
    {
        symbol: '🇹🇳',
        name: 'emoji-1818',
        keyword: 'flag-tn tunisia flag'
    },
    {
        symbol: '🇹🇴',
        name: 'emoji-1819',
        keyword: 'flag-to tonga flag'
    },
    {
        symbol: '🇹🇷',
        name: 'emoji-1820',
        keyword: 'flag-tr turkey flag'
    },
    {
        symbol: '🇹🇹',
        name: 'emoji-1821',
        keyword: 'flag-tt trinidad & tobago flag'
    },
    {
        symbol: '🇹🇻',
        name: 'emoji-1822',
        keyword: 'flag-tv tuvalu flag'
    },
    {
        symbol: '🇹🇼',
        name: 'emoji-1823',
        keyword: 'flag-tw taiwan flag'
    },
    {
        symbol: '🇹🇿',
        name: 'emoji-1824',
        keyword: 'flag-tz tanzania flag'
    },
    {
        symbol: '🇺🇦',
        name: 'emoji-1825',
        keyword: 'flag-ua ukraine flag'
    },
    {
        symbol: '🇺🇬',
        name: 'emoji-1826',
        keyword: 'flag-ug uganda flag'
    },
    {
        symbol: '🇺🇲',
        name: 'emoji-1827',
        keyword: 'flag-um u.s. outlying islands flag'
    },
    {
        symbol: '🇺🇳',
        name: 'emoji-1828',
        keyword: 'flag-un united nations flag'
    },
    {
        symbol: '🇺🇸',
        name: 'emoji-1829',
        keyword: 'us flag-us united states flag'
    },
    {
        symbol: '🇺🇾',
        name: 'emoji-1830',
        keyword: 'flag-uy uruguay flag'
    },
    {
        symbol: '🇺🇿',
        name: 'emoji-1831',
        keyword: 'flag-uz uzbekistan flag'
    },
    {
        symbol: '🇻🇦',
        name: 'emoji-1832',
        keyword: 'flag-va vatican city flag'
    },
    {
        symbol: '🇻🇨',
        name: 'emoji-1833',
        keyword: 'flag-vc st. vincent & grenadines flag'
    },
    {
        symbol: '🇻🇪',
        name: 'emoji-1834',
        keyword: 'flag-ve venezuela flag'
    },
    {
        symbol: '🇻🇬',
        name: 'emoji-1835',
        keyword: 'flag-vg british virgin islands flag'
    },
    {
        symbol: '🇻🇮',
        name: 'emoji-1836',
        keyword: 'flag-vi u.s. virgin islands flag'
    },
    {
        symbol: '🇻🇳',
        name: 'emoji-1837',
        keyword: 'flag-vn vietnam flag'
    },
    {
        symbol: '🇻🇺',
        name: 'emoji-1838',
        keyword: 'flag-vu vanuatu flag'
    },
    {
        symbol: '🇼🇫',
        name: 'emoji-1839',
        keyword: 'flag-wf wallis & futuna flag'
    },
    {
        symbol: '🇼🇸',
        name: 'emoji-1840',
        keyword: 'flag-ws samoa flag'
    },
    {
        symbol: '🇽🇰',
        name: 'emoji-1841',
        keyword: 'flag-xk kosovo flag'
    },
    {
        symbol: '🇾🇪',
        name: 'emoji-1842',
        keyword: 'flag-ye yemen flag'
    },
    {
        symbol: '🇾🇹',
        name: 'emoji-1843',
        keyword: 'flag-yt mayotte flag'
    },
    {
        symbol: '🇿🇦',
        name: 'emoji-1844',
        keyword: 'flag-za south africa flag'
    },
    {
        symbol: '🇿🇲',
        name: 'emoji-1845',
        keyword: 'flag-zm zambia flag'
    },
    {
        symbol: '🇿🇼',
        name: 'emoji-1846',
        keyword: 'flag-zw zimbabwe flag'
    },
    {
        symbol: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
        name: 'emoji-1847',
        keyword: 'england flag flag-england'
    },
    {
        symbol: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
        name: 'emoji-1848',
        keyword: 'scotland flag flag-scotland'
    },
    {
        symbol: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
        name: 'emoji-1849',
        keyword: 'wales flag flag-wales'
    }
]
